// Path: assets/ps-pdp.js
//
// Hybrid Dynamic PDP: minimal PDP controller
// - Year gate (reads PS.ssr().years), writes properties[Year] and ps_cc.year
// - Multi-add Clearcoat toggle
// - Native cart add with sections refresh and notification open
// - Ensures hidden props for Make/Color/Code/Year and _ps_* slugs
//
// Removed: client API calls, path parsing for product type, DOM painting, image swaps, ps:color:* events

(function(window, document){
  'use strict';

  var PS = window.PS || (window.PS = {});

  // Guard: bounce direct hits to base paint products to the color entry page.
  // Matches: /products/pen, /products/pen-tricoat, /products/bottle(-tricoat), /products/spray(-tricoat), /products/pro(-tricoat)
  try {
        var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
    if (!isDesignMode) {
    var path = window.location && window.location.pathname || '';
    if (/^\/products\/(pen|bottle|spray|pro)(-tricoat)?\/?$/i.test(path)) {
      window.location.replace('/');
      return;
    }
  }
  } catch (_e) {}

  var CONFIG = {
    cartSections: ['cart-notification-product','cart-notification-button','cart-icon-bubble'],
    minYear: 1980
  };

  var FACTORY_PROP_KEY = 'Factory Code';

  // ------------------------ Utils ------------------------
  function getCustomColorFunnelEntry(){
    var stored = '';
    var entry;

    try {
      if (window.paintscratchCustomColorFunnel
          && typeof window.paintscratchCustomColorFunnel.getEntry === 'function') {
        entry = window.paintscratchCustomColorFunnel.getEntry();
        if (entry && entry.entry_channel && entry.landing_group) return entry;
      }
    } catch (_eGlobalEntry) {}

    try {
      stored = window.sessionStorage.getItem('ps_custom_color_funnel_entry') || '';
      if (stored) {
        entry = JSON.parse(stored);
        if (entry && entry.entry_channel && entry.landing_group) return entry;
      }
    } catch (_eReadEntry) {}

    return { entry_channel: 'unknown', landing_group: 'other' };
  }

  function getCustomColorFunnelEnvironment(){
    var ua = '';
    var match = null;
    var deviceCategory = 'desktop';
    var browser = 'Other';
    var browserVersion = '';
    var operatingSystem = 'Other';

    try { ua = String(window.navigator && window.navigator.userAgent || ''); } catch (_eUserAgent) {}
    if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) deviceCategory = 'tablet';
    else if (/Mobi|Android|iPhone|iPod/i.test(ua)) deviceCategory = 'mobile';

    if (/Windows NT/i.test(ua)) operatingSystem = 'Windows';
    else if (/Android/i.test(ua)) operatingSystem = 'Android';
    else if (/iPhone|iPad|iPod/i.test(ua)) operatingSystem = 'iOS';
    else if (/Mac OS X/i.test(ua)) operatingSystem = 'macOS';
    else if (/CrOS/i.test(ua)) operatingSystem = 'Chrome OS';
    else if (/Linux/i.test(ua)) operatingSystem = 'Linux';

    match = ua.match(/EdgA?\/([0-9.]+)/i);
    if (match) {
      browser = 'Edge';
      browserVersion = match[1];
    } else {
      match = ua.match(/SamsungBrowser\/([0-9.]+)/i);
      if (match) {
        browser = 'Samsung Internet';
        browserVersion = match[1];
      } else {
        match = ua.match(/(?:Firefox|FxiOS)\/([0-9.]+)/i);
        if (match) {
          browser = 'Firefox';
          browserVersion = match[1];
        } else {
          match = ua.match(/(?:Chrome|CriOS)\/([0-9.]+)/i);
          if (match) {
            browser = 'Chrome';
            browserVersion = match[1];
          } else {
            match = ua.match(/Version\/([0-9.]+).*Safari/i);
            if (match) {
              browser = 'Safari';
              browserVersion = match[1];
            }
          }
        }
      }
    }

    return {
      device_category: deviceCategory,
      browser: browser,
      browser_version: browserVersion,
      operating_system: operatingSystem
    };
  }

  function trackCustomColorFunnel(step, details){
    try {
      var entry = getCustomColorFunnelEntry();
      var environment = getCustomColorFunnelEnvironment();
      var eventData = {
        step: String(step || ''),
        product_type: '',
        formula_choice: '',
        outcome: '',
        entry_channel: entry.entry_channel || 'unknown',
        landing_group: entry.landing_group || 'other',
        device_category: environment.device_category,
        browser: environment.browser,
        browser_version: environment.browser_version,
        operating_system: environment.operating_system,
        modal_required_fields: '',
        modal_block_reason: ''
      };
      var elapsedFromOpen;
      var elapsedFromPrevious;
      var previousStep;
      var timedModalStep;
      var trace;

      if (!eventData.step) return;
      if (window.PS && window.PS.Search) {
        var searchSessionId = window.PS.Search.sessionId();
        if (searchSessionId) eventData.search_session_id = searchSessionId;
      }
      if (details) {
        eventData.product_type = String(details.product_type || '');
        eventData.formula_choice = String(details.formula_choice || '');
        eventData.outcome = String(details.outcome || '');
        eventData.modal_required_fields = String(details.modal_required_fields || '');
        eventData.modal_block_reason = String(details.modal_block_reason || '');
        timedModalStep = normalizeVehicleModalFunnelStep(eventData.step);
        if (timedModalStep && timedModalStep !== 'vehicle_modal_open') {
          elapsedFromOpen = parseInt(details.elapsed_ms_from_modal_open, 10);
          elapsedFromPrevious = parseInt(details.elapsed_ms_from_previous_step, 10);
          previousStep = normalizeVehicleModalFunnelStep(details.previous_step);
          if (!isNaN(elapsedFromOpen) && elapsedFromOpen >= 0) eventData.elapsed_ms_from_modal_open = elapsedFromOpen;
          if (!isNaN(elapsedFromPrevious) && elapsedFromPrevious >= 0) eventData.elapsed_ms_from_previous_step = elapsedFromPrevious;
          if (previousStep) eventData.previous_step = previousStep;
        }
      }

      try {
        trace = JSON.parse(window.sessionStorage.getItem('ps_custom_color_funnel_trace') || '[]');
        if (!trace || typeof trace.push !== 'function') trace = [];
        trace.push(eventData);
        if (trace.length > 50) trace = trace.slice(trace.length - 50);
        window.sessionStorage.setItem('ps_custom_color_funnel_trace', JSON.stringify(trace));
      } catch (_eTrace) {}

      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('paintscratch:custom_color_funnel', eventData);
        }
      } catch (_ePublish) {}
    } catch (_eTracking) {}
  }

  function normalizeVehicleModalFunnelStep(step){
    var allowed = {
      vehicle_modal_open: true,
      vehicle_year_select_open: true,
      vehicle_year_selected: true,
      vehicle_model_load_requested: true,
      vehicle_model_load_succeeded: true,
      vehicle_model_load_failed: true,
      vehicle_model_empty: true,
      vehicle_model_selected: true,
      vehicle_factory_code_shown: true,
      vehicle_factory_code_selected: true,
      vehicle_continue_clicked: true,
      vehicle_continue_blocked: true,
      vehicle_modal_closed: true,
      vehicle_modal_continue: true
    };
    var normalized = String(step || '');
    return allowed[normalized] ? normalized : '';
  }

  function readVehicleModalFunnelClock(clockType){
    var value = null;
    try {
      if (clockType === 'performance' && window.performance && typeof window.performance.now === 'function') {
        value = window.performance.now();
      } else if (clockType === 'date') {
        value = new Date().getTime();
      }
    } catch (_eClock) {
      value = null;
    }
    return typeof value === 'number' && isFinite(value) ? value : null;
  }

  function chooseVehicleModalFunnelClock(){
    var performanceValue = readVehicleModalFunnelClock('performance');
    if (performanceValue !== null) return { type: 'performance', value: performanceValue };
    return { type: 'date', value: readVehicleModalFunnelClock('date') };
  }

  function endVehicleModalFunnel(controller){
    var state = controller && controller._vehicleModalFunnelState;
    if (!state) return;
    if (state.visibility_handler && typeof document !== 'undefined' && document.removeEventListener) {
      document.removeEventListener('visibilitychange', state.visibility_handler, false);
    }
    state.active = false;
    if (controller._vehicleModalFunnelState === state) controller._vehicleModalFunnelState = null;
  }

  function beginVehicleModalFunnel(controller, attempt, details){
    var clock;
    var state;
    if (!attempt || attempt.opened) return controller && controller._vehicleModalFunnelState;
    attempt.opened = true;
    endVehicleModalFunnel(controller);
    clock = chooseVehicleModalFunnelClock();
    state = {
      active: true,
      clock_type: clock.type,
      opened_at: clock.value,
      last_clock_at: clock.value,
      previous_step_at: clock.value,
      previous_step: 'vehicle_modal_open',
      timing_valid: clock.value !== null,
      visibility_handler: null
    };
    if (typeof document !== 'undefined') {
      if (document.hidden) state.timing_valid = false;
      if (document.addEventListener) {
        state.visibility_handler = function(){
          if (document.hidden) state.timing_valid = false;
        };
        document.addEventListener('visibilitychange', state.visibility_handler, false);
      }
    }
    if (controller) controller._vehicleModalFunnelState = state;
    trackCustomColorFunnel('vehicle_modal_open', details || {});
    return state;
  }

  function trackVehicleModalFunnel(controller, step, details){
    var key;
    var now = null;
    var state = controller && controller._vehicleModalFunnelState;
    var payload = {};
    var normalizedStep = normalizeVehicleModalFunnelStep(step);
    if (details) {
      for (key in details) {
        if (Object.prototype.hasOwnProperty.call(details, key)) payload[key] = details[key];
      }
    }
    if (state && state.active) {
      payload.previous_step = state.previous_step;
      if (state.timing_valid) {
        now = readVehicleModalFunnelClock(state.clock_type);
        if (now === null) {
          state.timing_valid = false;
        } else {
          if (now < state.last_clock_at) now = state.last_clock_at;
          state.last_clock_at = now;
          payload.elapsed_ms_from_modal_open = Math.max(0, Math.round(now - state.opened_at));
          payload.elapsed_ms_from_previous_step = Math.max(0, Math.round(now - state.previous_step_at));
        }
      }
    }
    trackCustomColorFunnel(step, payload);
    if (state && state.active && normalizedStep) {
      state.previous_step = normalizedStep;
      if (state.timing_valid && now !== null) state.previous_step_at = now;
    }
  }

  function funnelProductTypeFromItems(items){
    var raw = '';
    var match;
    try {
      if (items && items.length && items[0] && items[0].properties) {
        raw = String(items[0].properties._ps_product_slug || items[0].properties.ps_product_slug || '').toLowerCase();
      }
      match = raw.match(/(?:^|kit-)(pen|bottle|spray|pro)(?:-|$)/);
      return match && match[1] ? match[1] : '';
    } catch (_eProductType) {
      return '';
    }
  }

  function staticYearOptions(){
    var out = [], cur = new Date().getFullYear();
    for (var y = cur; y >= CONFIG.minYear; y--) out.push(String(y));
    return out;
  }

  function sanitizeYears(list){
    if (!list || !list.length) return [];
    var map = {}, out = [];
    for (var i=0;i<list.length;i++){
      var s = String(list[i] == null ? '' : list[i]).replace(/\D/g,'');
      if (s && !map[s]) { map[s]=1; out.push(s); }
    }
    out.sort(function(a,b){ return parseInt(b,10) - parseInt(a,10); });
    return out;
  }

  function sanitizeFactoryCodes(list){
    if (!list || !list.length) return [];
    var map = {}, out = [];
    for (var i=0;i<list.length;i++){
      var s = String(list[i] == null ? '' : list[i]).trim();
      if (!s) continue;
      var key = s.toLowerCase();
      if (!map[key]) {
        map[key] = 1;
        out.push(s);
      }
    }
    return out;
  }

  function sanitizeModels(list){
    if (!list || !list.length) return [];
    var map = {}, out = [];
    for (var i=0;i<list.length;i++){
      var s = String(list[i] == null ? '' : list[i]).replace(/^\s+|\s+$/g, '');
      var key = s.toLowerCase();
      if (!s || map[key]) continue;
      map[key] = 1;
      out.push(s);
    }
    return out;
  }

  function isAllModelsValue(value){
    return sanitizeModelKey(value) === 'all models';
  }

  function onlyAllModelsValue(list){
    var models = sanitizeModels(list || []);
    if (models.length !== 1) return '';
    return isAllModelsValue(models[0]) ? models[0] : '';
  }

  function escapeHtml(val){
    return String(val == null ? '' : val)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeModalContextText(val){
    return String(val == null ? '' : val).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function resolveModalContextImageUrl(img){
    var src = '';
    if (!img) return '';
    src = String(img.getAttribute('data-src') || img.getAttribute('src') || '');
    if (img.currentSrc) src = String(img.currentSrc || src || '');
    if (!src || src.indexOf('data:') === 0) return '';
    return src;
  }

  function readModalContextImage(img){
    var src = resolveModalContextImageUrl(img);
    var width = 0;
    var height = 0;
    if (!src) return null;
    width = parseInt(img.getAttribute('width'), 10) || img.naturalWidth || img.width || 0;
    height = parseInt(img.getAttribute('height'), 10) || img.naturalHeight || img.height || 0;
    return {
      src: src,
      alt: String(img.getAttribute('alt') || ''),
      width: width,
      height: height
    };
  }

  function normalizeModalContextUrl(val){
    var src = String(val == null ? '' : val);
    var a = null;
    if (!src) return '';
    if (src.indexOf('//') === 0) return window.location.protocol + src;
    if (src.indexOf('/') === 0) return window.location.origin + src;
    if (/^https?:\/\//i.test(src)) return src;
    try {
      a = document.createElement('a');
      a.href = src;
      return String(a.href || src);
    } catch (_e) {}
    return src;
  }

  function readModalContextFromKitSelection(startNode){
    var node = startNode;
    var guard = 0;
    var input = null;
    var row = null;
    var thumb = null;
    var container = null;
    var src = '';
    var name = '';
    var image = null;
    while (node && node !== document && guard++ < 12) {
      if (node.querySelector) {
        input = node.querySelector('.ps-kit-options-container .ps-kit-input:checked');
        if (input) break;
      }
      node = node.parentNode;
    }
    if (!input) return null;
    row = input.closest ? input.closest('.ps-kit-row') : null;
    container = input.closest ? input.closest('.ps-kit-options-container') : null;
    src = normalizeModalContextUrl(input.getAttribute('data-img') || '');
    name = normalizeModalContextText(input.getAttribute('data-ps-kit-name') || '');
    if (!name && row && row.querySelector) {
      name = normalizeModalContextText((row.querySelector('.ps-kit-title') || {}).textContent || '');
    }
    if (!name && container) {
      name = normalizeModalContextText(container.getAttribute('data-ps-base-product-type') || '');
    }
    if (!src && row && row.querySelector) {
      thumb = row.querySelector('.ps-kit-thumb img');
      image = readModalContextImage(thumb);
      if (image && image.src) {
        image.name = name;
        if (!image.alt) image.alt = name;
        return image;
      }
    }
    if (!src) return null;
    thumb = row && row.querySelector ? row.querySelector('.ps-kit-thumb img') : null;
    return {
      src: src,
      alt: (thumb && thumb.getAttribute && thumb.getAttribute('alt')) ? String(thumb.getAttribute('alt')) : name,
      width: thumb ? (parseInt(thumb.getAttribute('width'), 10) || thumb.naturalWidth || thumb.width || 0) : 0,
      height: thumb ? (parseInt(thumb.getAttribute('height'), 10) || thumb.naturalHeight || thumb.height || 0) : 0,
      name: name
    };
  }

  function readModalContextNameFromNode(startNode){
    var node = startNode;
    var guard = 0;
    var text = '';
    while (node && node !== document && guard++ < 12) {
      if (node.getAttribute) {
        text = normalizeModalContextText(node.getAttribute('data-ps-product-type') || '');
        if (text) return text;
      }
      node = node.parentNode;
    }
    return '';
  }

  function modalContextNameFromSlug(rawSlug){
    var raw = String(rawSlug == null ? '' : rawSlug).toLowerCase();
    var base = '';
    var label = '';
    var isKit = false;
    if (!raw) return '';
    isKit = /(^|-)kit(-|$)/.test(raw);
    base = baseSlugFromValue(raw);
    if (!base && raw.indexOf('pen') > -1) base = 'pen';
    if (!base && raw.indexOf('bottle') > -1) base = 'bottle';
    if (!base && raw.indexOf('spray') > -1) base = 'spray';
    if (!base && raw.indexOf('pro') > -1) base = 'pro';
    if (base === 'pen') label = 'Paint Pen';
    else if (base === 'bottle') label = 'Bottle';
    else if (base === 'spray') label = 'Spray Can';
    else if (base === 'pro') label = 'Paint Only';
    if (!label) return '';
    return isKit ? (label + ' Kit') : label;
  }

  function readModalContextNameFromPathname(pathname){
    var path = String(pathname == null ? '' : pathname);
    var match = path.match(/\/products\/([^\/?#]+)/i);
    if (!match) match = path.match(/\/colors\/[^\/]+\/[^\/]+\/([^\/?#]+)/i);
    if (!match || !match[1]) return '';
    return modalContextNameFromSlug(match[1]);
  }

  function readModalContextNameFromDocument(){
    var checked = document.querySelector('.ps-kit-input:checked');
    var row = null;
    var node = null;
    var text = '';
    if (checked) {
      text = normalizeModalContextText(checked.getAttribute('data-ps-kit-name') || '');
      if (text) return text;
      row = checked.closest ? checked.closest('.ps-kit-row') : null;
      if (row && row.querySelector) {
        text = normalizeModalContextText((row.querySelector('.ps-kit-title') || {}).textContent || '');
        if (text) return text;
      }
    }
    node = document.querySelector('.ps-kit-row.is-selected .ps-kit-title, .product__title h1, .product-single__title, h1');
    text = normalizeModalContextText(node ? node.textContent : '');
    return text;
  }

  function normalizeVariantModalContextText(val){
    return normalizeModalContextText(String(val == null ? '' : val).replace(/Variant sold out or unavailable/gi, ''));
  }

  function readModalContextVariantNameFromNode(startNode){
    var node = startNode;
    var guard = 0;
    var checked = null;
    var label = null;
    var next = null;
    var selectedOption = null;
    var text = '';
    while (node && node !== document && guard++ < 12) {
      if (node.querySelector) {
        checked = node.querySelector('variant-selects input[type="radio"]:checked');
        if (checked) {
          label = null;
          next = checked.nextSibling;
          while (next) {
            if (next.tagName && String(next.tagName).toLowerCase() === 'label') {
              label = next;
              break;
            }
            next = next.nextSibling;
          }
          if (!label && checked.id) {
            label = node.querySelector('label[for="' + checked.id.replace(/"/g, '\\"') + '"]');
          }
          text = normalizeVariantModalContextText(label ? label.textContent : checked.value);
          if (text) return text;
        }
        selectedOption = node.querySelector('variant-selects select option:checked');
        if (selectedOption) {
          text = normalizeVariantModalContextText(selectedOption.textContent || selectedOption.value);
          if (text) return text;
        }
      }
      node = node.parentNode;
    }
    return '';
  }

  function findModalContextImageFromNode(startNode){
    var node = startNode;
    var selectors = [
      '.quick-add__product-media img',
      '.card__media img',
      '.product__media img',
      '.product-media-modal__content img',
      '.product__media-toggle img',
      'img'
    ];
    var guard = 0;
    var i = 0;
    var images = null;
    var image = null;
    while (node && node !== document && guard++ < 12) {
      if (node.querySelectorAll) {
        for (i = 0; i < selectors.length; i++) {
          images = node.querySelectorAll(selectors[i]);
          if (!images || !images.length) continue;
          image = readModalContextImage(images[0]);
          if (image) return image;
        }
      }
      node = node.parentNode;
    }
    return null;
  }

  function mergePayload(base, extra){
    var out = {};
    var key = '';
    var src = null;
    var sources = [base, extra];
    var i = 0;
    for (i = 0; i < sources.length; i++) {
      src = sources[i];
      if (!src || typeof src !== 'object') continue;
      for (key in src) {
        if (!src.hasOwnProperty(key)) continue;
        if (typeof src[key] === 'undefined') continue;
        out[key] = src[key];
      }
    }
    return out;
  }

  function apiBase(){
    try {
      if (window.PS && PS.u && typeof PS.u.apiBase === 'function') return PS.u.apiBase();
      if (window.paintscratchTheme && window.paintscratchTheme.psUrl) {
        return String(window.paintscratchTheme.psUrl).replace(/\/+$/, '') + '/api/';
      }
    } catch (_e) {}
    return '';
  }

  function sanitizeModelKey(val){
    return String(val == null ? '' : val)
      .replace(/\s+/g, ' ')
      .replace(/^\s+|\s+$/g, '')
      .toLowerCase();
  }

  function resolveVehicleModelFromOptions(rawModel, modelOptions){
    var value = trimPropValue(rawModel);
    var key = sanitizeModelKey(value);
    var optionsList = modelOptions || [];
    var idx = 0;
    var optionValue = '';
    if (!value) return '';
    for (idx = 0; idx < optionsList.length; idx++) {
      optionValue = trimPropValue(optionsList[idx]);
      if (optionValue && optionValue === value) return optionValue;
    }
    for (idx = 0; idx < optionsList.length; idx++) {
      optionValue = trimPropValue(optionsList[idx]);
      if (optionValue && sanitizeModelKey(optionValue) === key) return optionValue;
    }
    return '';
  }

  function classifyVehicleModelResponse(data){
    if (Object.prototype.toString.call(data) === '[object Array]') {
      return { ok: true, models: data };
    }
    if (data && Object.prototype.toString.call(data.models) === '[object Array]') {
      return { ok: true, models: data.models };
    }
    return { ok: false, models: [] };
  }

  function requestVehicleModelList(url, done){
    var cb = typeof done === 'function' ? done : function(){};
    var xhr = null;
    var data = null;
    var parsed = null;
    var completed = false;
    function finish(err, models){
      if (completed) return;
      completed = true;
      cb(err, models || []);
    }
    if (!url) {
      finish(null, []);
      return;
    }
    xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.timeout = 4000;
    xhr.onreadystatechange = function(){
      if (xhr.readyState !== 4) return;
      if (!(xhr.status >= 200 && xhr.status < 300)) {
        finish('Unable to load models', []);
        return;
      }
      try { data = JSON.parse(xhr.responseText || '[]'); } catch (_e) {
        finish('Unable to load models', []);
        return;
      }
      parsed = classifyVehicleModelResponse(data);
      if (!parsed.ok) {
        finish('Unable to load models', []);
        return;
      }
      finish(null, sanitizeModels(parsed.models));
    };
    xhr.onerror = function(){ finish('Unable to load models', []); };
    xhr.ontimeout = function(){ finish('Unable to load models', []); };
    xhr.send(null);
  }

  function beginVehicleModalSession(controller){
    var next = 1;
    if (!controller) return next;
    next = (parseInt(String(controller._vehicleModalSession || 0), 10) || 0) + 1;
    controller._vehicleModalSession = next;
    return next;
  }

  function invalidateVehicleModalSession(controller, session){
    if (!controller || controller._vehicleModalSession !== session) return;
    controller._vehicleModalSession = session + 1;
  }

  function isVehicleModalSessionCurrent(controller, session, root){
    if (!controller || controller._vehicleModalSession !== session) return false;
    if (!root || !root.getAttribute) return false;
    return root.getAttribute('aria-hidden') === 'false';
  }

  function shouldApplyVehicleModelResponse(controller, session, root, currentRequestId, localRequestId){
    return isVehicleModalSessionCurrent(controller, session, root) && currentRequestId === localRequestId;
  }

  function resolveVehicleCheckoutStep(state){
    var value = state || {};
    if (value.isCustom === false) return 'cart';
    if (!value.yearValid) return 'vehicle';
    if (value.modelRequired && !value.modelValid) return 'vehicle';
    if (value.factoryRequired && !value.factoryValid) return 'factory';
    if (value.formulaRequired) return 'formula';
    return 'cart';
  }

  function resolveVehicleModalAction(state){
    var value = state || {};
    var nextStep = resolveVehicleCheckoutStep(value);
    if ((value.factoryRequired && !value.factoryValid) || nextStep === 'factory' || nextStep === 'formula') {
      return { label: 'Continue', ariaLabel: 'Continue to the next required vehicle step' };
    }
    return { label: 'Add to Cart', ariaLabel: 'Add selected paint product to cart' };
  }

  function resolveSavedVehicleModelOutcome(rawModel, modelOptions, err){
    var options = sanitizeModels(modelOptions || []);
    var resolved = '';
    if (err) return { step: 'vehicle', model: '' };
    if (!options.length) return { step: 'optional', model: '' };
    resolved = resolveVehicleModelFromOptions(rawModel, options);
    if (resolved) return { step: 'valid', model: resolved };
    return { step: 'vehicle', model: '' };
  }

  function resolveTrustedScopedVehicleModelOutcome(cc, ssr, year, modelOptions, err){
    if (!canUseVehicleScope(cc, ssr) || trimPropValue(cc && cc.year) !== trimPropValue(year)) {
      return { step: 'vehicle', model: '' };
    }
    return resolveSavedVehicleModelOutcome('', modelOptions || [], err);
  }

  function resolveAllowedFactoryCode(rawCode, factoryOptions){
    var code = trimPropValue(rawCode);
    var options = factoryOptions || [];
    var i = 0;
    if (!code) return '';
    for (i = 0; i < options.length; i++) {
      if (trimPropValue(options[i]).toLowerCase() === code.toLowerCase()) return trimPropValue(options[i]);
    }
    return '';
  }

  function findReusableFactoryCodeFromCart(cart, context, factoryOptions){
    var items = cart && cart.items && cart.items.length ? cart.items : [];
    var target = context || {};
    var allowed = factoryOptions || [];
    var targetMake = slugifyVehicleToken(target.make_slug || target.make);
    var targetYear = trimPropValue(target.year);
    var targetModel = sanitizeModelKey(target.model);
    var targetColorSlug = slugifyVehicleToken(target.color_slug);
    var targetColorName = slugifyVehicleToken(target.color);
    var targetColorCode = slugifyVehicleToken(target.code);
    var found = '';
    var i = 0;
    var props = null;
    var itemMake = '';
    var itemYear = '';
    var itemModel = '';
    var itemColorSlug = '';
    var itemColorName = '';
    var itemColorCode = '';
    var itemProduct = '';
    var normalizedItemProduct = '';
    var hasColorIdentity = false;
    var routeHandles = getCustomColorRouteHandleMap();
    var code = '';
    if (!targetModel || !targetColorSlug || isFreshVehicleSearchContext(target)) return '';
    for (i = 0; i < items.length; i++) {
      props = items[i] && items[i].properties && typeof items[i].properties === 'object' ? items[i].properties : {};
      itemProduct = trimPropValue(props._ps_product_slug || props.ps_product_slug).toLowerCase();
      if (!routeHandles[itemProduct]) {
        normalizedItemProduct = baseSlugFromValue(itemProduct);
        if (!normalizedItemProduct) normalizedItemProduct = baseSlugFromValue(items[i] && (items[i].handle || items[i].url));
        itemProduct = normalizedItemProduct;
      }
      hasColorIdentity = !!(
        trimPropValue(props._ps_color_slug) ||
        (trimPropValue(props.Make) && trimPropValue(props['Color Name']) && trimPropValue(props['Color Code']))
      );
      if (!hasColorIdentity || !routeHandles[itemProduct]) continue;
      itemMake = slugifyVehicleToken(props._ps_make_slug || props.Make);
      itemYear = trimPropValue(props.Year);
      itemModel = sanitizeModelKey(props.Model);
      itemColorSlug = slugifyVehicleToken(props._ps_color_slug);
      itemColorName = slugifyVehicleToken(props['Color Name']);
      itemColorCode = slugifyVehicleToken(props['Color Code']);
      if (!targetMake || itemMake !== targetMake || !targetYear || itemYear !== targetYear) continue;
      if (targetModel && itemModel !== targetModel) continue;
      if (itemColorSlug) {
        if (itemColorSlug !== targetColorSlug) continue;
      } else if (!targetColorName || !targetColorCode || itemColorName !== targetColorName || itemColorCode !== targetColorCode) {
        continue;
      }
      code = resolveAllowedFactoryCode(props[FACTORY_PROP_KEY], allowed);
      if (!code) continue;
      if (found && found.toLowerCase() !== code.toLowerCase()) return '';
      found = code;
    }
    return found;
  }

  function requestCartSnapshot(done){
    var cb = typeof done === 'function' ? done : function(){};
    var xhr = new XMLHttpRequest();
    var completed = false;
    function finish(err, cart){
      if (completed) return;
      completed = true;
      cb(err || null, cart || null);
    }
    xhr.open('GET', '/cart.js', true);
    xhr.timeout = 4000;
    xhr.onreadystatechange = function(){
      var cart = null;
      if (xhr.readyState !== 4) return;
      if (!(xhr.status >= 200 && xhr.status < 300)) {
        finish('Unable to read cart', null);
        return;
      }
      try { cart = JSON.parse(xhr.responseText || '{}'); } catch (_e) { cart = null; }
      if (!cart || Object.prototype.toString.call(cart.items) !== '[object Array]') {
        finish('Unable to read cart', null);
        return;
      }
      finish(null, cart);
    };
    xhr.onerror = function(){ finish('Unable to read cart', null); };
    xhr.ontimeout = function(){ finish('Unable to read cart', null); };
    xhr.send(null);
  }

  function claimCartRequest(controller){
    if (!controller || controller._cartRequestInFlight) return false;
    controller._cartRequestInFlight = true;
    return true;
  }

  function releaseCartRequest(controller){
    if (controller) controller._cartRequestInFlight = false;
  }

  function claimAtcFlow(controller){
    if (!controller || controller._atcFlowInFlight) return false;
    controller._atcFlowInFlight = true;
    return true;
  }

  function releaseAtcFlow(controller){
    if (controller) controller._atcFlowInFlight = false;
  }

  function normalizeVehicleMakeOptions(list){
    var source = list || [];
    var out = [];
    var seen = {};
    var item = null;
    var name = '';
    var slug = '';
    var key = '';
    var i = 0;
    if (!source.length) return [];
    for (i = 0; i < source.length; i++) {
      item = source[i];
      if (item && typeof item === 'object') {
        name = trimPropValue(item.make || item.name || item.label || item.value || '');
        slug = trimPropValue(item.make_slug || item.slug || item.handle || '');
      } else {
        name = trimPropValue(item);
        slug = '';
      }
      if (!name) continue;
      if (!slug) slug = slugifyVehicleToken(name);
      key = name.toLowerCase();
      if (seen[key]) continue;
      seen[key] = 1;
      out.push({ make: name, make_slug: slug });
    }
    return out;
  }

  function requestVehicleJsonList(url, keyName, done){
    var cb = typeof done === 'function' ? done : function(){};
    var xhr = null;
    var data = null;
    var list = [];
    var completed = false;
    function finish(err, values){
      if (completed) return;
      completed = true;
      cb(err, values || []);
    }
    if (!url) {
      finish(null, []);
      return;
    }
    xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.timeout = 4000;
    xhr.onreadystatechange = function(){
      if (xhr.readyState !== 4) return;
      if (!(xhr.status >= 200 && xhr.status < 300)) {
        finish('Unable to load options', []);
        return;
      }
      try { data = JSON.parse(xhr.responseText || '[]'); } catch (_e) { data = []; }
      if (Object.prototype.toString.call(data) === '[object Array]') {
        list = data;
      } else if (data && Object.prototype.toString.call(data[keyName]) === '[object Array]') {
        list = data[keyName];
      } else if (data && data.data && Object.prototype.toString.call(data.data) === '[object Array]') {
        list = data.data;
      } else {
        list = [];
      }
      finish(null, list);
    };
    xhr.onerror = function(){ finish('Unable to load options', []); };
    xhr.ontimeout = function(){ finish('Unable to load options', []); };
    xhr.send(null);
  }

  function fetchVehicleMakes(done){
    requestVehicleJsonList(apiBase() + 'shopify/makes', 'makes', function(err, list){
      done(err, normalizeVehicleMakeOptions(list || []));
    });
  }

  function fetchVehicleYearsForMake(make, done){
    var value = trimPropValue(make);
    if (!value) {
      done(null, []);
      return;
    }
    requestVehicleJsonList(apiBase() + 'shopify/years/' + encodeURIComponent(value), 'years', function(err, list){
      done(err, sanitizeYears(list || []));
    });
  }

  function resolveVehicleLookupContext(form, payload){
    var cc = readPsCc();
    var makeInput = form && form.querySelector ? form.querySelector('input[name="properties[Make]"]') : null;
    var makeSlugInput = form && form.querySelector ? form.querySelector('input[name="properties[_ps_make_slug]"]') : null;
    var colorInput = form && form.querySelector ? form.querySelector('input[name="properties[Color Name]"]') : null;
    var codeInput = form && form.querySelector ? form.querySelector('input[name="properties[Color Code]"]') : null;
    var colorSlugInput = form && form.querySelector ? form.querySelector('input[name="properties[_ps_color_slug]"]') : null;
    var context = {
      make: '',
      make_slug: '',
      color: '',
      code: '',
      color_slug: '',
      ps_from_search: isFreshVehicleSearchContext(cc)
    };

    if (makeInput && typeof makeInput.value !== 'undefined') context.make = trimPropValue(makeInput.value);
    if (!context.make && payload && payload.make) context.make = trimPropValue(payload.make);
    if (!context.make && cc && cc.make) context.make = trimPropValue(cc.make);

    if (makeSlugInput && typeof makeSlugInput.value !== 'undefined') context.make_slug = trimPropValue(makeSlugInput.value);
    if (!context.make_slug && payload && payload.make_slug) context.make_slug = trimPropValue(payload.make_slug);
    if (!context.make_slug && cc && cc.make_slug) context.make_slug = trimPropValue(cc.make_slug);

    if (colorInput && typeof colorInput.value !== 'undefined') context.color = trimPropValue(colorInput.value);
    if (!context.color && payload && payload.color) context.color = trimPropValue(payload.color);
    if (!context.color && cc && cc.color) context.color = trimPropValue(cc.color);

    if (codeInput && typeof codeInput.value !== 'undefined') context.code = trimPropValue(codeInput.value);
    if (!context.code && payload && payload.code) context.code = trimPropValue(payload.code);
    if (!context.code && cc && cc.code) context.code = trimPropValue(cc.code);

    if (colorSlugInput && typeof colorSlugInput.value !== 'undefined') context.color_slug = trimPropValue(colorSlugInput.value);
    if (!context.color_slug && payload && payload.color_slug) context.color_slug = trimPropValue(payload.color_slug);
    if (!context.color_slug && cc && cc.color_slug) context.color_slug = trimPropValue(cc.color_slug);

    return context;
  }

  function fetchVehicleModels(context, year, done){
    var cb = typeof done === 'function' ? done : function(){};
    var lookup = context && typeof context === 'object' ? context : { make: context };
    var mk = String(lookup.make == null ? '' : lookup.make).replace(/^\s+|\s+$/g, '');
    var ms = String(lookup.make_slug == null ? '' : lookup.make_slug).replace(/^\s+|\s+$/g, '');
    var cs = String(lookup.color_slug == null ? '' : lookup.color_slug).replace(/^\s+|\s+$/g, '');
    var yr = String(year == null ? '' : year).replace(/^\s+|\s+$/g, '');
    var hasColorLookup = !!(ms && cs);

    if (!yr || (!mk && !ms)) {
      cb(null, []);
      return;
    }

    if (ms && cs) {
      requestVehicleModelList(
        apiBase() + 'shopify/cars/' + encodeURIComponent(ms) + '/' + encodeURIComponent(cs) + '/' + encodeURIComponent(yr),
        function(err, models){
          cb(err, sanitizeModels(models || []));
        }
      );
      return;
    }

    if (mk) {
      requestVehicleModelList(
        apiBase() + 'shopify/models/' + encodeURIComponent(mk) + '/' + encodeURIComponent(yr),
        function(err, models){
          cb(err, sanitizeModels(models || []));
        }
      );
      return;
    }

    if (!hasColorLookup && !mk) cb(null, []);
  }

  function vehicleModelLookupCacheKey(context, year){
    var lookup = context && typeof context === 'object' ? context : {};
    var makeSlug = slugifyVehicleToken(lookup.make_slug || lookup.make);
    var colorSlug = trimPropValue(lookup.color_slug).toLowerCase();
    var yearValue = trimPropValue(year);
    if (!makeSlug || !colorSlug || !yearValue) return '';
    return makeSlug + '|' + colorSlug + '|' + yearValue;
  }

  function readVehicleModelsForController(controller, context, year){
    var key = vehicleModelLookupCacheKey(context, year);
    var cache = controller && controller._vehicleModelLookupCache;
    if (!key || !cache || !Object.prototype.hasOwnProperty.call(cache, key)) return null;
    return sanitizeModels(cache[key] || []);
  }

  function rememberVehicleModelsForController(controller, context, year, err, models){
    var key = vehicleModelLookupCacheKey(context, year);
    if (!controller || err || !key) return;
    if (!controller._vehicleModelLookupCache) controller._vehicleModelLookupCache = {};
    controller._vehicleModelLookupCache[key] = sanitizeModels(models || []);
  }

  function fetchVehicleModelsForController(controller, context, year, done){
    var cb = typeof done === 'function' ? done : function(){};
    var cached = readVehicleModelsForController(controller, context, year);
    if (cached !== null) {
      cb(null, cached);
      return;
    }
    fetchVehicleModels(context, year, function(err, models){
      rememberVehicleModelsForController(controller, context, year, err, models || []);
      cb(err, sanitizeModels(models || []));
    });
  }

  function isHondaAcuraMake(make){
    var s = String(make || '').toLowerCase();
    return s === 'honda' || s === 'acura';
  }

  function hasFactoryCodes(payload){
    return !!(payload && payload.factory_codes && payload.factory_codes.length);
  }

  function fetchColorContextFromCookie(done){
    var cb = typeof done === 'function' ? done : function(){};
    var cc = readPsCc();
    var ms = cc && cc.make_slug ? String(cc.make_slug) : '';
    var cs = cc && cc.color_slug ? String(cc.color_slug) : '';
    var url = '';
    var xhr = null;
    var data = null;
    var completed = false;
    function finish(err, detail){
      if (completed) return;
      completed = true;
      cb(err || null, detail || null);
    }
    function fail(reason, message){
      var err = new Error(message || 'Unable to refresh color context.');
      err.psColorContextFailure = true;
      err.psColorContextReason = reason;
      finish(err, null);
    }
    if (!ms || !cs) {
      finish(null, null);
      return;
    }
    url = apiBase() + 'shopify/cars/' + encodeURIComponent(ms) + '/' + encodeURIComponent(cs);
    if (!url) {
      finish(null, null);
      return;
    }
    xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.timeout = 4000;
    xhr.onreadystatechange = function(){
      var detail = null;
      if (xhr.readyState !== 4) return;
      if (!(xhr.status >= 200 && xhr.status < 300)) {
        fail('color_context_http_error', 'Color context refresh returned an HTTP error.');
        return;
      }
      try { data = JSON.parse(xhr.responseText || ''); } catch (_e) { data = null; }
      if (!data) {
        fail('color_context_malformed_json', 'Color context refresh returned malformed data.');
        return;
      }
      if (data.valid !== true) {
        fail('color_context_invalid', 'Color context refresh returned an invalid response.');
        return;
      }
      detail = {
        make: data.make || cc.make || '',
        color: data.color || cc.color || '',
        code: data.code || cc.code || '',
        hex: data.hex || cc.hex || '',
        year: cc.year || '',
        years: Array.isArray(data.years) ? data.years.slice(0) : [],
        models: Array.isArray(data.models) ? data.models.slice(0) : [],
        factory_codes: Array.isArray(data.factory_codes) ? data.factory_codes.slice(0) : [],
        isGuaranteed: data.isGuaranteed !== false,
        make_slug: data.make_slug || ms,
        color_slug: data.color_slug || cs,
        color_context_resolved: true,
        color_context_key: ms.toLowerCase() + '|' + cs.toLowerCase()
      };
      finish(null, detail);
    };
    xhr.onerror = function(){ fail('color_context_network', 'Color context refresh failed to connect.'); };
    xhr.ontimeout = function(){ fail('color_context_timeout', 'Color context refresh timed out.'); };
    xhr.send(null);
  }

  function shouldRefreshColorContext(form, payload){
    var cc = readPsCc();
    var resolvedKey = '';
    var props = serializeProperties(form);
    var years = sanitizeYears((payload && payload.years) || []);
    if (!isCustomColorLineItem(form, payload || {}, props)) return false;
    if (!cc || !trimPropValue(cc.make_slug) || !trimPropValue(cc.color_slug)) return false;
    resolvedKey = trimPropValue(cc.make_slug).toLowerCase() + '|' + trimPropValue(cc.color_slug).toLowerCase();
    if (payload && payload.color_context_resolved === true && payload.color_context_key === resolvedKey) return false;
    if (!(
      trimPropValue(cc.make) ||
      trimPropValue(cc.color) ||
      trimPropValue(cc.code) ||
      trimPropValue(cc.make_slug) ||
      trimPropValue(cc.color_slug)
    )) return false;
    if (!years.length) return true;
    if (isHondaAcuraMake((payload && payload.make) || cc.make) && !hasFactoryCodes(payload)) return true;
    return false;
  }

  function syncControllerPayload(controller, nextPayload){
    var payload = nextPayload && typeof nextPayload === 'object' ? nextPayload : {};
    if (!controller) return;
    controller._lastPayload = payload;
    controller._years = sanitizeYears((payload && payload.years) || []);
    controller._factoryCodes = sanitizeFactoryCodes((payload && payload.factory_codes) || []);
    if (controller.atcForm) {
      ensureBaseProps(controller.atcForm, payload);
      ensureSlugProps(controller.atcForm, payload);
    }
    if (controller.atcForm && controller.atcBtn && typeof controller.applyCatalyzedSprayOnlyGuard === 'function') {
      controller.applyCatalyzedSprayOnlyGuard(payload);
    }
  }

  function serializeProperties(form){
    var props = {};
    var nodes = form ? form.querySelectorAll('input[name^="properties["],textarea[name^="properties["]') : [];
    for (var i=0;i<nodes.length;i++){
      var n = nodes[i];
      var m = n.name.match(/^properties\[(.+)\]$/);
      if (m && typeof n.value !== 'undefined') props[m[1]] = n.value;
    }
    return props;
  }

  function readPsCc(){
    try{
      if (PS && PS.cc && typeof PS.cc.read === 'function'){
        var cc = PS.cc.read() || {};
        if (cc && typeof cc === 'object') return cc;
      }
    }catch(_e){}
    return {};
  }

  function isVehicleConfirmationRoute(){
    var path = '';
    var parts = [];
    var productSlug = '';
    var allowed = {
      pen: true,
      bottle: true,
      spray: true,
      pro: true,
      'kit-pen': true,
      'kit-bottle': true,
      'kit-spray': true
    };
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      path = '';
    }
    path = String(path || '').replace(/\/+$/, '');
    parts = path.split('/');
    if (parts.length !== 5 || parts[1] !== 'colors') return false;
    productSlug = String(parts[4] || '').toLowerCase();
    return !!allowed[productSlug];
  }

  function readVehicleConfirmationSsr(){
    var raw = null;
    var normalized = null;
    try {
      raw = (typeof window !== 'undefined' && window.PS_SSR && typeof window.PS_SSR === 'object') ? window.PS_SSR : null;
    } catch (_e) {
      raw = null;
    }
    normalized = (PS && PS.ssr && typeof PS.ssr === 'function') ? PS.ssr() : null;
    raw = raw || {};
    normalized = normalized || {};
    return mergePayload(raw, normalized);
  }

  function vehicleCookieMatchesColor(cc, ssr){
    var ccMakeSlug = trimPropValue(cc && cc.make_slug).toLowerCase();
    var ccColorSlug = trimPropValue(cc && cc.color_slug).toLowerCase();
    var ssrMakeSlug = trimPropValue(ssr && ssr.make_slug).toLowerCase();
    var ssrColorSlug = trimPropValue(ssr && ssr.color_slug).toLowerCase();
    return !!(ccMakeSlug && ccColorSlug && ssrMakeSlug && ssrColorSlug && ccMakeSlug === ssrMakeSlug && ccColorSlug === ssrColorSlug);
  }

  function slugifyVehicleToken(value){
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  }

  function vehicleCookieMatchesMake(cc, make, ssr){
    var ccMakeSlug = slugifyVehicleToken(trimPropValue(cc && cc.make_slug) || trimPropValue(cc && cc.make));
    var ssrMakeSlug = slugifyVehicleToken(trimPropValue(ssr && ssr.make_slug) || trimPropValue(make) || trimPropValue(ssr && ssr.make));
    return !!(ccMakeSlug && ssrMakeSlug && ccMakeSlug === ssrMakeSlug);
  }

  function hasTrustedVehicleScope(cc){
    return !!(cc && (cc.vehicle_scope === true || trimPropValue(cc.vehicle_scope) === 'true'));
  }

  function isFreshVehicleSearchContext(cc){
    return !!(cc && (cc.ps_from_search === true || trimPropValue(cc.ps_from_search) === 'true'));
  }

  function vehicleScopeMatchesSsrOptions(cc, ssr){
    var year = trimPropValue(cc && cc.year);
    var model = trimPropValue(cc && cc.model);
    var years = sanitizeYears((ssr && ssr.years) || []);
    var models = sanitizeModels((ssr && ssr.models) || []);
    var yearOk = false;
    var modelOk = false;
    var i = 0;
    if (!model) return false;
    modelOk = !!resolveVehicleModelFromOptions(model, models);
    if (!modelOk) return false;
    if (!year) return true;
    if (!years.length) return true;
    for (i = 0; i < years.length; i++) {
      if (String(years[i]) === String(year)) {
        yearOk = true;
        break;
      }
    }
    return yearOk;
  }

  function canUseVehicleScope(cc, ssr){
    if (!vehicleCookieMatchesColor(cc, ssr)) return false;
    if (hasTrustedVehicleScope(cc)) return true;
    return vehicleScopeMatchesSsrOptions(cc, ssr);
  }

  function resolveScopedCookieFactoryCode(cc, ssr, factoryOptions){
    var code = '';
    var options = factoryOptions || [];
    if (!canUseVehicleScope(cc, ssr) || isFreshVehicleSearchContext(cc)) return '';
    code = trimPropValue(cc && cc.factory_code);
    if (!code) return '';
    if (options.length) return resolveAllowedFactoryCode(code, options);
    return code;
  }

  function canUseVehicleDisplayContext(cc, ssr, make){
    if (!vehicleCookieMatchesMake(cc, make, ssr)) return false;
    return vehicleScopeMatchesSsrOptions(cc, ssr);
  }

  function normalizeStoredVehicleScope(raw){
    var out = {
      make: trimPropValue(raw && raw.make),
      year: trimPropValue(raw && raw.year),
      model: trimPropValue(raw && raw.model)
    };
    if (!out.make) return null;
    if (out.year && !/^\d+$/.test(out.year)) {
      out.year = '';
      out.model = '';
    }
    if (!out.year) out.model = '';
    return out;
  }

  function readStoredVehicleDisplayScope(keyPrefix, make, ssr){
    var storage = null;
    var key = '';
    var raw = '';
    var parsed = null;
    var normalized = null;
    var newest = null;
    var newestTs = 0;
    var storedTs = 0;
    var maxAgeMs = 6 * 60 * 60 * 1000;
    var i = 0;
    try {
      storage = window.sessionStorage;
    } catch(_e) {
      storage = null;
    }
    if (!storage || !storage.length) return null;
    for (i = 0; i < storage.length; i++) {
      try {
        key = storage.key(i);
      } catch(_e2) {
        key = '';
      }
      if (!key || key.indexOf(keyPrefix) !== 0) continue;
      try {
        raw = storage.getItem(key);
      } catch(_e3) {
        raw = '';
      }
      if (!raw) continue;
      try {
        parsed = JSON.parse(raw);
      } catch(_e4) {
        parsed = null;
      }
      normalized = normalizeStoredVehicleScope(parsed || {});
      storedTs = parsed && parsed.ts ? parseInt(parsed.ts, 10) : 0;
      if (!storedTs || isNaN(storedTs) || (Date.now() - storedTs) > maxAgeMs) continue;
      if (normalized && normalized.make && storedVehicleMatchesMake(normalized, make, ssr) && storedTs > newestTs) {
        newest = normalized;
        newestTs = storedTs;
      }
    }
    return newest;
  }

  function storedVehicleMatchesMake(scope, make, ssr){
    var scopeMakeSlug = slugifyVehicleToken(scope && scope.make);
    var makeSlug = slugifyVehicleToken(make || (ssr && ssr.make));
    if (!(scopeMakeSlug && makeSlug && scopeMakeSlug === makeSlug)) return false;
    if (scope && (scope.year || scope.model)) return vehicleScopeMatchesSsrOptions(scope, ssr);
    return true;
  }

  function buildVehicleDisplayContext(make, ssr){
    var cc = readPsCc();
    var useVehicleFields = canUseVehicleDisplayContext(cc, ssr, make);
    var displayMake = trimPropValue(make || (ssr && ssr.make));
    var storedScope = readStoredVehicleDisplayScope('ps-submitted-search:', displayMake, ssr) || readStoredVehicleDisplayScope('ps-edit-restore:', displayMake, ssr);
    var year = '';
    var model = '';

    if (useVehicleFields) {
      year = trimPropValue(cc && cc.year);
      model = trimPropValue(cc && cc.model);
      displayMake = trimPropValue(cc && cc.make) || displayMake;
    }
    if (storedVehicleMatchesMake(storedScope, displayMake, ssr)) {
      if (!displayMake) displayMake = trimPropValue(storedScope && storedScope.make);
      if (!year) year = trimPropValue(storedScope && storedScope.year);
      if (!model) model = trimPropValue(storedScope && storedScope.model);
      if (year || model) useVehicleFields = true;
    }

    return {
      make: displayMake,
      year: year,
      model: model,
      useVehicleFields: useVehicleFields,
      vehicleText: composeVehicleConfirmationLine(displayMake, year, model)
    };
  }

  function normalizeVehicleConfirmationImageUrl(url){
    var value = trimPropValue(url);
    if (!value) return '';
    if (/^https?:\/\//i.test(value) || value.charAt(0) === '/') return value;
    return '';
  }

  function vehicleConfirmationSwatchUrl(ssr, hex){
    var image = trimPropValue(ssr && (ssr.swatch_url || ssr.swatchUrl));
    var base = '';
    if (!image) {
      image = trimPropValue(ssr && ssr.image);
      if (image && image.indexOf('/img/swatch/') === -1) image = '';
    }
    if (!image && hex) {
      try {
        if (window.paintscratchTheme && window.paintscratchTheme.psUrl) {
          base = String(window.paintscratchTheme.psUrl).replace(/\/+$/, '');
        }
      } catch (_e) {
        base = '';
      }
      if (!base) {
        base = String(window.location.protocol || 'https:') + '//' + String(window.location.host || '');
      }
      image = base + '/img/swatch/' + hex.toUpperCase() + '.jpg';
    }
    return normalizeVehicleConfirmationImageUrl(image);
  }

  function buildVehicleConfirmationHubUrl(ssr){
    var path = '';
    var match = null;
    var makeSlug = '';
    var colorSlug = '';
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      path = '';
    }
    match = path.match(/^\/colors\/([^\/?#]+)\/([^\/?#]+)(?:\/|$)/i);
    if (match && match[1] && match[2]) {
      return '/colors/' + match[1] + '/' + match[2] + '/';
    }
    makeSlug = trimPropValue(ssr && ssr.make_slug).toLowerCase();
    colorSlug = trimPropValue(ssr && ssr.color_slug).toLowerCase();
    if (!makeSlug || !colorSlug) return '';
    return '/colors/' + encodeURIComponent(makeSlug) + '/' + encodeURIComponent(colorSlug) + '/';
  }

  function composeVehicleConfirmationLine(make, year, model){
    var parts = [];
    if (year) parts.push(year);
    if (make) parts.push(make);
    if (model) parts.push(model);
    return parts.join(' ');
  }

  function extractVehicleYearFromLine(line){
    var match = trimPropValue(line).match(/^(\d{4})(?:\s|$)/);
    return match && match[1] ? match[1] : '';
  }

  function normalizeVehicleConfirmationCode(code){
    var value = trimPropValue(code);
    return value ? value.toUpperCase() : 'Code unavailable';
  }

  function stripColorNameFromCode(code, color){
    var value = trimPropValue(code);
    var colorText = trimPropValue(color).toLowerCase();
    var idx = value.search(/\s+-\s+/);
    if (idx > 0 && colorText && value.toLowerCase().indexOf(colorText) > idx) {
      return trimPropValue(value.substring(0, idx));
    }
    return value;
  }

  function normalizeVehicleConfirmationName(name){
    var value = trimPropValue(name);
    return value ? value : 'Color name unavailable';
  }

  function formatVehicleConfirmationCode(code){
    return escapeHtml(code).replace(/([\/\-,.])/g, '$1<wbr>').replace(/\(/g, '<wbr>(');
  }

  function buildVehicleConfirmationColorHtml(color, code, hubUrl){
    var codeDisplay = normalizeVehicleConfirmationCode(code);
    var nameDisplay = normalizeVehicleConfirmationName(color);
    var identity = '';

    if (codeDisplay === 'Code unavailable') {
      identity = escapeHtml(nameDisplay);
    } else if (nameDisplay === 'Color name unavailable') {
      identity = formatVehicleConfirmationCode(codeDisplay);
    } else {
      identity = formatVehicleConfirmationCode(codeDisplay) + ' - ' + escapeHtml(nameDisplay);
    }

    return '' +
      '<span class="ps-vehicle-confirmation__color-label">COLOR CODE</span>' +
      (hubUrl ?
        '<a class="ps-vehicle-confirmation__color-link" href="' + escapeHtml(hubUrl) + '" aria-label="View ' + escapeHtml(codeDisplay + ' - ' + nameDisplay) + ' Color Hub page"><span class="ps-vehicle-confirmation__color-code">' + identity + '</span></a>' :
        '<span class="ps-vehicle-confirmation__color-code">' + identity + '</span>');
  }

  function findVehicleMakeOption(options, value){
    var wanted = trimPropValue(value);
    var wantedSlug = slugifyVehicleToken(wanted);
    var i = 0;
    var item = null;
    if (!wanted) return null;
    for (i = 0; i < options.length; i++) {
      item = options[i];
      if (trimPropValue(item.make) === wanted) return item;
    }
    for (i = 0; i < options.length; i++) {
      item = options[i];
      if (slugifyVehicleToken(item.make_slug || item.make) === wantedSlug) return item;
    }
    return null;
  }

  function cleanLegacyMakePath(make){
    return trimPropValue(make)
      .replace(/[^\x20-\x7E]/g, '')
      .replace(/[\/\s]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function cleanLegacyModelPath(make, model){
    var makeKey = trimPropValue(make).toLowerCase();
    var modelKey = trimPropValue(model).toLowerCase().replace(/\s+/g, ' ');
    var value = trimPropValue(model);
    if (makeKey === 'toyota' && modelKey === 'rav-4') value = 'RAV4';
    return value
      .replace(/[ /#']/g, '-')
      .replace(/[()]/g, '')
      .replace(/[^\x20-\x7E]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildTouchUpPaintVehiclePath(make, year, model){
    var makePath = cleanLegacyMakePath(make);
    var yearPath = trimPropValue(year).replace(/\D/g, '');
    var modelPath = cleanLegacyModelPath(make, model);
    if (!makePath || !/^\d{4}$/.test(yearPath) || !modelPath) return '';
    return '/touch_up_paint/' + makePath + '/' + yearPath + '-' + makePath + '-' + modelPath + '.html';
  }

  function clearVehicleSearchSessionContext(){
    var storage = null;
    var keys = [];
    var key = '';
    var i = 0;
    try {
      storage = window.sessionStorage;
    } catch (_e) {
      storage = null;
    }
    if (!storage) return;
    try {
      storage.removeItem('ps_last_color_context');
      storage.removeItem('ps_last_vehicle_context');
      for (i = 0; i < storage.length; i++) {
        key = storage.key(i);
        if (key && (key.indexOf('ps-submitted-search:') === 0 || key.indexOf('ps-edit-restore:') === 0)) {
          keys.push(key);
        }
      }
      for (i = 0; i < keys.length; i++) {
        storage.removeItem(keys[i]);
      }
    } catch (_e2) {}
  }

  function writeVehicleOnlySearchContext(selection){
    var make = trimPropValue(selection && selection.make);
    var makeSlug = trimPropValue(selection && selection.make_slug).toLowerCase();
    var year = trimPropValue(selection && selection.year);
    var model = trimPropValue(selection && selection.model);
    var payload = null;
    if (!make) return false;
    if (!makeSlug) makeSlug = slugifyVehicleToken(make);
    payload = {
      make: make,
      make_slug: makeSlug,
      year: year,
      model: model,
      vehicle_scope: true,
      color: '',
      code: '',
      hex: '',
      color_slug: '',
      factory_code: '',
      shopify_page: '',
      image: '',
      valid: false,
      products: [],
      selected_color: '',
      selected_color_code: '',
      selected_color_hex: '',
      selected_color_slug: '',
      selectedColor: '',
      selectedColorCode: '',
      selectedColorHex: '',
      selectedColorSlug: ''
    };
    try {
      if (PS && PS.cc && typeof PS.cc.write === 'function') {
        PS.cc.write(payload);
      } else {
        writePsCc(payload);
      }
    } catch (_e) {
      writePsCc(payload);
    }
    return true;
  }

  function openVehicleConfirmationEditModal(initialContext){
    var initial = initialContext || {};
    var makeOptions = [];
    var yearOptions = [];
    var modelOptions = [];
    var selectedMake = trimPropValue(initial.make);
    var selectedMakeSlug = trimPropValue(initial.make_slug);
    var selectedYear = trimPropValue(initial.year);
    var selectedModel = trimPropValue(initial.model);
    var makeCombobox = null;
    var yearCombobox = null;
    var modelCombobox = null;
    var requestId = 0;
    var loading = false;
    var modalSessionController = null;
    var modalSession = 0;

    function optionNames(options){
      var out = [];
      var i = 0;
      for (i = 0; i < options.length; i++) out.push(options[i].make);
      return out;
    }

    function setPrimaryState(modal, message){
      if (!modal || !modal.setPrimaryDisabled) return;
      modal.setPrimaryDisabled(loading || !selectedMake || !selectedYear || !selectedModel, loading ? (message || 'Loading vehicle options') : 'Select make, year, and model to continue');
    }

    if (!(PS.Modal && PS.Modal.open)) return;
    modalSessionController = PS.PDP || PS;
    modalSession = beginVehicleModalSession(modalSessionController);

    PS.Modal.open({
      title: 'Change Vehicle Details',
      okLabel: 'Find My Color',
      okAriaLabel: 'Find paint colors for this vehicle',
      hideCancel: true,
      modalClass: 'ps-modal--vehicle-details ps-modal--change-vehicle ps-modal--vehicle-confirmation-edit',
      contentClass: 'psm-content psm-vehicle-details psm-change-vehicle psm-vehicle-confirmation-edit',
      contentHtml:
        '<p class="psm-change-vehicle-copy">Enter your vehicle\'s information and we\'ll help you find the right color.</p>' +
        '<div class="psm-vehicle-field psm-vehicle-field--make">' +
          '<div class="psm-vehicle-combobox psm-vehicle-combobox--make" data-psm-combobox="make">' +
            '<input type="hidden" name="make" value="' + escapeHtml(selectedMake) + '">' +
            '<input type="hidden" name="make_slug" value="' + escapeHtml(selectedMakeSlug) + '">' +
            '<input type="text" name="make_display" value="' + escapeHtml(selectedMake) + '" class="psm-input psm-vehicle-combobox-input psm-vehicle-combobox-input--required" placeholder="Select make (required)" autocomplete="off" role="combobox" aria-label="Vehicle make" aria-autocomplete="list" aria-expanded="false" aria-controls="psm-vehicle-make-list">' +
            '<button type="button" class="psm-vehicle-combobox-toggle" aria-label="Toggle make suggestions"></button>' +
            '<div id="psm-vehicle-make-list" class="psm-vehicle-model-list" role="listbox" hidden></div>' +
          '</div>' +
        '</div>' +
        '<div class="psm-vehicle-field psm-vehicle-field--year">' +
          '<div class="psm-vehicle-combobox psm-vehicle-combobox--year is-disabled" data-psm-combobox="year">' +
            '<input type="hidden" name="year" value="' + escapeHtml(selectedYear) + '">' +
            '<input type="text" name="year_display" value="' + escapeHtml(selectedYear) + '" class="psm-input psm-vehicle-combobox-input psm-vehicle-combobox-input--year psm-vehicle-combobox-input--required" placeholder="Select year (required)" autocomplete="off" inputmode="numeric" disabled role="combobox" aria-label="Vehicle year" aria-autocomplete="list" aria-expanded="false" aria-controls="psm-vehicle-edit-year-list">' +
            '<button type="button" class="psm-vehicle-combobox-toggle" aria-label="Toggle year suggestions" disabled></button>' +
            '<div id="psm-vehicle-edit-year-list" class="psm-vehicle-model-list psm-vehicle-year-list" role="listbox" hidden></div>' +
          '</div>' +
        '</div>' +
        '<div class="psm-vehicle-field psm-vehicle-field--model">' +
          '<div class="psm-vehicle-combobox is-disabled" data-psm-combobox="model">' +
            '<input type="text" name="model" value="' + escapeHtml(selectedModel) + '" class="psm-input psm-vehicle-combobox-input psm-vehicle-combobox-input--required" placeholder="Select model (required)" autocomplete="off" disabled role="combobox" aria-label="Vehicle model" aria-autocomplete="list" aria-expanded="false" aria-controls="psm-vehicle-edit-model-list">' +
            '<button type="button" class="psm-vehicle-combobox-toggle" aria-label="Toggle model suggestions" disabled></button>' +
            '<div id="psm-vehicle-edit-model-list" class="psm-vehicle-model-list" role="listbox" hidden></div>' +
          '</div>' +
        '</div>',
      focusSelector: 'input[name="make_display"]',
      onValidate: function(data){
        if (!trimPropValue(data.make)) return { ok:false, message:'Please select a make.', focusSelector: 'input[name="make_display"]' };
        if (!trimPropValue(data.year)) return { ok:false, message:'Please select a year.', focusSelector: 'input[name="year_display"]' };
        data.model = resolveVehicleModelFromOptions(data.model, modelOptions);
        if (!trimPropValue(data.model)) return { ok:false, message:'Please select a model.', focusSelector: 'input[name="model"]' };
        if (!buildTouchUpPaintVehiclePath(data.make, data.year, data.model)) return { ok:false, message:'We could not build a vehicle color page for that selection.' };
        return { ok:true };
      },
      onOpen: function(modal){
        var makeValueEl = modal.formEl.querySelector('input[name="make"]');
        var makeSlugEl = modal.formEl.querySelector('input[name="make_slug"]');
        var makeEl = modal.formEl.querySelector('input[name="make_display"]');
        var makeComboEl = modal.formEl.querySelector('[data-psm-combobox="make"]');
        var makeToggleEl = makeComboEl ? makeComboEl.querySelector('.psm-vehicle-combobox-toggle') : null;
        var makeListEl = modal.formEl.querySelector('#psm-vehicle-make-list');
        var yearValueEl = modal.formEl.querySelector('input[name="year"]');
        var yearEl = modal.formEl.querySelector('input[name="year_display"]');
        var yearComboEl = modal.formEl.querySelector('[data-psm-combobox="year"]');
        var yearToggleEl = yearComboEl ? yearComboEl.querySelector('.psm-vehicle-combobox-toggle') : null;
        var yearListEl = modal.formEl.querySelector('#psm-vehicle-edit-year-list');
        var modelEl = modal.formEl.querySelector('input[name="model"]');
        var modelComboEl = modal.formEl.querySelector('[data-psm-combobox="model"]');
        var modelToggleEl = modelComboEl ? modelComboEl.querySelector('.psm-vehicle-combobox-toggle') : null;
        var modelListEl = modal.formEl.querySelector('#psm-vehicle-edit-model-list');

        function setYearEnabled(enabled, placeholderText){
          yearEl.disabled = !enabled;
          yearToggleEl.disabled = !enabled;
          yearEl.placeholder = placeholderText || 'Select year';
          if (enabled) yearComboEl.classList.remove('is-disabled');
          else yearComboEl.classList.add('is-disabled');
          if (!enabled && yearCombobox) yearCombobox.close();
        }

        function setModelEnabled(enabled, placeholderText){
          modelEl.disabled = !enabled;
          modelToggleEl.disabled = !enabled;
          modelEl.placeholder = placeholderText || 'Select model';
          if (enabled) modelComboEl.classList.remove('is-disabled');
          else modelComboEl.classList.add('is-disabled');
          if (!enabled && modelCombobox) modelCombobox.close();
        }

        function setModelValue(value){
          selectedModel = trimPropValue(value);
          modelEl.value = selectedModel;
          if (modelCombobox) modelCombobox.syncFromSelection();
          setPrimaryState(modal);
        }

        function loadModelsForYear(yearValue, restoreModel){
          var localRequestId = 0;
          var modelToRestore = trimPropValue(restoreModel);
          selectedYear = trimPropValue(yearValue);
          yearValueEl.value = selectedYear;
          modelOptions = [];
          setModelValue('');
          modal.renderError('');
          if (!selectedYear) {
            setModelEnabled(false, 'Select model');
            setPrimaryState(modal);
            return;
          }
          loading = true;
          localRequestId = ++requestId;
          setModelEnabled(false, 'Loading models...');
          setPrimaryState(modal, 'Loading vehicle models');
          fetchVehicleModels({ make: selectedMake, make_slug: selectedMakeSlug }, selectedYear, function(_err, models){
            if (!isVehicleModalSessionCurrent(modalSessionController, modalSession, modal.root)) return;
            if (localRequestId !== requestId) return;
            modelOptions = sanitizeModels(models || []);
            loading = false;
            setModelEnabled(true, 'Select model');
            if (modelToRestore) setModelValue(resolveVehicleModelFromOptions(modelToRestore, modelOptions));
            if (!selectedModel && modelOptions.length === 1) setModelValue(modelOptions[0]);
            setPrimaryState(modal);
          });
        }

        function loadYearsForMake(skipModelLoad){
          var lookupValue = selectedMakeSlug || selectedMake;
          var localRequestId = ++requestId;
          var restoreYear = skipModelLoad ? trimPropValue(initial.year) : '';
          var restoreModel = skipModelLoad ? trimPropValue(initial.model) : '';
          yearOptions = [];
          modelOptions = [];
          setModelValue('');
          yearValueEl.value = '';
          selectedYear = '';
          if (yearCombobox) yearCombobox.syncFromSelection();
          setYearEnabled(false, 'Loading years...');
          setModelEnabled(false, 'Select model');
          loading = true;
          setPrimaryState(modal, 'Loading vehicle years');
          fetchVehicleYearsForMake(lookupValue, function(_err, years){
            if (!isVehicleModalSessionCurrent(modalSessionController, modalSession, modal.root)) return;
            if (localRequestId !== requestId) return;
            yearOptions = sanitizeYears(years || []);
            loading = false;
            setYearEnabled(true, 'Select year');
            if (selectedYear && yearOptions.indexOf(selectedYear) === -1) selectedYear = '';
            if (!selectedYear && restoreYear && yearOptions.indexOf(restoreYear) > -1) selectedYear = restoreYear;
            yearValueEl.value = selectedYear;
            if (yearCombobox) yearCombobox.syncFromSelection();
            if (selectedYear) loadModelsForYear(selectedYear, restoreModel);
            else setPrimaryState(modal);
          });
        }

        function setMakeValue(value, skipInitialRestore){
          var option = findVehicleMakeOption(makeOptions, value);
          selectedMake = option ? option.make : trimPropValue(value);
          selectedMakeSlug = option ? option.make_slug : slugifyVehicleToken(selectedMake);
          makeValueEl.value = selectedMake;
          makeSlugEl.value = selectedMakeSlug;
          makeEl.value = selectedMake;
          if (makeCombobox) makeCombobox.syncFromSelection();
          if (selectedMake) loadYearsForMake(!!skipInitialRestore);
          else {
            selectedYear = '';
            yearValueEl.value = '';
            if (yearCombobox) yearCombobox.syncFromSelection();
            setModelValue('');
            setYearEnabled(false, 'Select year');
            setModelEnabled(false, 'Select model');
            setPrimaryState(modal);
          }
        }

        makeCombobox = createModalCombobox({
          comboEl: makeComboEl,
          inputEl: makeEl,
          listEl: makeListEl,
          toggleEl: makeToggleEl,
          optionIdPrefix: 'psm-vehicle-edit-make-option-',
          emptyText: 'No matching makes found.',
          getOptions: function(){ return optionNames(makeOptions); },
          getSelectedValue: function(){ return makeValueEl.value; },
          filterOption: function(optionValue, query){
            return String(optionValue).toLowerCase().indexOf(String(query || '').toLowerCase()) > -1;
          },
          onInput: function(nextQuery){
            var option = findVehicleMakeOption(makeOptions, nextQuery);
            if (option && option.make.toLowerCase() === trimPropValue(nextQuery).toLowerCase()) {
              setMakeValue(option.make, false);
              return { syncDisplay: true, close: true };
            }
            makeValueEl.value = '';
            makeSlugEl.value = '';
            selectedMake = '';
            selectedMakeSlug = '';
            selectedYear = '';
            yearValueEl.value = '';
            if (yearCombobox) yearCombobox.syncFromSelection();
            setModelValue('');
            setYearEnabled(false, 'Select year');
            setModelEnabled(false, 'Select model');
            setPrimaryState(modal);
            return {};
          },
          onSelect: function(value){
            setMakeValue(value, false);
          },
          onClear: function(){
            setMakeValue('', false);
          },
          onBlur: function(){
            if (!findVehicleMakeOption(makeOptions, makeEl.value)) setMakeValue('', false);
            return { syncDisplay: true };
          }
        });

        yearCombobox = createModalCombobox({
          comboEl: yearComboEl,
          inputEl: yearEl,
          listEl: yearListEl,
          toggleEl: yearToggleEl,
          optionIdPrefix: 'psm-vehicle-edit-year-option-',
          emptyText: 'No matching years found.',
          getOptions: function(){ return yearOptions.slice(0); },
          getSelectedValue: function(){ return yearValueEl.value; },
          normalizeInput: function(rawValue){ return String(rawValue || '').replace(/\D/g, ''); },
          filterOption: function(optionValue, query){ return String(optionValue).indexOf(query) === 0; },
          onInput: function(nextQuery){
            if (!nextQuery) {
              loadModelsForYear('');
              return { syncDisplay: true };
            }
            if (yearOptions.indexOf(nextQuery) > -1) {
              loadModelsForYear(nextQuery);
              return { syncDisplay: true, close: true };
            }
            yearValueEl.value = '';
            selectedYear = '';
            setPrimaryState(modal);
            return {};
          },
          onSelect: function(value){ loadModelsForYear(value); },
          onClear: function(){ loadModelsForYear(''); },
          onBlur: function(){
            if (yearOptions.indexOf(yearEl.value) === -1) loadModelsForYear('');
            return { syncDisplay: true };
          }
        });

        modelCombobox = createModalCombobox({
          comboEl: modelComboEl,
          inputEl: modelEl,
          listEl: modelListEl,
          toggleEl: modelToggleEl,
          optionIdPrefix: 'psm-vehicle-edit-model-option-',
          emptyText: 'No matching models found.',
          getOptions: function(){ return modelOptions.slice(0); },
          getSelectedValue: function(){ return modelEl.value; },
          filterOption: function(optionValue, query){
            return String(optionValue).toLowerCase().indexOf(String(query || '').toLowerCase()) > -1;
          },
          onInput: function(nextQuery){
            var resolved = resolveVehicleModelFromOptions(nextQuery, modelOptions);
            if (resolved && resolved.toLowerCase() === trimPropValue(nextQuery).toLowerCase()) {
              setModelValue(resolved);
              return { syncDisplay: true, close: true };
            }
            selectedModel = '';
            return {};
          },
          onSelect: function(value){ setModelValue(value); },
          onClear: function(){ setModelValue(''); },
          onBlur: function(){ return { syncDisplay: true }; },
          onEnterAfterSelect: function(){
            if (modal.formEl.requestSubmit) modal.formEl.requestSubmit();
            else modal.okBtn.click();
          }
        });

        setYearEnabled(false, 'Select year');
        setModelEnabled(false, 'Select model');
        setPrimaryState(modal);
        loading = true;
        setPrimaryState(modal, 'Loading vehicle makes');
        fetchVehicleMakes(function(_err, makes){
          if (!isVehicleModalSessionCurrent(modalSessionController, modalSession, modal.root)) return;
          makeOptions = makes || [];
          loading = false;
          if (makeCombobox) makeCombobox.syncFromSelection();
          if (selectedMake) setMakeValue(selectedMake, true);
          else setPrimaryState(modal);
        });
      }
    }).then(function(res){
      var data = null;
      var vehiclePath = '';
      invalidateVehicleModalSession(modalSessionController, modalSession);
      if (!res || !res.ok) return;
      data = res.data || {};
      vehiclePath = buildTouchUpPaintVehiclePath(data.make, data.year, data.model);
      if (!vehiclePath) return;
      if (!writeVehicleOnlySearchContext({
        make: data.make,
        make_slug: data.make_slug,
        year: data.year,
        model: data.model
      })) return;
      clearVehicleSearchSessionContext();
      window.location.href = vehiclePath;
    });
  }

  PS.VehicleDetails = PS.VehicleDetails || {};
  PS.VehicleDetails.openChangeVehicleModal = function(initialContext){
    return openVehicleConfirmationEditModal(initialContext || {});
  };

  function bindVehicleConfirmationEdit(box, context){
    var edit = null;
    if (!box || !box.querySelector) return;
    edit = box.querySelector('[data-ps-vehicle-confirmation-edit], .ps-vehicle-confirmation__edit');
    if (!edit) {
      edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'ps-vehicle-confirmation__edit';
      edit.setAttribute('data-ps-vehicle-confirmation-edit', '1');
      edit.setAttribute('aria-label', 'Change vehicle details');
      edit.innerHTML = '<svg class="ps-vehicle-confirmation__edit-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M3.5 14.7v1.8h1.8l8.9-8.9-1.8-1.8-8.9 8.9Zm12-8.4.8-.8c.4-.4.4-1 0-1.4l-.4-.4c-.4-.4-1-.4-1.4 0l-.8.8 1.8 1.8Z" fill="currentColor"/></svg>';
      box.appendChild(edit);
    }
    if (edit.getAttribute('data-ps-vehicle-confirmation-edit-bound') === '1') {
      edit._psVehicleConfirmationContext = context;
      return;
    }
    edit._psVehicleConfirmationContext = context;
    edit.setAttribute('data-ps-vehicle-confirmation-edit-bound', '1');
    edit.addEventListener('click', function(evt){
      if (evt && evt.preventDefault) evt.preventDefault();
      PS.VehicleDetails.openChangeVehicleModal(edit._psVehicleConfirmationContext || {});
    });
  }

  function getBreadcrumbColorIdentity(){
    var nav = null;
    var text = '';
    var match = null;
    try {
      nav = document.querySelector('nav[aria-label="Breadcrumb"], .breadcrumbs, .breadcrumb');
      text = nav ? String(nav.textContent || '') : '';
    } catch (_e) {
      text = '';
    }
    match = text.match(/([A-Z0-9][A-Z0-9\/., -]*?)\s+-\s+([A-Za-z][^\/\n\r]+)/);
    if (!match || !match[1] || !match[2]) return null;
    return {
      code: trimPropValue(match[1]).toUpperCase(),
      color: trimPropValue(match[2]).replace(/\s+Paint\s+\w+.*$/i, '')
    };
  }

  function getBreadcrumbMakeName(){
    var nav = null;
    var links = null;
    try {
      nav = document.querySelector('nav[aria-label="Breadcrumb"], .breadcrumbs, .breadcrumb');
      links = nav && nav.querySelectorAll ? nav.querySelectorAll('a') : null;
      if (links && links.length > 1) return trimPropValue(links[1].textContent || '');
    } catch (_e) {}
    return '';
  }

  function productLabelFromPath(){
    var path = '';
    var slug = '';
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      path = '';
    }
    slug = splitPathToken(path);
    slug = slug ? String(slug).toLowerCase() : '';
    if (slug === 'pen') return 'Paint Pen';
    if (slug === 'bottle') return 'Paint Bottle';
    if (slug === 'spray') return 'Spray Paint';
    if (slug === 'pro') return 'Professional Paint';
    if (slug === 'kit-pen') return 'Paint Pen Kit';
    if (slug === 'kit-bottle') return 'Paint Bottle Kit';
    if (slug === 'kit-spray') return 'Spray Paint Kit';
    if (slug === 'kit-pro') return 'Professional Paint Kit';
    return '';
  }

  function deriveLegacyHeadingProductText(contextText, makeName, colorName){
    var text = trimPropValue(contextText);
    var make = trimPropValue(makeName);
    var color = trimPropValue(colorName);
    if (make) text = text.replace(new RegExp('^' + escapeRegExp(make) + '\\s+', 'i'), '');
    if (color) text = text.replace(new RegExp('^' + escapeRegExp(color) + '\\s+', 'i'), '');
    text = text.replace(/^Touch[- ]Up\s+/i, '');
    text = text.replace(/\s+for\s+.+$/i, '');
    text = trimPropValue(text);
    return text || productLabelFromPath();
  }

  function escapeRegExp(value){
    return String(value || '').replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  function normalizeLegacyColorFocusHeadings(){
    var nodes = null;
    var ssr = null;
    var crumb = null;
    var makeName = '';
    var colorName = '';
    var code = '';
    var path = '';
    var productRoute = false;
    var i = 0;

    try {
      nodes = document.querySelectorAll('.ps-color-code-focus');
    } catch (_e) {
      nodes = null;
    }
    if (!nodes || !nodes.length) return;

    ssr = readVehicleConfirmationSsr();
    crumb = getBreadcrumbColorIdentity();
    makeName = trimPropValue((ssr && ssr.make) || getBreadcrumbMakeName());
    colorName = trimPropValue((ssr && (ssr.color || ssr.color_name)) || (crumb && crumb.color));
    code = trimPropValue((ssr && (ssr.code || ssr.color_code)) || (crumb && crumb.code)).toUpperCase();
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_ePath) {
      path = '';
    }
    productRoute = isPathWithProductSlug(path);

    for (i = 0; i < nodes.length; i++) {
      (function(node){
        var labelNode = node.querySelector ? node.querySelector('.ps-color-code-focus__label') : null;
        var codeNode = node.querySelector ? node.querySelector('.ps-color-code-focus__code') : null;
        var contextNode = node.querySelector ? node.querySelector('.ps-color-code-focus__context') : null;
        var productNode = node.querySelector ? node.querySelector('.ps-color-code-focus__product') : null;
        var labelText = trimPropValue(labelNode && labelNode.textContent ? labelNode.textContent : '');
        var nodeCode = trimPropValue(codeNode && codeNode.textContent ? codeNode.textContent : code).toUpperCase();
        var nodeContext = trimPropValue(contextNode && contextNode.textContent ? contextNode.textContent : '');
        var nodeColor = colorName;
        var nodeMake = makeName;
        var productText = '';
        var contextText = '';
        var displayContext = null;

        if (!nodeColor && nodeCode && nodeContext) {
          nodeColor = trimPropValue(nodeContext.replace(new RegExp('^' + escapeRegExp(nodeMake) + '\\s+', 'i'), '').replace(/\s+Touch[- ]Up Paint.*$/i, ''));
        }
        if (!nodeMake && nodeColor && nodeContext) {
          nodeMake = trimPropValue(nodeContext.replace(new RegExp('\\s*' + escapeRegExp(nodeColor) + '\\s+.*$', 'i'), ''));
        }
        nodeCode = stripColorNameFromCode(nodeCode, nodeColor).toUpperCase();
        if (!nodeCode || !nodeColor) return;

        try {
          window.PS_SSR = window.PS_SSR || {};
          if (!window.PS_SSR.code && !window.PS_SSR.color_code) window.PS_SSR.code = nodeCode;
          if (!window.PS_SSR.color && !window.PS_SSR.color_name) window.PS_SSR.color = nodeColor;
          if (nodeMake && !window.PS_SSR.make) window.PS_SSR.make = nodeMake;
        } catch (_eSsrRepair) {}

        displayContext = buildVehicleDisplayContext(nodeMake, ssr);

        if (productRoute) {
          productText = trimPropValue(productNode && productNode.textContent ? productNode.textContent : '');
          if (!productText) productText = deriveLegacyHeadingProductText(nodeContext, nodeMake, nodeColor);
          contextText = productText ? ('Touch-Up ' + productText + (displayContext.vehicleText ? ' for ' + displayContext.vehicleText : '')) : '';
        } else {
          if (!labelText) labelText = 'COLOR CODE';
          contextText = displayContext.vehicleText ? (displayContext.vehicleText + ' Touch-Up Paint') : 'Touch-Up Paint';
        }

        node.className = 'ps-color-heading ps-color-heading--legacy-repaired ps-color-heading--code-weight-regular ps-color-heading--context-weight-regular';
        node.setAttribute('data-ps-color-heading', '1');
        node.innerHTML =
          (labelText ? '<span class="ps-color-heading__label">' + escapeHtml(labelText) + '</span>' : '') +
          '<span class="ps-color-heading__code"><span class="ps-color-heading__code-token">' + formatVehicleConfirmationCode(nodeCode) + '</span><span class="ps-color-heading__separator"> - </span><span class="ps-color-heading__name">' + escapeHtml(nodeColor) + '</span></span>' +
          (contextText ? '<span class="ps-color-heading__context">' + escapeHtml(contextText) + '</span>' : '');
      })(nodes[i]);
    }
  }

  function hydrateVehicleConfirmation(){
    var box = document.querySelector('[data-ps-vehicle-confirmation]');
    var swatch = box && box.querySelector ? box.querySelector('[data-ps-vehicle-confirmation-swatch]') : null;
    var vehicleNode = box && box.querySelector ? box.querySelector('[data-ps-vehicle-confirmation-vehicle]') : null;
    var colorNode = box && box.querySelector ? box.querySelector('[data-ps-vehicle-confirmation-color]') : null;
    var ssr = null;
    var cc = null;
    var useVehicleFields = false;
    var make = '';
    var color = '';
    var code = '';
    var year = '';
    var model = '';
    var vehicleText = '';
    var colorText = '';
    var hex = '';
    var swatchImage = '';
    var displayContext = null;
    var hubUrl = '';

    if (!box) return false;
    box.setAttribute('hidden', 'hidden');
    if (!isVehicleConfirmationRoute()) return false;

    ssr = readVehicleConfirmationSsr();
    make = trimPropValue(ssr && ssr.make);
    color = trimPropValue(ssr && ssr.color);
    code = trimPropValue(ssr && ssr.code);
    if (!ssr || ssr.valid !== true || !make || !color || !code) return false;

    cc = readPsCc();
    displayContext = buildVehicleDisplayContext(make, ssr);
    useVehicleFields = displayContext.useVehicleFields;
    if (useVehicleFields) {
      year = displayContext.year;
      model = displayContext.model;
    }

    vehicleText = displayContext.vehicleText || composeVehicleConfirmationLine(make, year, model);
    colorText = 'Color code ' + normalizeVehicleConfirmationCode(code) + ', ' + normalizeVehicleConfirmationName(color);
    hubUrl = buildVehicleConfirmationHubUrl(ssr);

    if (vehicleNode) vehicleNode.textContent = vehicleText;
    if (colorNode) {
      colorNode.innerHTML = buildVehicleConfirmationColorHtml(color, code, hubUrl);
      colorNode.setAttribute('aria-label', colorText);
    }
    if (swatch) {
      if (hubUrl) {
        swatch.setAttribute('href', hubUrl);
        swatch.setAttribute('aria-hidden', 'false');
        swatch.setAttribute('aria-label', 'View ' + normalizeVehicleConfirmationCode(code) + ' - ' + normalizeVehicleConfirmationName(color) + ' Color Hub page');
        swatch.removeAttribute('tabindex');
      } else {
        swatch.removeAttribute('href');
        swatch.setAttribute('aria-hidden', 'true');
        swatch.setAttribute('tabindex', '-1');
      }
      swatch.style.display = 'block';
      swatch.style.height = '8rem';
      swatch.style.minHeight = '8rem';
      hex = trimPropValue(ssr && ssr.hex).replace(/[^0-9a-fA-F]/g, '').slice(0, 6);
      swatchImage = vehicleConfirmationSwatchUrl(ssr, hex);
      swatch.style.backgroundImage = '';
      swatch.style.backgroundColor = '';
      if (swatchImage) {
        swatch.style.backgroundImage = 'url("' + swatchImage.replace(/"/g, '%22') + '")';
      }
      if (hex) {
        swatch.style.backgroundColor = '#' + hex;
      }
    }

    bindVehicleConfirmationEdit(box, {
      make: displayContext.make || make,
      make_slug: trimPropValue((cc && cc.make_slug) || (ssr && ssr.make_slug)),
      year: year,
      model: model
    });
    applyVehicleConfirmationHiddenContext(displayContext, canUseVehicleScope(cc, ssr));
    box.removeAttribute('hidden');
    return true;
  }

  function applyVehicleConfirmationHiddenContext(displayContext, allowVehicleFields){
    var ctx = displayContext || {};
    var form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    var year = trimPropValue(ctx.year || '') || extractVehicleYearFromLine(ctx.vehicleText || '');
    var model = trimPropValue(ctx.model || '');
    function writeHiddenContext(){
      if (year) upsertHiddenProp(form, 'Year', year);
      if (model) upsertHiddenProp(form, 'Model', model);
    }
    if (!form || !ctx.useVehicleFields || allowVehicleFields !== true) return;
    writeHiddenContext();
    try {
      window.setTimeout(writeHiddenContext, 0);
      window.setTimeout(writeHiddenContext, 250);
    } catch (_e) {}
  }

  function writePsCc(cc){
    var val = cc && typeof cc === 'object' ? cc : {};
    function syncSameTabVehicleContext(source){
      var payload = null;
      var data = source && typeof source === 'object' ? source : {};
      var makeSlug = trimPropValue(data.make_slug || '');
      var colorSlug = trimPropValue(data.color_slug || '');
      if (!makeSlug || !colorSlug) return;
      payload = {
        make_slug: String(makeSlug).toLowerCase(),
        color_slug: String(colorSlug).toLowerCase(),
        year: trimPropValue(data.year || ''),
        model: trimPropValue(data.model || ''),
        factory_code: trimPropValue(data.factory_code || ''),
        ps_from_search: isFreshVehicleSearchContext(data)
      };
      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem('ps_last_color_context', JSON.stringify({
            make_slug: payload.make_slug,
            color_slug: payload.color_slug
          }));
          window.sessionStorage.setItem('ps_last_vehicle_context', JSON.stringify(payload));
        }
      } catch (_e) {}
    }
    try{
      if (PS && PS.cc && typeof PS.cc.write === 'function'){
        PS.cc.write(val);
        syncSameTabVehicleContext((PS.cc.read && PS.cc.read()) || val);
        return;
      }
    }catch(_e){}
    try{
      var payload = encodeURIComponent(JSON.stringify(val));
      var parts = [
        'ps_cc=' + payload,
        'Path=/',
        'Max-Age=' + (60*60*24*30),
        'SameSite=Lax'
      ];
      if (window.location && window.location.protocol === 'https:') parts.push('Secure');
      document.cookie = parts.join('; ');
      syncSameTabVehicleContext(val);
    }catch(_e){}
  }

  function readQuantityNear(form){
    function toQty(v){
      var q = parseInt(String(v || '').replace(/[^\d]/g, ''), 10);
      return q && q > 0 ? q : 1;
    }
    var el = form && form.querySelector('input[name="quantity"]');
    if (el && typeof el.value !== 'undefined'){
      var q1 = toQty(el.value);
      if (q1 > 0) return q1;
    }
    var root = form && form.closest ? form.closest('section') : document;
    var cands = root ? root.querySelectorAll('input[name="quantity"], .quantity__input, [data-quantity-input]') : [];
    for (var i=0;i<cands.length;i++){
      var n = cands[i];
      if (typeof n.value !== 'undefined'){
        var q2 = toQty(n.value);
        if (q2 > 0) return q2;
      }
      if (n.getAttribute){
        var q3 = toQty(n.getAttribute('value'));
        if (q3 > 0) return q3;
      }
    }
    var btn = document.querySelector('product-form [type="submit"], product-form .product-form__submit, form[action*="/cart/add"] [type="submit"]');
    if (btn && btn.getAttribute){
      var q4 = toQty(btn.getAttribute('data-qty'));
      if (q4 > 0) return q4;
    }
    if (form && form.getAttribute){
      var q5 = toQty(form.getAttribute('data-qty'));
      if (q5 > 0) return q5;
    }
    return 1;
  }

  function mainLineItemFromForm(form, data){
    if(!form) return null;
    var idEl = form.querySelector('input[name="id"]');
    if(!idEl || !idEl.value) return null;
    var qty = readQuantityNear(form);

    var props = serializeProperties(form);

    // Ensure Factory Code is present as a line item property.
    // Prefer the value from the form, then use only exact current-color cookie context.
    if (!props.hasOwnProperty(FACTORY_PROP_KEY) || props[FACTORY_PROP_KEY] === '') {
      var cc = readPsCc();
      var scopedFactoryCode = resolveScopedCookieFactoryCode(cc, data || {}, []);
      if (scopedFactoryCode) {
        props[FACTORY_PROP_KEY] = scopedFactoryCode;
      }
    }
    if (!validateCustomColorIntegrity(form, data, props).ok) return null;

    return { id: String(idEl.value), quantity: qty, properties: props };
  }


  function upsertHiddenProp(form, key, val){
    if (!form || !key) return;
    var sel = 'input[name="properties[' + key + ']"]';
    var el = form.querySelector(sel);
    if (!el){
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + key + ']';
      form.appendChild(el);
    }
    el.value = String(val == null ? '' : val);
  }

  function upsertPdpManagedColorProp(form, key, val){
    var el = null;
    upsertHiddenProp(form, key, val);
    el = form && form.querySelector ? form.querySelector('input[name="properties[' + key + ']"]') : null;
    if (el && el.setAttribute) el.setAttribute('data-ps-pdp-managed-color-prop', '1');
  }

  function removePdpManagedColorProps(form){
    var keys = ['Make', 'Color Name', 'Color Code', 'Year', 'Model', '_isGuaranteed', FACTORY_PROP_KEY, '_ps_make_slug', '_ps_color_slug', '_ps_product_slug'];
    var index = 0;
    var el = null;
    var removeUnmarked = readCustomColorFlag(form) === false;
    if (!form || !form.querySelector) return;
    for (index = 0; index < keys.length; index += 1) {
      el = form.querySelector('input[name="properties[' + keys[index] + ']"]');
      if (el && el.parentNode && (removeUnmarked || (el.getAttribute && el.getAttribute('data-ps-pdp-managed-color-prop') === '1'))) {
        el.parentNode.removeChild(el);
      }
    }
  }

  function removeHiddenProp(form, key){
    var el = null;
    if (!form || !key || !form.querySelector) return;
    el = form.querySelector('input[name="properties[' + key + ']"]');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function trimPropValue(val){
    return String(val == null ? '' : val).replace(/^\s+|\s+$/g, '');
  }

  function setModalComboboxExpanded(comboEl, inputEl, listEl, open){
    if (!comboEl || !inputEl || !listEl) return;
    inputEl.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) comboEl.classList.add('is-open');
    else comboEl.classList.remove('is-open');
    listEl.hidden = !open;
  }

  function scrollModalComboboxOptionIntoView(listEl, optionEl){
    var top = 0;
    var bottom = 0;
    var viewBottom = 0;
    if (!listEl || !optionEl) return;
    top = optionEl.offsetTop;
    bottom = top + optionEl.offsetHeight;
    viewBottom = listEl.scrollTop + listEl.clientHeight;
    if (top < listEl.scrollTop) {
      listEl.scrollTop = top;
    } else if (bottom > viewBottom) {
      listEl.scrollTop = bottom - listEl.clientHeight;
    }
  }

  function scrollModalComboboxOptionToTop(listEl, optionEl){
    if (!listEl || !optionEl) return;
    listEl.scrollTop = optionEl.offsetTop;
  }

  function syncModalComboboxClearButton(inputEl, clearButtonEl){
    var hasValue = false;
    if (!clearButtonEl) return;
    hasValue = !!trimPropValue(inputEl && inputEl.value);
    if (!hasValue || (inputEl && inputEl.disabled)) {
      clearButtonEl.style.display = 'none';
      clearButtonEl.setAttribute('aria-hidden', 'true');
      clearButtonEl.tabIndex = -1;
      return;
    }
    clearButtonEl.style.display = 'block';
    clearButtonEl.setAttribute('aria-hidden', 'false');
    clearButtonEl.tabIndex = 0;
  }

  function createModalCombobox(cfg){
    var activeIndex = -1;
    var searchQuery = '';

    function isOpen(){
      return !!(cfg.comboEl && cfg.comboEl.classList.contains('is-open'));
    }

    function getSelectedValue(){
      if (!cfg.getSelectedValue) return trimPropValue(cfg.inputEl && cfg.inputEl.value);
      return trimPropValue(cfg.getSelectedValue());
    }

    function getOptions(){
      var options = cfg.getOptions ? cfg.getOptions() : [];
      return options && options.slice ? options.slice(0) : [];
    }

    function setInputValue(nextValue){
      if (!cfg.inputEl) return;
      cfg.inputEl.value = String(nextValue || '');
      syncModalComboboxClearButton(cfg.inputEl, cfg.clearEl);
    }

    function closeList(){
      activeIndex = -1;
      searchQuery = '';
      setModalComboboxExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, false);
      cfg.inputEl.removeAttribute('aria-activedescendant');
      setInputValue(getSelectedValue());
    }

    function getFilteredOptions(){
      var options = getOptions();
      var filtered = [];
      var idx = 0;
      if (!searchQuery) return options;
      for (idx = 0; idx < options.length; idx++) {
        if (cfg.filterOption(options[idx], searchQuery)) filtered.push(options[idx]);
      }
      return filtered;
    }

    function syncAriaSelection(optionsList){
      var nodes = cfg.listEl.querySelectorAll('[data-psm-combobox-value]');
      var idx = 0;
      if (!nodes.length) {
        cfg.inputEl.removeAttribute('aria-activedescendant');
        return;
      }
      if (activeIndex >= nodes.length) activeIndex = nodes.length - 1;
      for (idx = 0; idx < nodes.length; idx++) {
        if (idx === activeIndex) nodes[idx].classList.add('is-active');
        else nodes[idx].classList.remove('is-active');
      }
      if (activeIndex > -1 && optionsList[activeIndex]) {
        cfg.inputEl.setAttribute('aria-activedescendant', cfg.optionIdPrefix + activeIndex);
        scrollModalComboboxOptionIntoView(cfg.listEl, nodes[activeIndex]);
      } else {
        cfg.inputEl.removeAttribute('aria-activedescendant');
      }
    }

    function renderList(openAfterRender){
      var filtered = getFilteredOptions();
      var selectedValue = getSelectedValue();
      var html = '';
      var idx = 0;
      var selectedIndex = -1;
      var nodesForTop = null;
      if (!cfg.listEl) return;
      if (!filtered.length) {
        if (!searchQuery) {
          cfg.listEl.innerHTML = '';
          closeList();
          return;
        }
        cfg.listEl.innerHTML = '<div class="psm-vehicle-model-empty">' + escapeHtml(cfg.emptyText) + '</div>';
        activeIndex = -1;
        cfg.inputEl.removeAttribute('aria-activedescendant');
        if (openAfterRender) setModalComboboxExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, true);
        return;
      }
      if (!searchQuery && selectedValue && activeIndex < 0) {
        for (idx = 0; idx < filtered.length; idx++) {
          if (String(filtered[idx]) === selectedValue) {
            selectedIndex = idx;
            break;
          }
        }
        activeIndex = selectedIndex;
      } else if (activeIndex >= filtered.length) {
        activeIndex = filtered.length - 1;
      }
      for (idx = 0; idx < filtered.length; idx++) {
        html += '<button type="button" id="' + cfg.optionIdPrefix + idx + '" class="psm-vehicle-model-option' +
          (String(filtered[idx]) === selectedValue ? ' is-selected' : '') + '" role="option" aria-selected="' +
          (String(filtered[idx]) === selectedValue ? 'true' : 'false') + '" data-psm-combobox-value="' +
          escapeHtml(filtered[idx]) + '">' + escapeHtml(filtered[idx]) + '</button>';
      }
      cfg.listEl.innerHTML = html;
      if (openAfterRender) setModalComboboxExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, true);
      syncAriaSelection(filtered);
      if (openAfterRender && !searchQuery && selectedIndex > -1) {
        nodesForTop = cfg.listEl.querySelectorAll('[data-psm-combobox-value]');
        if (nodesForTop[selectedIndex]) scrollModalComboboxOptionToTop(cfg.listEl, nodesForTop[selectedIndex]);
      }
    }

    function openList(){
      if (!cfg.inputEl || cfg.inputEl.disabled) return;
      searchQuery = '';
      activeIndex = -1;
      renderList(true);
      try {
        cfg.inputEl.focus();
        if (trimPropValue(cfg.inputEl.value)) cfg.inputEl.select();
      } catch(_e) {}
    }

    function syncFromSelection(){
      activeIndex = -1;
      searchQuery = '';
      setInputValue(getSelectedValue());
      if (isOpen()) {
        renderList(true);
        return;
      }
      setModalComboboxExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, false);
      cfg.inputEl.removeAttribute('aria-activedescendant');
    }

    function clearValue(){
      searchQuery = '';
      activeIndex = -1;
      if (cfg.onClear) cfg.onClear();
      syncFromSelection();
      if (!cfg.inputEl.disabled) openList();
    }

    cfg.toggleEl.onclick = function(evt){
      if (evt && evt.preventDefault) evt.preventDefault();
      if (evt && evt.stopPropagation) evt.stopPropagation();
      if (cfg.inputEl.disabled) return;
      if (isOpen()) {
        closeList();
        return;
      }
      openList();
    };
    cfg.toggleEl.onmousedown = function(evt){
      if (evt && evt.preventDefault) evt.preventDefault();
    };

    cfg.inputEl.onfocus = function(){
      if (cfg.inputEl.disabled) return;
      openList();
    };

    cfg.inputEl.onclick = function(){
      if (cfg.inputEl.disabled) return;
      openList();
    };

    cfg.inputEl.oninput = function(){
      var nextQuery = String(cfg.inputEl.value || '');
      var result = null;
      if (cfg.inputEl.disabled) return;
      if (cfg.normalizeInput) {
        nextQuery = cfg.normalizeInput(nextQuery);
        if (cfg.inputEl.value !== nextQuery) cfg.inputEl.value = nextQuery;
      }
      searchQuery = nextQuery;
      activeIndex = -1;
      syncModalComboboxClearButton(cfg.inputEl, cfg.clearEl);
      if (cfg.onInput) {
        result = cfg.onInput(nextQuery) || {};
        if (typeof result.searchQuery !== 'undefined') searchQuery = String(result.searchQuery || '');
        if (result.syncDisplay) {
          syncFromSelection();
          if (result.close) closeList();
          return;
        }
        if (result.close) {
          closeList();
          return;
        }
      }
      renderList(true);
    };

    cfg.inputEl.onblur = function(){
      window.setTimeout(function(){
        var result = cfg.onBlur ? (cfg.onBlur() || {}) : {};
        if (result.syncDisplay) syncFromSelection();
        closeList();
      }, 120);
    };

    cfg.inputEl.onkeydown = function(evt){
      var key = evt.key || evt.keyCode;
      var filtered = null;
      var selectedIndex = -1;
      var chosenValue = '';
      if (key === 'Escape' || key === 27) {
        if (isOpen()) {
          if (evt && evt.preventDefault) evt.preventDefault();
          if (evt && evt.stopPropagation) evt.stopPropagation();
          closeList();
        }
        return;
      }
      if (key === 'ArrowDown' || key === 40 || key === 'ArrowUp' || key === 38) {
        filtered = getFilteredOptions();
        if (!filtered.length) return;
        if (evt && evt.preventDefault) evt.preventDefault();
        if (!isOpen()) setModalComboboxExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, true);
        if (key === 'ArrowDown' || key === 40) activeIndex = activeIndex < filtered.length - 1 ? activeIndex + 1 : 0;
        else activeIndex = activeIndex > 0 ? activeIndex - 1 : filtered.length - 1;
        renderList(true);
        return;
      }
      if (key === 'Enter' || key === 13) {
        filtered = getFilteredOptions();
        if (!isOpen() || !filtered.length) return;
        if (evt && evt.preventDefault) evt.preventDefault();
        if (evt && evt.stopPropagation) evt.stopPropagation();
        if (activeIndex < 0 && !searchQuery) {
          for (selectedIndex = 0; selectedIndex < filtered.length; selectedIndex++) {
            if (String(filtered[selectedIndex]) === getSelectedValue()) {
              activeIndex = selectedIndex;
              break;
            }
          }
        }
        if (activeIndex < 0 && filtered.length === 1) activeIndex = 0;
        if (activeIndex < 0 || activeIndex >= filtered.length) return;
        chosenValue = filtered[activeIndex];
        searchQuery = '';
        activeIndex = -1;
        if (cfg.onSelect) cfg.onSelect(chosenValue, { source: 'keyboard-enter' });
        closeList();
        if (cfg.onEnterAfterSelect) cfg.onEnterAfterSelect(chosenValue);
      }
    };

    cfg.listEl.onclick = function(evt){
      var target = evt.target || evt.srcElement;
      var value = '';
      while (target && target !== cfg.listEl && (!target.getAttribute || !target.getAttribute('data-psm-combobox-value'))) {
        target = target.parentNode;
      }
      if (!target || target === cfg.listEl || !target.getAttribute) return;
      value = target.getAttribute('data-psm-combobox-value') || '';
      if (!value) return;
      searchQuery = '';
      activeIndex = -1;
      if (cfg.onSelect) cfg.onSelect(value, { source: 'click' });
      closeList();
    };

    cfg.listEl.onmousedown = function(evt){
      if (evt && evt.preventDefault) evt.preventDefault();
    };

    if (cfg.clearEl) {
      cfg.clearEl.onclick = function(evt){
        if (evt && evt.preventDefault) evt.preventDefault();
        if (evt && evt.stopPropagation) evt.stopPropagation();
        clearValue();
      };
      cfg.clearEl.onmousedown = function(evt){
        if (evt && evt.preventDefault) evt.preventDefault();
      };
    }

    syncFromSelection();
    return {
      close: closeList,
      open: openList,
      syncFromSelection: syncFromSelection
    };
  }

  function readCustomColorFlag(form){
    var host = null;
    var attr = '';
    if (!form) return null;
    if (form.getAttribute) {
      attr = String(form.getAttribute('data-ps-custom-color-product') || '').toLowerCase();
      if (attr === 'true') return true;
      if (attr === 'false') return false;
    }
    try {
      host = form.closest ? form.closest('product-form') : null;
    } catch (_e) {
      host = null;
    }
    if (!host || !host.getAttribute) return null;
    attr = String(host.getAttribute('data-ps-custom-color-product') || '').toLowerCase();
    if (attr === 'true') return true;
    if (attr === 'false') return false;
    return null;
  }

  function isColorRoutePath(path){
    return /^\/colors\/[^\/]+\/[^\/]+(?:\/[^\/]+)?\/?$/i.test(String(path || ''));
  }

  function hasVehicleLineItemContext(props){
    var p = props || {};
    return !!(
      trimPropValue(p['Make']) ||
      trimPropValue(p['Color Name']) ||
      trimPropValue(p['Color Code']) ||
      trimPropValue(p['_ps_make_slug']) ||
      trimPropValue(p['_ps_color_slug'])
    );
  }

  function hasRewrittenCustomColorContext(form, data, props){
    var d = data || {};
    var p = props || {};
    var productSlug = '';
    if (trimPropValue(p['_ps_make_slug']) || trimPropValue(p['_ps_color_slug'])) return true;
    if (trimPropValue(d.make_slug) || trimPropValue(d.color_slug)) return true;
    if (!hasVehicleLineItemContext(p)) return false;
    productSlug = String(resolveProductSlug(form, d) || '').toLowerCase();
    if (productSlug && getCustomColorRouteHandleMap()[productSlug]) return true;
    return false;
  }

  function isCustomColorLineItem(form, data, props){
    var d = data || {};
    var p = props || {};
    var flag = readCustomColorFlag(form);
    var path = '';
    if (flag === true) return true;
    if (flag === false) return false;
    if (hasRewrittenCustomColorContext(form, d, p)) return true;
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      path = '';
    }
    return isColorRoutePath(path);
  }

  function validateCustomColorIntegrity(form, data, props){
    var p = props || serializeProperties(form);
    var required = ['Make', 'Year', 'Color Name', 'Color Code', '_ps_make_slug', '_ps_color_slug', '_ps_product_slug'];
    var models = sanitizeModels((data && data.models) || []);
    var index = 0;
    var modelRequired = false;
    var result = {
      managed: false,
      ok: true,
      reason: '',
      properties: p
    };
    if (!isCustomColorLineItem(form, data || {}, p)) return result;
    result.managed = true;
    for (index = 0; index < required.length; index += 1) {
      if (!trimPropValue(p[required[index]])) {
        result.ok = false;
        result.reason = 'missing_' + required[index].toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/_+$/, '');
        return result;
      }
    }
    modelRequired = models.length > 0 && !onlyAllModelsValue(models);
    if (modelRequired && !trimPropValue(p.Model)) {
      result.ok = false;
      result.reason = 'missing_model';
      return result;
    }
    if (hasFactoryCodes(data) && !trimPropValue(p[FACTORY_PROP_KEY])) {
      result.ok = false;
      result.reason = 'missing_factory_code';
      return result;
    }
    return result;
  }

  function shouldUseNativeCartFallback(form, data, err){
    if (err && err.psNoNativeFallback) return false;
    return !isCustomColorLineItem(form, data || {}, serializeProperties(form));
  }

  function attemptNativeCartFallback(form, data, err){
    if (!shouldUseNativeCartFallback(form, data, err)) return false;
    try {
      if (form && typeof form.submit === 'function') {
        form.submit();
        return true;
      }
    } catch (_e) {}
    return false;
  }

  function hasValidRepairPlanColorYear(data, props){
    var year = trimPropValue((props || {})['Year']);
    var years = sanitizeYears((data && data.years) || []);
    if (!/^\d{4}$/.test(year)) return false;
    return !years.length || years.indexOf(year) > -1;
  }

  function prepareRepairPlanColorForm(form, data){
    var slugInput = form && form.querySelector ? form.querySelector('input[name="properties[_ps_product_slug]"]') : null;
    var productSlug = slugInput && slugInput.value ? String(slugInput.value).toLowerCase() : String(form && form.getAttribute && form.getAttribute('data-ps-product-base') || '').toLowerCase();
    ensureSlugProps(form, data || {});
    if (productSlug && getCustomColorRouteHandleMap()[productSlug]) {
      upsertHiddenProp(form, '_ps_product_slug', productSlug);
    }
    ensureBaseProps(form, data || {});
    return serializeProperties(form);
  }

  function copyRepairPlanFormula(form, confirmedForm){
    var confirmed = confirmedForm.querySelector('input[name="properties[Paint Formula]"]');
    var previous = form.querySelector('input[name="properties[Paint Formula]"]');
    if (confirmed && confirmed.value) upsertHiddenProp(form, 'Paint Formula', confirmed.value);
    else if (previous) previous.parentNode.removeChild(previous);
  }

  function repairPlanOptInProperties(rawProperties){
    var properties = {};
    if (rawProperties && rawProperties._ps_repair_photo_opt_in === '1') properties._ps_repair_photo_opt_in = '1';
    if (rawProperties && rawProperties._ps_repair_guide_opt_in === '1') properties._ps_repair_guide_opt_in = '1';
    return Object.keys(properties).length ? properties : null;
  }

  function normalizeRepairPlanOrdinaryItems(rawItems){
    var normalized = [];
    var seen = {};
    var list = rawItems && typeof rawItems.length === 'number' ? rawItems : [];
    var maxLines = 12;
    var maxQuantity = 20;
    var i = 0;
    var raw = null;
    var id = 0;
    var quantity = 0;
    var key = '';

    for (i = 0; i < list.length && normalized.length < maxLines; i += 1) {
      raw = list[i] || {};
      if (!/^\d+$/.test(String(raw.id)) || !/^\d+$/.test(String(raw.quantity))) continue;
      id = parseInt(raw.id, 10);
      quantity = parseInt(raw.quantity, 10);
      if (!id || id < 1 || id > 9007199254740991 || !quantity || quantity < 1 || quantity > maxQuantity) continue;
      key = String(id);
      if (seen[key]) continue;
      seen[key] = true;
      var markers = repairPlanOptInProperties(raw.properties);
      normalized.push(markers ? { id: key, quantity: quantity, properties: markers } : { id: key, quantity: quantity });
    }
    return normalized;
  }

  function appendRepairPlanOrdinaryItems(items, ordinaryItems){
    var combined = items && items.slice ? items.slice(0) : [];
    var ordinary = normalizeRepairPlanOrdinaryItems(ordinaryItems);
    var known = {};
    var i = 0;
    var item = null;
    var key = '';

    for (i = 0; i < combined.length; i += 1) {
      item = combined[i] || {};
      key = String(item.id || '');
      if (key) known[key] = i;
    }
    for (i = 0; i < ordinary.length; i += 1) {
      item = ordinary[i];
      key = String(item.id || '');
      if (!key) continue;
      if (known[key] !== undefined) {
        if (item.properties) {
          var existing = combined[known[key]];
          var marked = {};
          var properties = {};
          var property = '';
          for (property in existing) {
            if (Object.prototype.hasOwnProperty.call(existing, property)) marked[property] = existing[property];
          }
          for (property in (existing.properties || {})) {
            if (Object.prototype.hasOwnProperty.call(existing.properties, property)) properties[property] = existing.properties[property];
          }
          if (item.properties._ps_repair_photo_opt_in === '1') properties._ps_repair_photo_opt_in = '1';
          if (item.properties._ps_repair_guide_opt_in === '1') properties._ps_repair_guide_opt_in = '1';
          marked.properties = properties;
          combined[known[key]] = marked;
        }
        continue;
      }
      known[key] = combined.length;
      combined.push(item.properties ? { id: key, quantity: item.quantity, properties: repairPlanOptInProperties(item.properties) } : { id: key, quantity: item.quantity });
    }
    return combined;
  }

  function repairPlanKitExtrasFromForm(form){
    var checked = null;
    var rawIds = '';
    var ids = [];
    var extras = [];
    var qty = readQuantityNear(form);
    var i = 0;
    var id = 0;
    if (!form || !form.querySelector) return extras;
    checked = form.querySelector('.ps-kit-input:checked');
    if (!checked) return extras;
    rawIds = checked.getAttribute ? checked.getAttribute('data-kit-ids') || '' : '';
    if (!rawIds) return extras;
    ids = rawIds.split(',');
    for (i = 0; i < ids.length; i += 1) {
      id = parseInt(ids[i], 10);
      if (id > 0) extras.push({ id: id, quantity: qty });
    }
    return extras;
  }

  function setRepairPlanButtonBusy(button, busy){
    if (!button) return;
    if (busy) {
      if (typeof button.disabled !== 'undefined') button.disabled = true;
      if (button.setAttribute) button.setAttribute('aria-disabled', 'true');
      return;
    }
    if (typeof button.disabled !== 'undefined') button.disabled = false;
    if (button.setAttribute) button.setAttribute('aria-disabled', 'false');
  }

  function completeRepairPlanRequest(controller, form, err, result){
    var request = controller && controller._repairPlanRequest;
    var callback = null;
    if (!request || request.completed || request.form !== form) return false;
    request.completed = true;
    callback = request.done;
    setRepairPlanButtonBusy(request.button, false);
    controller._repairPlanRequest = null;
    controller._repairPlanInFlight = false;
    if (controller.atcForm === form) controller.atcForm = request.originalForm || null;
    if (controller.atcBtn === request.button) controller.atcBtn = request.originalBtn || null;
    if (request.hasOwnProperty && request.hasOwnProperty('originalPayload')) controller._lastPayload = request.originalPayload;
    if (typeof request.originalProductBase !== 'undefined') controller._currentProductBase = request.originalProductBase;
    if (typeof request.originalCatalyzedOnly !== 'undefined') controller._isCatalyzedOnly = request.originalCatalyzedOnly;
    if (typeof request.originalSprayProduct !== 'undefined') controller._isSprayProduct = request.originalSprayProduct;
    try {
      if (typeof callback === 'function') callback(err || null, result || null);
    } catch (_eCallback) {}
    return true;
  }

  function cancelRepairPlanRequest(controller, form, message){
    var err = new Error(message || 'Repair plan cancelled.');
    err.psRepairPlanCancelled = true;
    return completeRepairPlanRequest(controller, form, err, null);
  }

  function markRepairPlanTransportError(err){
    if (!err || err.psIntegrityFailure || err.psRepairPlanCancelled || err.psRepairPlanPreflightRejected) return err;
    err.psRepairPlanUncertain = true;
    return err;
  }

  function stopCustomColorIntegrityFailure(controller, form, data, result){
    var reason = result && result.reason ? result.reason : 'identity_unavailable';
    try { releaseCartRequest(controller); } catch (_eReleaseCart) {}
    try { releaseAtcFlow(controller); } catch (_eReleaseAtc) {}
    try { if (controller && typeof controller.enable === 'function') controller.enable(); } catch (_eEnable) {}
    try { if (controller && typeof controller._clearModalProductContext === 'function') controller._clearModalProductContext(); } catch (_eClear) {}
    setFormErrorMessage(form, 'We could not confirm your vehicle and paint details. Please choose your vehicle again and retry.');
    trackCustomColorFunnel('atc_integrity_blocked', {
      product_type: funnelProductTypeFromItems([{ properties: (result && result.properties) || serializeProperties(form) }]),
      outcome: 'blocked',
      modal_block_reason: reason
    });
    completeRepairPlanRequest(controller, form, new Error('We could not confirm your vehicle and paint details. Please choose your vehicle again and retry.'), null);
  }

  function setFormErrorMessage(form, messageText){
    var host = null;
    var wrapper = null;
    var message = null;
    var fallback = null;
    var text = trimPropValue(messageText);
    if (!form) return;
    try {
      host = form.closest ? form.closest('product-form') : null;
    } catch (_e) {
      host = null;
    }
    if (host && typeof host.handleErrorMessage === 'function') {
      host.handleErrorMessage(text || false);
      return;
    }
    if (host && host.querySelector) {
      wrapper = host.querySelector('.product-form__error-message-wrapper');
    }
    if (!wrapper && form.querySelector) {
      wrapper = form.querySelector('.product-form__error-message-wrapper');
    }
    if (wrapper && wrapper.querySelector) {
      message = wrapper.querySelector('.product-form__error-message');
      if (message) message.textContent = text;
      wrapper.toggleAttribute('hidden', !text);
      return;
    }
    if (!form || !form.querySelector || !form.appendChild) return;
    fallback = form.querySelector('[data-ps-atc-integrity-error="1"]');
    if (!text) {
      if (fallback && fallback.parentNode) fallback.parentNode.removeChild(fallback);
      return;
    }
    if (!fallback) {
      fallback = document.createElement('div');
      fallback.setAttribute('data-ps-atc-integrity-error', '1');
      fallback.setAttribute('role', 'alert');
      fallback.setAttribute('aria-live', 'assertive');
      form.appendChild(fallback);
    }
    fallback.textContent = text;
  }

  function splitPathToken(raw){
    var s = String(raw || '');
    var q = s.indexOf('?');
    var h = s.indexOf('#');
    var cut = -1;
    var parts = null;
    var i = 0;
    var token = '';
    var m = null;
    if (q > -1 && h > -1) cut = q < h ? q : h;
    else if (q > -1) cut = q;
    else if (h > -1) cut = h;
    if (cut > -1) s = s.substring(0, cut);
    m = s.match(/^https?:\/\/[^\/]+(\/.*)$/i);
    if (m && m[1]) s = m[1];
    s = String(s || '').toLowerCase();
    if (!s) return '';
    parts = s.split('/');
    for (i = parts.length - 1; i >= 0; i--) {
      if (parts[i]) {
        token = parts[i];
        break;
      }
    }
    return token || '';
  }

  function containsKitHint(raw){
    var s = String(raw || '').toLowerCase();
    if (!s) return false;
    if (s === 'kit') return true;
    if (s.indexOf('kit-') === 0) return true;
    if (s.indexOf('-kit-') > -1) return true;
    if (/[-_]kit$/.test(s)) return true;
    if (s.indexOf('touch-up-paint-kit-') === 0) return true;
    return false;
  }

  function containsTricoHint(raw){
    return String(raw || '').toLowerCase().indexOf('trico') > -1;
  }

  function isPathWithProductSlug(path){
    var p = String(path || '').toLowerCase();
    var token = extractProductLookupToken(p);
    if (!p) return false;
    if (/^\/products\/[^\/]+\/?$/.test(p)) return !!(token && getColorProductBaseMap()[token]);
    if (/^\/colors\/[^\/]+\/[^\/]+\/[^\/]+\/?$/.test(p)) return !!(token && getCustomColorRouteHandleMap()[token]);
    return false;
  }

  function findFeaturedIdNearForm(form){
    var cur = form;
    while (cur && cur !== document){
      if (cur.getAttribute){
        var attrVal = cur.getAttribute('data-ps-featured-id');
        if (attrVal) return String(attrVal).toLowerCase();
      }
      if (cur.id && /^ps_(kits|products)_/.test(cur.id)) return String(cur.id).toLowerCase();
      cur = cur.parentNode;
    }
    return '';
  }

  function findHrefHintNearForm(form){
    var parent = null;
    var link = null;
    var root = null;
    if (!form) return '';
    parent = form.parentNode;
    if (parent && parent.querySelector){
      link = parent.querySelector('a[href*="/colors/"], a[href*="/products/"]');
      if (link && link.getAttribute) return String(link.getAttribute('href') || '');
    }
    try {
      root = form.closest ? form.closest('.card-wrapper, .grid__item, .image-with-text__grid, section, product-info') : null;
    } catch (_e) {
      root = null;
    }
    if (root && root.querySelector){
      link = root.querySelector('a[href*="/colors/"], a[href*="/products/"]');
      if (link && link.getAttribute) return String(link.getAttribute('href') || '');
    }
    return '';
  }

  function findProductInfoHintNearForm(form){
    var root = null;
    if (!form) return '';
    try {
      root = form.closest ? form.closest('product-info') : null;
    } catch (_e) {
      root = null;
    }
    if (!root || !root.getAttribute) return '';
    return String(root.getAttribute('data-url') || root.getAttribute('data-product-url') || '');
  }

  function findLocalProductBase(form){
    var formBase = '';
    var infoHint = '';
    var hrefHint = '';
    if (form && form.getAttribute) {
      formBase = baseSlugFromValue(form.getAttribute('data-ps-product-base') || '');
      if (formBase) return formBase;
    }
    infoHint = findProductInfoHintNearForm(form);
    formBase = baseSlugFromValue(splitPathToken(infoHint) || infoHint);
    if (formBase) return formBase;
    hrefHint = findHrefHintNearForm(form);
    formBase = baseSlugFromValue(splitPathToken(hrefHint) || hrefHint);
    if (formBase) return formBase;
    return '';
  }

  function resolveProductSlug(form, data){
    var d = data || {};
    var raw = String(d.product_slug || '');
    var rawToken = splitPathToken(raw);
    var featuredId = findFeaturedIdNearForm(form);
    var featuredNorm = String(featuredId || '').replace(/-/g, '_');
    var infoHint = findProductInfoHintNearForm(form);
    var infoToken = splitPathToken(infoHint);
    var hrefHint = findHrefHintNearForm(form);
    var hrefToken = splitPathToken(hrefHint);
    var pathHint = '';
    var pathToken = '';
    var base = '';
    var localBase = '';
    var isKit = false;
    var isTrico = false;

    try {
      pathHint = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      pathHint = '';
    }
    pathToken = splitPathToken(pathHint);

    localBase = findLocalProductBase(form);
    base = localBase;
    if (!base) base = baseSlugFromValue(rawToken || raw);
    if (!base && isPathWithProductSlug(pathHint)) base = baseSlugFromValue(pathToken || pathHint);
    if (!base) base = getCurrentProductBase(d, form);

    if (form && form.getAttribute && /^(kit-pen|kit-bottle|kit-spray)(-tricoat)?$/.test(form.getAttribute('data-ps-product-base') || '')) isKit = true;
    if (featuredNorm.indexOf('ps_kits_') === 0) isKit = true;
    if (!isKit && containsKitHint(rawToken || raw)) isKit = true;
    if (!isKit && containsKitHint(infoToken || infoHint)) isKit = true;
    if (!isKit && containsKitHint(hrefToken || hrefHint)) isKit = true;
    if (!isKit && isPathWithProductSlug(pathHint) && containsKitHint(pathToken || pathHint)) isKit = true;

    if (d && d.is_tricoat === true) isTrico = true;
    if (!isTrico && featuredNorm.indexOf('tricoat') > -1) isTrico = true;
    if (!isTrico && containsTricoHint(rawToken || raw)) isTrico = true;
    if (!isTrico && containsTricoHint(infoToken || infoHint)) isTrico = true;
    if (!isTrico && containsTricoHint(hrefToken || hrefHint)) isTrico = true;
    if (!isTrico && isPathWithProductSlug(pathHint) && containsTricoHint(pathToken || pathHint)) isTrico = true;

    if (base && isKit) return 'kit-' + base;
    if (localBase) return localBase;
    if (rawToken) return rawToken;
    if (base) return base;
    return '';
  }

  function ensureSlugProps(form, data){
    var d = data || {};
    var cc = readPsCc();
    var existingProductSlug = '';
    var existingInput = null;
    var resolvedProductSlug = '';
    if (readCustomColorFlag(form) === false) {
      removePdpManagedColorProps(form);
      return;
    }
    if (form && form.querySelector){
      existingInput = form.querySelector('input[name="properties[_ps_product_slug]"]');
      if (existingInput && existingInput.value) {
        existingProductSlug = String(existingInput.value);
      }
    }
    resolvedProductSlug = resolveProductSlug(form, d);
    if (!resolvedProductSlug && existingProductSlug) resolvedProductSlug = existingProductSlug;
    upsertPdpManagedColorProp(form, '_ps_make_slug', d.make_slug || cc.make_slug || '');
    upsertPdpManagedColorProp(form, '_ps_color_slug', d.color_slug || cc.color_slug || '');
    upsertPdpManagedColorProp(form, '_ps_product_slug', resolvedProductSlug);
  }
  function ensureBaseProps(form, data){
    var d = data || {};
    // Prefer PS_SSR values, then ps_cc
    var cc = readPsCc();
    var useVehicleFields = canUseVehicleScope(cc, d);
    var hiddenYear = '';
    var hiddenModel = '';
    var modelVal = '';
    var productBase = '';
    var modelInput = null;
    var yearInput = form && form.querySelector ? form.querySelector('input[name="properties[Year]"]') : null;
    var productSlugInput = null;
    if (readCustomColorFlag(form) === false) {
      removePdpManagedColorProps(form);
      return;
    }
    modelInput = form && form.querySelector ? form.querySelector('input[name="properties[Model]"]') : null;
    upsertPdpManagedColorProp(form, 'Make', d.make || cc.make || '');
    upsertPdpManagedColorProp(form, 'Color Name', d.color || cc.color || '');
    upsertPdpManagedColorProp(form, 'Color Code', d.code || cc.code || '');
    hiddenYear = useVehicleFields ? (cc.year || '') : '';
    hiddenModel = useVehicleFields && cc && cc.model ? String(cc.model).replace(/^\s+|\s+$/g, '') : '';
    if (!hiddenYear && yearInput && typeof yearInput.value !== 'undefined') hiddenYear = trimPropValue(yearInput.value);
    if (!hiddenModel && modelInput && typeof modelInput.value !== 'undefined') hiddenModel = trimPropValue(modelInput.value);
    upsertPdpManagedColorProp(form, 'Year', hiddenYear);
    upsertPdpManagedColorProp(form, '_isGuaranteed', d.isGuaranteed);

    var fc = resolveScopedCookieFactoryCode(cc, d, []);
    if (fc) {
      upsertPdpManagedColorProp(form, FACTORY_PROP_KEY, fc);
    }

    modelVal = hiddenModel;
    productBase = getCurrentProductBase(d, form);
    if (!productBase && form && form.querySelector) {
      productSlugInput = form.querySelector('input[name="properties[_ps_product_slug]"]');
      if (productSlugInput && productSlugInput.value) {
        productBase = baseSlugFromValue(String(productSlugInput.value));
      }
    }
    if (productBase && modelVal) {
      upsertPdpManagedColorProp(form, 'Model', modelVal);
    } else if (modelInput) {
      removeHiddenProp(form, 'Model');
    }
  }

  function isCatalyzedSprayOnly(colorName){
    var n = String(colorName || '').toLowerCase();
    return /\(catalyzed spray(?: can)? only\)/.test(n);
  }

  // Entry point for future product expansion:
  // Theme setting: settings.ps_catalyzed_allowed_bases (comma-separated, default: spray).
  // Example values: "spray" or "spray,pro".
  var CATALYZED_ALLOWED_BASES = (function(){
    var out = {};
    var raw = '';
    var parts = [];
    var i = 0;
    try {
      raw = window.paintscratchTheme && window.paintscratchTheme.psCatalyzedAllowedBases
        ? String(window.paintscratchTheme.psCatalyzedAllowedBases)
        : 'spray';
    } catch (_e) { raw = 'spray'; }
    parts = String(raw || 'spray').toLowerCase().split(',');
    for (i = 0; i < parts.length; i++) {
      var key = String(parts[i] || '').replace(/^\s+|\s+$/g, '');
      if (key) out[key] = true;
    }
    if (!out.spray) out.spray = true;
    return out;
  })();

  function isKnownProductBase(base){
    return base === 'pen' || base === 'bottle' || base === 'spray' || base === 'pro';
  }

  function isCatalyzedAllowedBase(base){
    return !!(base && CATALYZED_ALLOWED_BASES[base]);
  }

  function getColorProductBaseMap(){
    var raw = null;
    if (getColorProductBaseMap.cache) return getColorProductBaseMap.cache;
    try {
      raw = window.paintscratchTheme && window.paintscratchTheme.psColorProductBaseMap
        ? window.paintscratchTheme.psColorProductBaseMap
        : null;
    } catch (_e) {
      raw = null;
    }
    if (raw && typeof raw === 'object') {
      getColorProductBaseMap.cache = raw;
      return raw;
    }
    getColorProductBaseMap.cache = {
      pen: 'pen',
      'pen-tricoat': 'pen',
      'touch-up-paint-pen': 'pen',
      bottle: 'bottle',
      'bottle-tricoat': 'bottle',
      'touch-up-paint-bottle-2oz': 'bottle',
      spray: 'spray',
      'spray-tricoat': 'spray',
      'touch-up-paint-spray-can': 'spray',
      pro: 'pro',
      'pro-tricoat': 'pro',
      'touch-up-paint-pro-gallon': 'pro',
      'kit-pen': 'pen',
      'kit-pen-tricoat': 'pen',
      'touch-up-paint-kit-pen': 'pen',
      'kit-bottle': 'bottle',
      'kit-bottle-tricoat': 'bottle',
      'touch-up-paint-kit-bottle': 'bottle',
      'kit-spray': 'spray',
      'kit-spray-tricoat': 'spray',
      'touch-up-paint-kit-spray': 'spray'
    };
    return getColorProductBaseMap.cache;
  }

  function getCustomColorRouteHandleMap(){
    var raw = null;
    if (getCustomColorRouteHandleMap.cache) return getCustomColorRouteHandleMap.cache;
    try {
      raw = window.paintscratchTheme && window.paintscratchTheme.psCustomColorRouteHandles
        ? window.paintscratchTheme.psCustomColorRouteHandles
        : null;
    } catch (_e) {
      raw = null;
    }
    if (raw && typeof raw === 'object') {
      getCustomColorRouteHandleMap.cache = raw;
      return raw;
    }
    getCustomColorRouteHandleMap.cache = {
      pro: true,
      'pro-tricoat': true,
      spray: true,
      'spray-tricoat': true,
      bottle: true,
      'bottle-tricoat': true,
      pen: true,
      'pen-tricoat': true,
      'kit-pen': true,
      'kit-bottle': true,
      'kit-spray': true,
      'kit-pen-tricoat': true,
      'kit-bottle-tricoat': true,
      'kit-spray-tricoat': true
    };
    return getCustomColorRouteHandleMap.cache;
  }

  function extractProductLookupToken(raw){
    var s = String(raw || '').toLowerCase();
    var parts = null;
    if (!s) return '';
    if (s.indexOf('shopify://products/') > -1) {
      return s.split('shopify://products/').pop().split('?')[0].split('#')[0].split('/')[0];
    }
    if (s.indexOf('/products/') > -1) {
      return s.split('/products/').pop().split('?')[0].split('#')[0].split('/')[0];
    }
    if (s.indexOf('/colors/') > -1) {
      parts = s.split('/colors/').pop().split('?')[0].split('#')[0].split('/');
      if (parts.length > 2) return parts[2];
    }
    s = s.split('?')[0].split('#')[0];
    s = s.replace(/^\/+/, '').replace(/\/+$/, '');
    if (s.indexOf('/') > -1) {
      parts = s.split('/');
      s = parts[parts.length - 1];
    }
    return s;
  }

  function baseSlugFromValue(raw){
    var token = extractProductLookupToken(raw);
    var map = getColorProductBaseMap();
    if (token && map[token]) return map[token];
    if (isKnownProductBase(token)) return token;
    return '';
  }

  function getCurrentProductBase(payload, form){
    var byForm = "";
    var byPayload = baseSlugFromValue(payload && payload.product_slug);
    byForm = findLocalProductBase(form);
    if (byForm) return byForm;
    if (byPayload) return byPayload;
    try {
      var path = window.location && window.location.pathname ? String(window.location.pathname) : '';
      if (isPathWithProductSlug(path)) {
        var byPath = baseSlugFromValue(splitPathToken(path) || path);
        if (byPath) return byPath;
      }
      var m = path.match(/\/products\/(pen|bottle|spray|pro)(?:-tricoat)?\b/i);
      if (m && m[1]) return String(m[1]).toLowerCase();
    } catch (_e) {}
    return '';
  }

  function buildSprayOnlyUrl(payload){
    var cc = readPsCc();
    var ms = (payload && payload.make_slug) || cc.make_slug || '';
    var cs = (payload && payload.color_slug) || cc.color_slug || '';
    if (ms && cs) return '/colors/' + ms + '/' + cs + '/spray';
    return '/products/spray';
  }

  function isColorProductRoute(){
    var path = '';
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      path = '';
    }
    return path.indexOf('/colors/') === 0;
  }

  function findDynamicCheckoutNearForm(form){
    if (!form) return null;
    var root = null;
    try {
      root = form.closest ? form.closest('product-form') : null;
    } catch (_e) {}
    if (!root) root = form;
    var local = root.querySelector('.shopify-payment-button');
    if (local) return local;
    var parent = form.parentNode;
    if (parent && parent.querySelector) {
      var siblingLocal = parent.querySelector('.shopify-payment-button');
      if (siblingLocal) return siblingLocal;
    }
    return null;
  }

  // ------------------------ Collection helpers (tricoat toggle) ------------------------
  function resolveSectionFromHook(hook){
    var sec = null;
    var hookSection = hook && hook.closest ? hook.closest('section') : null;
    if (hookSection && hookSection.nextElementSibling) sec = hookSection.nextElementSibling;
    if (!sec && hook && hook.parentNode && hook.parentNode.nextElementSibling) {
      var sib = hook.parentNode.nextElementSibling;
      if (sib.tagName && sib.tagName.toLowerCase() === 'section') sec = sib;
    }
    if (sec && (!sec.tagName || sec.tagName.toLowerCase() !== 'section')) sec = null;
    return sec;
  }

  function findCollectionPairs(){
    var hooks = document.querySelectorAll('.ps-collection-hook[data-ps-collection]');
    var out = [], i, hook, type, sec;
    for (i = 0; i < hooks.length; i++){
      hook = hooks[i];
      type = hook.getAttribute('data-ps-collection') || '';
      sec = resolveSectionFromHook(hook);
      if (sec) out.push({ type: type, el: sec });
    }
    return out;
  }

  function setHidden(el, hide){
    if (!el) return;
    if (hide){
      el.setAttribute('data-ps-collection-hidden','');
      el.setAttribute('aria-hidden','true');
      el.style.display = 'none';
    } else {
      el.removeAttribute('data-ps-collection-hidden');
      el.setAttribute('aria-hidden','false');
      el.style.display = '';
    }
  }

// ------------------------ Cart helpers ------------------------
// Replace [MAKE] [COLOR] [CODE] tokens in cart notification/drawer using line item properties.
function psReplaceInRoot(root, map){
  if (!root) return;
  var sels = [
    '.cart-item__name a',
    '.cart-item__name',
    '.cart-notification-product__name',
    '.cart-notification__heading',
    '.cart-item__details a',
    '.product-option',
    'h3','h2'
  ];
  for (var s = 0; s < sels.length; s++){
    var nodes = root.querySelectorAll(sels[s]);
    for (var i = 0; i < nodes.length; i++){
      var el = nodes[i];
      var txt = (el.textContent || '');
      if (!txt || txt.indexOf('[') === -1) continue;
      var out = txt.replace(/\[MAKE\]/g, map['[MAKE]'])
                   .replace(/\[COLOR\]/g, map['[COLOR]'])
                   .replace(/\[CODE\]/g, map['[CODE]']);
      if (out !== txt){
        if (el.firstChild && el.firstChild.nodeType === 3 && el.childNodes.length === 1){
          el.firstChild.nodeValue = out;
        } else {
          el.textContent = out;
        }
      }
    }
  }
}
function psReplaceCartPlaceholders(props){
  props = props || {};
  var map = {
    '[MAKE]': props['Make'] || '',
    '[COLOR]': props['Color Name'] || props['Color'] || '',
    '[CODE]': props['Color Code'] || props['Code'] || ''
  };
  var roots = [];
  var r1 = document.getElementById('cart-notification'); if (r1) roots.push(r1);
  var r2 = document.querySelector('cart-notification, .cart-notification'); if (r2 && roots.indexOf(r2) === -1) roots.push(r2);
  var r3 = document.getElementById('CartDrawer'); if (r3) roots.push(r3);
  var r4 = document.querySelector('cart-drawer, .cart-drawer'); if (r4 && roots.indexOf(r4) === -1) roots.push(r4);
  for (var i = 0; i < roots.length; i++) psReplaceInRoot(roots[i], map);
}

function psSetAgentCartAddSuccess(items){
  var item = items && items[0] ? items[0] : null;
  var props = item && item.properties ? item.properties : {};
  var detail = '';
  if (!document || !document.body) return;
  detail = [
    'Product: ' + (props['Product'] || props['_ps_product_slug'] || ''),
    'Color Code: ' + (props['Color Code'] || ''),
    'Color Name: ' + (props['Color Name'] || ''),
    'Make: ' + (props['Make'] || ''),
    'Year: ' + (props['Year'] || ''),
    'Model: ' + (props['Model'] || '')
  ].join(' | ');
  document.body.setAttribute('data-ps-agent-cart-add-success', 'true');
  document.body.setAttribute('data-ps-agent-cart-add-summary', detail);
}

function currentSectionsUrl(){ return window.location.pathname; }

  function currentSectionId(form){
    var input = form && form.querySelector('input[name="section-id"]');
    if (input && input.value) return String(input.value);
    var el = form;
    while (el && el.nodeType === 1){
      if (el.id && /^shopify-section-/.test(el.id)) return el.id.replace(/^shopify-section-/, '');
      el = el.parentNode;
    }
    return '';
  }

  function applySections(map){
    if(!map) return;

    function replaceByIdOrInject(key, html){
      var did = false;
      var cur = document.getElementById('shopify-section-' + key);
      if(cur){
        try{
          var tmp = document.createElement('div');
          tmp.innerHTML = String(html || '');
          var fresh = tmp.firstElementChild;
          if(fresh) cur.parentNode.replaceChild(fresh, cur);
          else cur.outerHTML = String(html || '');
          did = true;
        }catch(_e){}
      }
      if(did) return true;

      if(key === 'cart-notification-product'){
        var productTarget =
          document.querySelector('[data-cart-notification-product]') ||
          document.querySelector('#cart-notification-product') ||
          document.querySelector('.cart-notification-product, .cart-notification__product');
        if(productTarget){ productTarget.innerHTML = String(html || ''); did = true; }
      }else if(key === 'cart-notification-button'){
        var linksTarget =
          document.querySelector('[data-cart-notification-button]') ||
          document.querySelector('#cart-notification-button') ||
          document.querySelector('.cart-notification__links, .notification__links');
        if(linksTarget){ linksTarget.innerHTML = String(html || ''); did = true; }
      }else if(key === 'cart-icon-bubble'){
        var bubbleWrap = document.getElementById('shopify-section-cart-icon-bubble') ||
                         document.querySelector('.header__icon--cart, [data-cart-icon-bubble]');
        if(bubbleWrap){
          try{
            var c = document.getElementById('shopify-section-cart-icon-bubble');
            if(c){
              var t2 = document.createElement('div'); t2.innerHTML = String(html || '');
              var f2 = t2.firstElementChild;
              if(f2) c.parentNode.replaceChild(f2, c); else c.outerHTML = String(html || '');
            }else{
              bubbleWrap.innerHTML = String(html || '');
            }
            did = true;
          }catch(_e){}
        }
      }
      return did;
    }

    for(var key in map){
      if(!map.hasOwnProperty(key)) continue;
      replaceByIdOrInject(key, map[key]);
    }

    try{
      var root = document.getElementById('cart-notification') ||
                 (document.querySelector('cart-notification') || document);
      var linksWrap = root.querySelector('.cart-notification__links, .notification__links');
      if(linksWrap){
        var hasLink = !!linksWrap.querySelector('a, button[type="button"][data-href]');
        if(!hasLink){
          var holder = document.getElementById('shopify-section-cart-notification-button');
          var label = (holder && holder.textContent ? holder.textContent.trim() : '') || 'View cart';
          var a = document.createElement('a');
          a.href = '/cart';
          a.className = 'button button--primary';
          a.textContent = label;
          linksWrap.innerHTML = '';
          linksWrap.appendChild(a);
        }
      }
    }catch(_e){}
  }

  function limitNotificationToAddedItems(items){
    if(!items || !items.length) return;
    var ids = {};
    for(var i=0;i<items.length;i++){
      var id = String(items[i] && items[i].id || '').trim();
      if(id) ids[id] = 1;
    }
    var root = document.getElementById('cart-notification') ||
               (document.querySelector('cart-notification') || document);
    var list = root.querySelector('#cart-notification-product, .cart-notification-product, .cart-notification__product');
    if(!list) return;
    var rows = list.querySelectorAll('[id^="cart-notification-product-"], .cart-item');
    for(var r=0; r<rows.length; r++){
      var row = rows[r];
      var vid = '';
      if(row.id){
        var m = row.id.match(/cart-notification-product-(\d+)/);
        if(m) vid = m[1];
      }
      if(!vid){ vid = row.getAttribute && row.getAttribute('data-variant-id') || ''; }
      if(vid && ids[vid]) continue;
      if(!vid && items.length === 1) continue;
      try{ row.parentNode.removeChild(row); }catch(_e){}
    }
  }

  function openCartNotificationPanel(){
    var panel = document.getElementById('cart-notification');
    if (!panel || !panel.classList) return false;
    if (panel.style && panel.style.removeProperty) {
      panel.style.removeProperty('top');
    }
    panel.classList.add('animate');
    panel.classList.add('active');
    return true;
  }

  function cartNotificationHasContent(){
    var panel = document.getElementById('cart-notification');
    var product;
    if (!panel || !panel.querySelector) return false;
    product = panel.querySelector('#cart-notification-product, .cart-notification-product, .cart-notification__product');
    if (!product) return false;
    return !!String(product.textContent || '').replace(/\s+/g, '');
  }

  function ensureCartNotificationVisible(){
    var panel = document.getElementById('cart-notification');
    if (!panel || !panel.classList || panel.classList.contains('active')) return;
    if (!cartNotificationHasContent()) return;
    openCartNotificationPanel();
  }

  function openCartUI(){
    try{
      var notif = document.querySelector('cart-notification');
      if (notif && typeof notif.open === 'function'){ notif.open(); return; }
      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined('cart-notification').then(function(){
          var readyNotif = document.querySelector('cart-notification');
          if (readyNotif && typeof readyNotif.open === 'function') {
            readyNotif.open();
            return;
          }
          openCartNotificationPanel();
        });
        setTimeout(function(){
          var panel = document.getElementById('cart-notification');
          if (!panel || !panel.classList || panel.classList.contains('active')) return;
          openCartNotificationPanel();
        }, 250);
        return;
      }
      if (openCartNotificationPanel()) return;
      if (notif){ try{ notif.classList.add('is-visible'); }catch(_e){} }
    }catch(_e){}
    var triggers = [
      '[data-cart-drawer-toggle]',
      '[data-action="open-cart"]',
      '[aria-controls="CartDrawer"]',
      'button.cart-toggle',
      '.header__icon--cart a, .header__icon--cart button'
    ];
    for (var i=0;i<triggers.length;i++){
      var t = document.querySelector(triggers[i]);
      if (t){ try{ t.click(); return; }catch(_e){} }
    }
  }

  function pluralizeNotificationIfNeeded(itemCount){
    if (itemCount <= 1) return;
    var root = document.getElementById('shopify-section-cart-notification') ||
               document.querySelector('cart-notification, .cart-notification');
    if (!root) return;
    var heading = root.querySelector('[data-notification-heading], .cart-notification__heading, .notification__heading, h2, h3');
    if (!heading) return;
    var txt = (heading.textContent || '').trim();
    if (/item added/i.test(txt)) heading.textContent = 'Items added to your cart';
  }

  function renderAddedItems(resp, items){
    var propsForTokens = {};
    if (resp && resp.sections) applySections(resp.sections);
    try {
      propsForTokens = (items && items[0] && items[0].properties) || {};
      psReplaceCartPlaceholders(propsForTokens);
    } catch(_e){}
    try { psSetAgentCartAddSuccess(items); } catch(_eAgentMarker){}
    limitNotificationToAddedItems(items);
    if (items && items.length > 1) pluralizeNotificationIfNeeded(items.length);
    openCartUI();
    setTimeout(ensureCartNotificationVisible, 100);
    setTimeout(ensureCartNotificationVisible, 500);
    setTimeout(function(){ try{ psReplaceCartPlaceholders(propsForTokens); }catch(_e){} }, 50);
  }

  function addItemsAndRender(items, sectionId, done, opts){
    var options = opts || {};
    var completed = false;
    var integrityResult = null;
    var payload = {
      items: items,
      sections: CONFIG.cartSections.join(','),
      sections_url: currentSectionsUrl()
    };
    if (options.integrityForm) {
      integrityResult = validateCustomColorIntegrity(options.integrityForm, options.integrityData || {});
      if (!integrityResult.ok) {
        var integrityError = new Error('We could not confirm your vehicle and paint details. Please choose your vehicle again and retry.');
        integrityError.psIntegrityFailure = true;
        integrityError.psIntegrityReason = integrityResult.reason;
        if (done) done(integrityError, null);
        return;
      }
    }
    if (sectionId) payload['section-id'] = sectionId;

    function finishRequest(err, result){
      if (completed) return;
      completed = true;
      if (err) trackCustomColorFunnel('cart_failure', { product_type: funnelProductTypeFromItems(items), outcome: 'failure' });
      if (done) done(err || null, result || null);
    }

    function finishTransportFailure(message){
      var err = new Error(message);
      err.psNoNativeFallback = true;
      finishRequest(err);
    }

    if (typeof options.beforeSend === 'function') {
      var approved = false;
      try { approved = options.beforeSend(items) === true; } catch (_eBeforeSend) {}
      if (!approved) {
        var changed = new Error('The repair basket changed. Review the current items before adding again.');
        changed.psRepairPlanPreflightRejected = true;
        finishRequest(changed);
        return;
      }
    }
    trackCustomColorFunnel('cart_request', { product_type: funnelProductTypeFromItems(items), outcome: 'requested' });

    var xhr = new XMLHttpRequest();
    xhr.open('POST','/cart/add.js',true);
    xhr.timeout = 10000;
    xhr.setRequestHeader('Content-Type','application/json; charset=UTF-8');
    xhr.setRequestHeader('Accept','application/json');
    xhr.onreadystatechange = function(){
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300){
        var resp = null;
        try { resp = JSON.parse(xhr.responseText || '{}'); } catch(e){ resp = {}; }
        if (options.requireCompleteItems) {
          var returned = resp && resp.items;
          var complete = Array.isArray(returned) && items.every(function(expected){
            return returned.some(function(actual){ return String(actual.variant_id || actual.id) === String(expected.id) && Number(actual.quantity) >= expected.quantity; });
          });
          if (!complete) {
            finishTransportFailure('We could not confirm every selected product in the cart.');
            return;
          }
        }
        trackCustomColorFunnel('cart_success', { product_type: funnelProductTypeFromItems(items), outcome: 'success' });
        if (options.quickAddModal && typeof options.quickAddModal.hide === 'function') {
          document.body.addEventListener('modalClosed', function () {
            renderAddedItems(resp, items);
            finishRequest(null, { parsed: resp });
          }, { once: true });
          options.quickAddModal.hide(true);
          return;
        }

        renderAddedItems(resp, items);
        finishRequest(null, { parsed: resp });
      } else {
        var err;
        try {
          var j = JSON.parse(xhr.responseText||'{}');
          err = new Error(j && j.description ? j.description : ('add.js ' + xhr.status));
          err.payload = j;
        } catch(e2){
          err = new Error('add.js ' + xhr.status);
        }
        finishRequest(err);
      }
    };
    xhr.onerror = function(){ finishTransportFailure('Unable to add this item to your cart.'); };
    xhr.ontimeout = function(){ finishTransportFailure('The cart request timed out. Please try again.'); };
    xhr.send(JSON.stringify(payload));
  }

  // ------------------------ PDP Controller ------------------------
  PS.PDP = {
    atcBtn: null,
    atcForm: null,
    _bound: false,
    _onAtcHandler: null,
    _years: [],
    _factoryCodes: [],
    _lastPayload: null,
    _collectionPairs: [],
    _isCatalyzedOnly: false,
    _isSprayProduct: false,
    _currentProductBase: '',
    _catalyzedListenerBound: false,
    _colorContextListenerBound: false,
    _modalProductContext: null,
    _cartRequestInFlight: false,
    _atcFlowInFlight: false,
    _repairPlanRequest: null,
    _repairPlanInFlight: false,
    _vehicleModalSession: 0,

    init: function(){
      var payload = {};
      // Prefer the primary PDP buy button, not quick-add card buttons.
      this.atcBtn = document.querySelector('product-form .product-form__submit');
      if (!this.atcBtn) {
        this.atcBtn = document.querySelector('product-form [type="submit"], form[action*="/cart/add"] [type="submit"]');
      }
      if (!this.atcBtn) return false;
      var pf = this.atcBtn.closest && this.atcBtn.closest('product-form');
      this.atcForm = pf ? pf.querySelector('form') : null;
      if (!this.atcForm) this.atcForm = document.querySelector('form[action*="/cart/add"]');

      var ssr = (PS.ssr && PS.ssr()) || null;
      var ssrRaw = (typeof window !== 'undefined' && window.PS_SSR && typeof window.PS_SSR === 'object')
        ? window.PS_SSR
        : null;

      payload = mergePayload(ssrRaw || {}, ssr || {});
      this._lastPayload = mergePayload(payload, this._lastPayload || {});
      syncControllerPayload(this, this._lastPayload || {});
      hydrateVehicleConfirmation();

      bindPdpColorContextListener();
      this._catalyzedListenerBound = true;

      this._collectionPairs = findCollectionPairs();
      this.toggleCollectionsByFlag(!!(this._lastPayload && this._lastPayload.is_tricoat));

      // PS - Kit Options Init
      this._initKits();

      if (!this._bound){
        this._bindYearGate();
        this._bound = true;
      }
      return true;
    },

    rememberColorContext: function(detail){
      var d = detail && typeof detail === 'object' ? detail : {};
      var nextPayload = mergePayload(this._lastPayload || {}, d);
      syncControllerPayload(this, nextPayload);
      hydrateVehicleConfirmation();
      if (d.hasOwnProperty('is_tricoat')) {
        this.toggleCollectionsByFlag(!!d.is_tricoat);
      }
    },

    _captureModalProductContext: function(form, btn){
      var image = null;
      var name = '';
      var variantName = '';
      var context = null;
      if (btn) context = readModalContextFromKitSelection(btn);
      if (!context && form) context = readModalContextFromKitSelection(form);
      if (context && context.src) {
        if (!context.name) {
          context.name = modalContextNameFromSlug((this._lastPayload && this._lastPayload.product_slug) || '');
          if (!context.name) context.name = readModalContextNameFromPathname((window.location && window.location.pathname) ? window.location.pathname : '');
          if (!context.name) context.name = readModalContextNameFromDocument();
        }
        this._modalProductContext = context;
        return this._modalProductContext;
      }
      if (btn) image = findModalContextImageFromNode(btn);
      if (!image && form) image = findModalContextImageFromNode(form);
      if (btn) variantName = readModalContextVariantNameFromNode(btn);
      if (!variantName && form) variantName = readModalContextVariantNameFromNode(form);
      if (btn) name = readModalContextNameFromNode(btn);
      if (!name && form) name = readModalContextNameFromNode(form);
      if (!name) name = modalContextNameFromSlug((this._lastPayload && this._lastPayload.product_slug) || '');
      if (!name && form && form.getAttribute) name = modalContextNameFromSlug(form.getAttribute('data-ps-product-base') || '');
      if (!name) name = readModalContextNameFromPathname((window.location && window.location.pathname) ? window.location.pathname : '');
      if (!name) name = readModalContextNameFromDocument();
      if (variantName) name = variantName;
      if (image && image.src) {
        context = {
          src: image.src,
          alt: image.alt,
          width: image.width,
          height: image.height,
          name: name
        };
      }
      this._modalProductContext = context;
      return this._modalProductContext;
    },

    _clearModalProductContext: function(){
      this._modalProductContext = null;
    },

    _getModalProductContextHtml: function(){
      var context = this._modalProductContext;
      var sizeAttrs = '';
      var nameHtml = '';
      if (!context || !context.src) return '';
      if (context.width > 0) sizeAttrs += ' width="' + String(context.width) + '"';
      if (context.height > 0) sizeAttrs += ' height="' + String(context.height) + '"';
      if (context.name) {
        nameHtml =
          '<div class="psm-product-context__copy">' +
            '<span class="psm-product-context__name">' + escapeHtml(context.name) + '</span>' +
          '</div>';
      }
      return '' +
        '<div class="psm-product-context">' +
          '<div class="psm-product-context__image-wrap">' +
            '<img class="psm-product-context__image" src="' + escapeHtml(context.src) + '" alt="' + escapeHtml(context.alt) + '"' + sizeAttrs + '>' +
          '</div>' +
          nameHtml +
        '</div>';
    },

    _initKits: function() {
      var self = this;
      var inputs = document.querySelectorAll('.ps-kit-input');
      if (!inputs.length) return;

      // PS - Patch: Inject styled HTML for 1st option (Title + Description)
      // Note: Price is now handled by the Liquid template in a separate column.
      try {
        var firstInput = inputs[0];
        var firstRow = firstInput.closest('.ps-kit-row');
        if (firstRow) {
          var textTarget = firstRow.querySelector('.ps-kit-text-target');
          if (textTarget) {
            var payload = self._lastPayload || (typeof window.PS_SSR !== 'undefined' ? window.PS_SSR : {});
            var colorName = payload.color || '';
            // Tricoat check: strictly check payload or fallback to generic regex on existing text if needed
            var isTricoat = /tricoat/i.test(colorName);
            // PS Patch: Force simple title without product slug prefix
            var titleText = isTricoat ? 'Paint Only (Tricoat)' : 'Paint Only';
            var descText = isTricoat
              ? 'Includes the color-matched basecoat and midcoat. Apply basecoat first, then midcoat, then clearcoat when the finish calls for it.'
              : 'Color-matched paint for the selected finish. Add primer, clearcoat, or polishing supplies only when the repair and finish call for them.';

            textTarget.innerHTML = 
              '<div class="ps-kit-title">' + titleText + '</div>' + 
              '<div class="ps-kit-desc">' + descText + '</div>';
          }
        }
      } catch (_e) {}

      // 1. Capture Original Main Image
      var mainMedia = document.querySelector('.product__media img');
      var originalSrc = mainMedia ? (mainMedia.currentSrc || mainMedia.src) : null;

      // 1b. Capture Modal Hero Image (Fix for mobile modal showing wrong image)
      var modalHeroImg = document.querySelector('.product-media-modal__content img');
      var originalModalSrc = modalHeroImg ? (modalHeroImg.currentSrc || modalHeroImg.src) : null;

      // 2. Capture Original Thumbnail Image (The first one in the list)
      var firstThumbImg = document.querySelector('.thumbnail-list__item:first-child img') || 
                          document.querySelector('.product__media-toggle:first-child img');
      var originalThumbSrc = firstThumbImg ? (firstThumbImg.getAttribute('data-ps-src') || firstThumbImg.currentSrc || firstThumbImg.src) : null;
      var originalThumbSrcset = firstThumbImg ? (firstThumbImg.getAttribute('data-ps-srcset') || firstThumbImg.getAttribute('srcset')) : null;

      // Helper: Reset gallery to view the first image (Hero)
      function resetGalleryToHero() {
        var firstThumbBtn = document.querySelector('.thumbnail-list__item button') || 
                            document.querySelector('.product__media-toggle');
        if (firstThumbBtn) {
          firstThumbBtn.click();
          return;
        }
        var slider = document.querySelector('.product__media-list') || 
                     document.querySelector('.slider.product__media');
        if (slider && slider.scrollTo) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }

      function onKitChange() {
        var checked = document.querySelector('.ps-kit-input:checked');
        if (!checked) return;

        // --- Visual Selection State ---
        var rows = document.querySelectorAll('.ps-kit-row');
        for (var i = 0; i < rows.length; i++) rows[i].classList.remove('is-selected');
        var activeRow = checked.closest('.ps-kit-row');
        if (activeRow) activeRow.classList.add('is-selected');

        // --- Swap Text Content ---
        var descContent = activeRow ? activeRow.querySelector('.ps-kit-desc-content') : null;
        var mainDesc = document.getElementById('ps-description-container');
        if (descContent && mainDesc) {
          mainDesc.innerHTML = descContent.innerHTML;
        }

        // --- Swap Images (Main + Thumbnail) ---
        var newImg;
        if (checked.value === '0' && originalSrc) {
             newImg = originalSrc;
        } else {
             newImg = checked.getAttribute('data-img');
        }

        // Update Main Hero
        if (newImg && mainMedia) {
          mainMedia.src = newImg;
          mainMedia.removeAttribute('srcset'); 
        }

        // Update Modal Hero (Mobile Fix)
        if (modalHeroImg) {
          if (checked.value === '0' && originalModalSrc) {
             modalHeroImg.src = originalModalSrc;
          } else if (newImg) {
             modalHeroImg.src = newImg;
          }
          modalHeroImg.removeAttribute('srcset');
        }

        // Update First Thumbnail (to match the Hero)
        if (firstThumbImg) {
          if (checked.value === '0' && originalThumbSrc) {
             firstThumbImg.src = originalThumbSrc;
             firstThumbImg.setAttribute('data-ps-src', originalThumbSrc);
             if (originalThumbSrcset) {
               firstThumbImg.setAttribute('srcset', originalThumbSrcset);
               firstThumbImg.setAttribute('data-ps-srcset', originalThumbSrcset);
             } else {
               firstThumbImg.removeAttribute('srcset');
               firstThumbImg.removeAttribute('data-ps-srcset');
             }
          } else if (newImg) {
             firstThumbImg.src = newImg;
             firstThumbImg.setAttribute('data-ps-src', newImg);
             firstThumbImg.removeAttribute('data-ps-srcset');
             firstThumbImg.removeAttribute('srcset');
          }
        }

        // Force view back to the Hero image
        if (newImg) resetGalleryToHero();

        // --- Update Price ---
        var newPrice = checked.getAttribute('data-price-text');
        if (newPrice) {
          var container = document.querySelector('.product__info-container') || document.querySelector('.product-single__meta') || document;
          var priceEls = container.querySelectorAll('.price-item--regular, .price-item--sale');
          for (var p = 0; p < priceEls.length; p++) {
             priceEls[p].textContent = newPrice;
          }
        }
      }
      
      // Bind listeners
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('change', onKitChange);
        var row = inputs[i].closest('.ps-kit-row');
        if (row) {
          row.addEventListener('click', function(e) {
            if (e.target.type !== 'radio') {
               var inp = this.querySelector('input');
               if(inp && !inp.checked) { inp.checked = true; onKitChange(); }
            }
          });
        }
      }
      
      // Trigger initial state carefully
      var checked = document.querySelector('.ps-kit-input:checked');
      if(checked) {
          var row = checked.closest('.ps-kit-row');
          var descContent = row ? row.querySelector('.ps-kit-desc-content') : null;
          var mainDesc = document.getElementById('ps-description-container');
          if (descContent && mainDesc) mainDesc.innerHTML = descContent.innerHTML;
          
          var newPrice = checked.getAttribute('data-price-text');
          if (newPrice) {
            var container = document.querySelector('.product__info-container') || document;
            var priceEls = container.querySelectorAll('.price-item--regular, .price-item--sale');
            for (var p = 0; p < priceEls.length; p++) priceEls[p].textContent = newPrice;
          }
      }
    },

    _getKitExtras: function() {
       var checked = document.querySelector('.ps-kit-input:checked');
       if (!checked) return [];
       var str = checked.getAttribute('data-kit-ids') || '';
       if (!str) return [];

       // Sync quantity with the main product form
       var qty = 1;
       if (this.atcForm) {
         qty = readQuantityNear(this.atcForm);
       }

       var ids = str.split(',');
       var extras = [];
       for (var i=0; i<ids.length; i++) {
         var clean = parseInt(ids[i], 10);
         if (clean) extras.push({ id: clean, quantity: qty });
       }
       return extras;
    },

    _getClearcoatVariantId: function() {
      var container = document.querySelector('.ps-kit-options-container');
      if (!container) return 0;
      return parseInt(container.getAttribute('data-ps-cc-vid'), 10) || 0;
    },

    _kitHasClearcoat: function() {
      var ccVid = this._getClearcoatVariantId();
      if (!ccVid) return false;
      var checked = document.querySelector('.ps-kit-input:checked');
      if (!checked) return false;
      var ids = (checked.getAttribute('data-kit-ids') || '').split(',');
      for (var i = 0; i < ids.length; i++) {
        if (parseInt(ids[i], 10) === ccVid) return true;
      }
      return false;
    },

    _openVehicleDetailsModal: function(doneCb, options){
      var self = this;
      var yearOptions = (this._years && this._years.length) ? this._years.slice(0) : staticYearOptions();
      var initialYear = options && options.initialYear ? String(options.initialYear) : '';
      var initialModel = options && options.initialModel ? String(options.initialModel) : '';
      var requiredMsg = (options && options.requiredMsg) ? options.requiredMsg : 'Please select a year';
      var vehicleLookup = resolveVehicleLookupContext(self.atcForm, self._lastPayload || {});
      var productContextHtml = self._getModalProductContextHtml();
      var vehicleModalClass = 'ps-modal--vehicle-details' + (productContextHtml ? ' ps-modal--with-product-context' : '');
      var vehicleModalState = { modelOptions: [], modelLoading: false, modelLookupFailed: false };
      var vehicleModalSession = beginVehicleModalSession(self);
      var vehicleModalAttempt = { opened: false };
      var modalFactoryOptions = options && options.factoryOptions && options.factoryOptions.slice ? options.factoryOptions.slice(0) : ((this._factoryCodes && this._factoryCodes.length) ? this._factoryCodes.slice(0) : []);
      var factoryInput = self.atcForm && self.atcForm.querySelector ? self.atcForm.querySelector('input[name="properties[' + FACTORY_PROP_KEY + ']"]') : null;
      var currentFactoryCode = trimPropValue(factoryInput && factoryInput.value);
      var cc = readPsCc();
      if (!currentFactoryCode) currentFactoryCode = resolveScopedCookieFactoryCode(cc, self._lastPayload || {}, modalFactoryOptions);

      function resolveAllowedVehicleModel(rawModel){
        return resolveVehicleModelFromOptions(rawModel, vehicleModalState.modelOptions);
      }

      function getVehicleModalNextAction(yearValue){
        var selectedYear = parseInt(String(yearValue || ''), 10) || 0;
        var singleStageYear = (window.paintscratchTheme && window.paintscratchTheme.psSingleStageYear) || 0;
        return resolveVehicleModalAction({
          isCustom: true,
          yearValid: !!selectedYear,
          factoryRequired: !!modalFactoryOptions.length,
          factoryValid: !!resolveAllowedFactoryCode(currentFactoryCode, modalFactoryOptions),
          formulaRequired: !!(singleStageYear && selectedYear && selectedYear < singleStageYear)
        });
      }

      if (!(PS.Modal && PS.Modal.open)) {
        var retryCount = options && options.retryCount ? parseInt(String(options.retryCount), 10) : 0;
        if (retryCount < 2) {
          setTimeout(function(){
            var nextOptions = options || {};
            nextOptions.retryCount = retryCount + 1;
            self._openVehicleDetailsModal(doneCb, nextOptions);
          }, 100);
          return;
        }
        if (self && typeof self.enable === 'function') self.enable();
        setFormErrorMessage(self.atcForm, 'Vehicle details are still loading. Please try again.');
        invalidateVehicleModalSession(self, vehicleModalSession);
        if (options && typeof options.onCancel === 'function') options.onCancel();
        return;
      }

      if (PS.Modal && PS.Modal.open) {
        PS.Modal.open({
          title: 'Enter Vehicle Details',
          okLabel: getVehicleModalNextAction(initialYear).label,
          okAriaLabel: getVehicleModalNextAction(initialYear).ariaLabel,
          hideCancel: true,
          modalClass: vehicleModalClass,
          contentClass: 'psm-content psm-vehicle-details',
          contentHtml:
            '<p class="psm-vehicle-copy">To ensure a color match, we\'ll need to know some information about your vehicle:</p>' +
            '<div class="psm-vehicle-field psm-vehicle-field--year">' +
              '<div class="psm-vehicle-combobox psm-vehicle-combobox--year" data-psm-combobox="year">' +
                '<input type="hidden" name="year" value="' + escapeHtml(initialYear) + '">' +
                '<input type="text" name="year_display" value="' + escapeHtml(initialYear) + '" class="psm-input psm-vehicle-combobox-input psm-vehicle-combobox-input--year psm-vehicle-year-input" placeholder="Select year (required)" autocomplete="off" inputmode="numeric" role="combobox" aria-label="Vehicle year" aria-autocomplete="list" aria-expanded="false" aria-controls="psm-vehicle-year-list" data-ps-agent-control="vehicle-year">' +
                '<button type="button" class="psm-vehicle-combobox-toggle" aria-label="Toggle year suggestions"></button>' +
                '<div id="psm-vehicle-year-list" class="psm-vehicle-model-list psm-vehicle-year-list" role="listbox" hidden></div>' +
              '</div>' +
            '</div>' +
            '<div class="psm-vehicle-field psm-vehicle-field--model">' +
              '<div class="psm-vehicle-combobox is-disabled" data-psm-combobox="model">' +
                '<input type="text" name="model" value="' + escapeHtml(initialModel) + '" class="psm-input psm-vehicle-combobox-input" placeholder="Select model" autocomplete="off" disabled role="combobox" aria-label="Vehicle model" aria-autocomplete="list" aria-expanded="false" aria-controls="psm-vehicle-model-list" data-ps-agent-control="vehicle-model">' +
                '<button type="button" class="psm-vehicle-combobox-toggle" aria-label="Toggle model suggestions" disabled></button>' +
                '<div id="psm-vehicle-model-list" class="psm-vehicle-model-list" role="listbox" hidden></div>' +
              '</div>' +
              '<div id="psm-vehicle-model-status" class="psm-vehicle-model-status" role="status" aria-live="polite" aria-atomic="true"></div>' +
            '</div>' +
            productContextHtml,
          onPrimaryBlocked: function(reason){
            var blockReason = 'missing_year';
            if (reason === 'Loading required vehicle choices') blockReason = 'models_loading';
            else if (reason === 'Vehicle models could not load. Retry to continue') blockReason = 'models_load_failed';
            else if (reason === 'Select a vehicle model to continue') blockReason = 'missing_model';
            trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: blockReason === 'missing_model' ? 'year,model' : 'year', modal_block_reason: blockReason });
          },
          onValidate: function(data){
            var chosenYear = trimPropValue(data.year);
            data.model = resolveAllowedVehicleModel(data.model);
            if (!chosenYear) {
              trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'year', modal_block_reason: 'missing_year' });
              return { ok:false, message: requiredMsg, focusSelector: 'input[name="year_display"]' };
            }
            if (vehicleModalState.modelLoading) {
              trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'year,model', modal_block_reason: 'models_loading' });
              return { ok:false, message: 'Vehicle models are still loading. Please wait.', focusSelector: 'input[name="model"]' };
            }
            if (vehicleModalState.modelLookupFailed) {
              trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'year,model', modal_block_reason: 'models_load_failed' });
              return { ok:false, message: 'Vehicle models could not load. Please retry.', focusSelector: 'input[name="model"]' };
            }
            if (vehicleModalState.modelOptions.length && !data.model) {
              trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'year,model', modal_block_reason: 'missing_model' });
              return { ok:false, message: 'Please select your vehicle model.', focusSelector: 'input[name="model"]' };
            }
            trackVehicleModalFunnel(self, 'vehicle_continue_clicked', { product_type: self._currentProductBase || '', outcome: 'clicked', modal_required_fields: vehicleModalState.modelOptions.length ? 'year,model' : 'year' });
            return { ok:true };
          },
          onOpen: function(modal){
            beginVehicleModalFunnel(self, vehicleModalAttempt, { product_type: self._currentProductBase || '', outcome: 'opened', modal_required_fields: 'year' });
            var yearValueEl = modal.formEl.querySelector('input[name="year"]');
            var yearEl = modal.formEl.querySelector('input[name="year_display"]');
            var yearComboEl = modal.formEl.querySelector('[data-psm-combobox="year"]');
            var yearClearEl = yearComboEl ? yearComboEl.querySelector('.psm-vehicle-combobox-clear') : null;
            var yearToggleEl = yearComboEl ? yearComboEl.querySelector('.psm-vehicle-combobox-toggle') : null;
            var yearListEl = modal.formEl.querySelector('#psm-vehicle-year-list');
            var modelEl = modal.formEl.querySelector('input[name="model"]');
            var comboEl = modal.formEl.querySelector('[data-psm-combobox="model"]');
            var clearEl = comboEl ? comboEl.querySelector('.psm-vehicle-combobox-clear') : null;
            var toggleEl = comboEl ? comboEl.querySelector('.psm-vehicle-combobox-toggle') : null;
            var listEl = modal.formEl.querySelector('#psm-vehicle-model-list');
            var hasInitialYear = false;
            var modelOptions = [];
            var requestId = 0;
            var isLoading = false;
            var isModelLoading = false;
            var slowTimer = null;
            var lastLoadedYear = '';
            var yearCombobox = null;
            var modelCombobox = null;
            var modelStatusEl = modal.formEl.querySelector('#psm-vehicle-model-status');

            function isCurrentModalSession(){
              return isVehicleModalSessionCurrent(self, vehicleModalSession, modal.root);
            }

            function isAllowedYear(val){
              var chosen = trimPropValue(val);
              var idx = 0;
              for (idx = 0; idx < yearOptions.length; idx++) {
                if (String(yearOptions[idx]) === chosen) return true;
              }
              return false;
            }

            function setExpanded(targetComboEl, targetInputEl, targetListEl, open){
              if (!targetComboEl || !targetInputEl || !targetListEl) return;
              targetInputEl.setAttribute('aria-expanded', open ? 'true' : 'false');
              if (open) targetComboEl.classList.add('is-open');
              else targetComboEl.classList.remove('is-open');
              targetListEl.hidden = !open;
            }

            function scrollOptionIntoView(targetListEl, optionEl){
              var top = 0;
              var bottom = 0;
              var viewBottom = 0;
              if (!targetListEl || !optionEl) return;
              top = optionEl.offsetTop;
              bottom = top + optionEl.offsetHeight;
              viewBottom = targetListEl.scrollTop + targetListEl.clientHeight;
              if (top < targetListEl.scrollTop) {
                targetListEl.scrollTop = top;
              } else if (bottom > viewBottom) {
                targetListEl.scrollTop = bottom - targetListEl.clientHeight;
              }
            }

            function syncClearButton(inputEl, clearButtonEl){
              var hasValue = false;
              if (!clearButtonEl) return;
              hasValue = !!trimPropValue(inputEl && inputEl.value);
              if (!hasValue || (inputEl && inputEl.disabled)) {
                clearButtonEl.style.display = 'none';
                clearButtonEl.setAttribute('aria-hidden', 'true');
                clearButtonEl.tabIndex = -1;
                return;
              }
              clearButtonEl.style.display = 'block';
              clearButtonEl.setAttribute('aria-hidden', 'false');
              clearButtonEl.tabIndex = 0;
            }

            function createVehicleCombobox(cfg){
              var activeIndex = -1;
              var searchQuery = '';

              function isOpen(){
                return !!(cfg.comboEl && cfg.comboEl.classList.contains('is-open'));
              }

              function getSelectedValue(){
                if (!cfg.getSelectedValue) return trimPropValue(cfg.inputEl && cfg.inputEl.value);
                return trimPropValue(cfg.getSelectedValue());
              }

              function getOptions(){
                var options = cfg.getOptions ? cfg.getOptions() : [];
                return options && options.slice ? options.slice(0) : [];
              }

              function setInputValue(nextValue){
                if (!cfg.inputEl) return;
                cfg.inputEl.value = String(nextValue || '');
                syncClearButton(cfg.inputEl, cfg.clearEl);
              }

              function closeList(){
                activeIndex = -1;
                searchQuery = '';
                setExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, false);
                cfg.inputEl.removeAttribute('aria-activedescendant');
                setInputValue(getSelectedValue());
              }

              function getFilteredOptions(){
                var options = getOptions();
                var filtered = [];
                var idx = 0;
                if (!searchQuery) return options;
                for (idx = 0; idx < options.length; idx++) {
                  if (cfg.filterOption(options[idx], searchQuery)) filtered.push(options[idx]);
                }
                return filtered;
              }

              function syncAriaSelection(optionsList){
                var nodes = cfg.listEl.querySelectorAll('[data-psm-combobox-value]');
                var idx = 0;
                if (!nodes.length) {
                  cfg.inputEl.removeAttribute('aria-activedescendant');
                  return;
                }
                if (activeIndex >= nodes.length) activeIndex = nodes.length - 1;
                for (idx = 0; idx < nodes.length; idx++) {
                  if (idx === activeIndex) nodes[idx].classList.add('is-active');
                  else nodes[idx].classList.remove('is-active');
                }
                if (activeIndex > -1 && optionsList[activeIndex]) {
                  cfg.inputEl.setAttribute('aria-activedescendant', cfg.optionIdPrefix + activeIndex);
                  scrollOptionIntoView(cfg.listEl, nodes[activeIndex]);
                } else {
                  cfg.inputEl.removeAttribute('aria-activedescendant');
                }
              }

              function renderList(openAfterRender){
                var filtered = getFilteredOptions();
                var selectedValue = getSelectedValue();
                var html = '';
                var idx = 0;
                var selectedIndex = -1;
                if (!cfg.listEl) return;
                if (!filtered.length) {
                  if (!searchQuery) {
                    cfg.listEl.innerHTML = '';
                    closeList();
                    return;
                  }
                  cfg.listEl.innerHTML = '<div class="psm-vehicle-model-empty">' + escapeHtml(cfg.emptyText) + '</div>';
                  activeIndex = -1;
                  cfg.inputEl.removeAttribute('aria-activedescendant');
                  if (openAfterRender) setExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, true);
                  return;
                }
                if (!searchQuery && selectedValue && activeIndex < 0) {
                  for (idx = 0; idx < filtered.length; idx++) {
                    if (String(filtered[idx]) === selectedValue) {
                      selectedIndex = idx;
                      break;
                    }
                  }
                  activeIndex = selectedIndex;
                } else if (activeIndex >= filtered.length) {
                  activeIndex = filtered.length - 1;
                }
                for (idx = 0; idx < filtered.length; idx++) {
                  html += '<button type="button" id="' + cfg.optionIdPrefix + idx + '" class="psm-vehicle-model-option' +
                    (String(filtered[idx]) === selectedValue ? ' is-selected' : '') + '" role="option" aria-selected="' +
                    (String(filtered[idx]) === selectedValue ? 'true' : 'false') + '" data-psm-combobox-value="' +
                    escapeHtml(filtered[idx]) + '" data-ps-agent-option="vehicle-option" data-ps-agent-value="' +
                    escapeHtml(filtered[idx]) + '">' + escapeHtml(filtered[idx]) + '</button>';
                }
                cfg.listEl.innerHTML = html;
                if (openAfterRender) setExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, true);
                syncAriaSelection(filtered);
              }

              function openList(){
                if (!cfg.inputEl || cfg.inputEl.disabled) return;
                if (!isOpen() && cfg.onOpen) cfg.onOpen();
                searchQuery = '';
                activeIndex = -1;
                renderList(true);
                try {
                  cfg.inputEl.focus();
                  if (trimPropValue(cfg.inputEl.value)) cfg.inputEl.select();
                } catch(_e) {}
              }

              function syncFromSelection(){
                activeIndex = -1;
                searchQuery = '';
                setInputValue(getSelectedValue());
                if (isOpen()) {
                  renderList(true);
                  return;
                }
                setExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, false);
                cfg.inputEl.removeAttribute('aria-activedescendant');
              }

              function clearValue(){
                searchQuery = '';
                activeIndex = -1;
                if (cfg.onClear) cfg.onClear();
                syncFromSelection();
                if (!cfg.inputEl.disabled) openList();
              }

              cfg.toggleEl.onclick = function(evt){
                if (evt && evt.preventDefault) evt.preventDefault();
                if (evt && evt.stopPropagation) evt.stopPropagation();
                if (cfg.inputEl.disabled) return;
                if (isOpen()) {
                  closeList();
                  return;
                }
                openList();
              };
              cfg.toggleEl.onmousedown = function(evt){
                if (evt && evt.preventDefault) evt.preventDefault();
              };

              cfg.inputEl.onfocus = function(){
                if (cfg.inputEl.disabled) return;
                openList();
              };

              cfg.inputEl.onclick = function(){
                if (cfg.inputEl.disabled) return;
                openList();
              };

              cfg.inputEl.oninput = function(){
                var nextQuery = String(cfg.inputEl.value || '');
                var result = null;
                if (cfg.inputEl.disabled) return;
                if (cfg.normalizeInput) {
                  nextQuery = cfg.normalizeInput(nextQuery);
                  if (cfg.inputEl.value !== nextQuery) cfg.inputEl.value = nextQuery;
                }
                searchQuery = nextQuery;
                activeIndex = -1;
                syncClearButton(cfg.inputEl, cfg.clearEl);
                if (cfg.onInput) {
                  result = cfg.onInput(nextQuery) || {};
                  if (typeof result.searchQuery !== 'undefined') searchQuery = String(result.searchQuery || '');
                  if (result.syncDisplay) {
                    syncFromSelection();
                    if (result.close) closeList();
                    return;
                  }
                  if (result.close) {
                    closeList();
                    return;
                  }
                }
                renderList(true);
              };

              cfg.inputEl.onblur = function(){
                window.setTimeout(function(){
                  var result = cfg.onBlur ? (cfg.onBlur() || {}) : {};
                  if (result.syncDisplay) syncFromSelection();
                  closeList();
                }, 120);
              };

              cfg.inputEl.onkeydown = function(evt){
                var key = evt.key || evt.keyCode;
                var filtered = null;
                var selectedIndex = -1;
                var chosenValue = '';
                if (key === 'Escape' || key === 27) {
                  if (isOpen()) {
                    if (evt && evt.preventDefault) evt.preventDefault();
                    if (evt && evt.stopPropagation) evt.stopPropagation();
                    closeList();
                  }
                  return;
                }
                if (key === 'ArrowDown' || key === 40 || key === 'ArrowUp' || key === 38) {
                  filtered = getFilteredOptions();
                  if (!filtered.length) return;
                  if (evt && evt.preventDefault) evt.preventDefault();
                  if (!isOpen()) setExpanded(cfg.comboEl, cfg.inputEl, cfg.listEl, true);
                  if (key === 'ArrowDown' || key === 40) activeIndex = activeIndex < filtered.length - 1 ? activeIndex + 1 : 0;
                  else activeIndex = activeIndex > 0 ? activeIndex - 1 : filtered.length - 1;
                  renderList(true);
                  return;
                }
                if (key === 'Enter' || key === 13) {
                  filtered = getFilteredOptions();
                  if (!isOpen() || !filtered.length) return;
                  if (evt && evt.preventDefault) evt.preventDefault();
                  if (evt && evt.stopPropagation) evt.stopPropagation();
                  if (activeIndex < 0 && !searchQuery) {
                    for (selectedIndex = 0; selectedIndex < filtered.length; selectedIndex++) {
                      if (String(filtered[selectedIndex]) === getSelectedValue()) {
                        activeIndex = selectedIndex;
                        break;
                      }
                    }
                  }
                  if (activeIndex < 0 && filtered.length === 1) activeIndex = 0;
                  if (activeIndex < 0 || activeIndex >= filtered.length) return;
                  chosenValue = filtered[activeIndex];
                  searchQuery = '';
                  activeIndex = -1;
                  if (cfg.onSelect) cfg.onSelect(chosenValue, { source: 'keyboard-enter' });
                  closeList();
                  if (cfg.onEnterAfterSelect) cfg.onEnterAfterSelect(chosenValue);
                }
              };

              cfg.listEl.onclick = function(evt){
                var target = evt.target || evt.srcElement;
                var value = '';
                while (target && target !== cfg.listEl && (!target.getAttribute || !target.getAttribute('data-psm-combobox-value'))) {
                  target = target.parentNode;
                }
                if (!target || target === cfg.listEl || !target.getAttribute) return;
                value = target.getAttribute('data-psm-combobox-value') || '';
                if (!value) return;
                searchQuery = '';
                activeIndex = -1;
                if (cfg.onSelect) cfg.onSelect(value, { source: 'click' });
                closeList();
              };

              cfg.listEl.onmousedown = function(evt){
                if (evt && evt.preventDefault) evt.preventDefault();
              };

              if (cfg.clearEl) {
                cfg.clearEl.onclick = function(evt){
                  if (evt && evt.preventDefault) evt.preventDefault();
                  if (evt && evt.stopPropagation) evt.stopPropagation();
                  clearValue();
                };
                cfg.clearEl.onmousedown = function(evt){
                  if (evt && evt.preventDefault) evt.preventDefault();
                };
              }

              syncFromSelection();
              return {
                close: closeList,
                open: openList,
                syncFromSelection: syncFromSelection
              };
            }

            function setModelEnabled(enabled, placeholderText){
              var isEnabled = !!enabled;
              modelEl.disabled = !isEnabled;
              toggleEl.disabled = !isEnabled;
              if (clearEl) clearEl.disabled = !isEnabled;
              modelEl.placeholder = placeholderText || 'Select model';
              if (isEnabled) comboEl.classList.remove('is-disabled');
              else comboEl.classList.add('is-disabled');
              syncClearButton(modelEl, clearEl);
              if (!isEnabled && modelCombobox) modelCombobox.close();
            }

            function setModelStatus(message, state){
              if (!modelStatusEl) return;
              modelStatusEl.textContent = message || '';
              modelStatusEl.className = 'psm-vehicle-model-status' + (state ? ' is-' + state : '');
              if (state === 'error') {
                modelStatusEl.innerHTML = '<span>We could not load vehicle models. Please try again.</span> <button type="button" class="psm-model-retry" data-psm-retry-models="true">Retry</button>';
              }
            }

            function updateVehicleModalAction(){
              var action = getVehicleModalNextAction(trimPropValue(yearValueEl.value));
              modal.okBtn.textContent = action.label;
              modal.okBtn.setAttribute('aria-label', action.ariaLabel);
            }

            function updateSubmitState(){
              var selectedModel = resolveAllowedVehicleModel(modelEl && modelEl.value);
              var primaryDisabled = isLoading || isModelLoading || vehicleModalState.modelLookupFailed || !trimPropValue(yearValueEl.value) || (modelOptions.length && !selectedModel);
              var primaryReason = '';
              if (isLoading || isModelLoading) primaryReason = 'Loading required vehicle choices';
              else if (vehicleModalState.modelLookupFailed) primaryReason = 'Vehicle models could not load. Retry to continue';
              else if (!trimPropValue(yearValueEl.value)) primaryReason = 'Select year to continue';
              else if (modelOptions.length && !selectedModel) primaryReason = 'Select a vehicle model to continue';
              if (modal.setPrimaryDisabled) {
                modal.setPrimaryDisabled(primaryDisabled, primaryReason);
              } else {
                modal.okBtn.disabled = primaryDisabled;
                modal.okBtn.setAttribute('aria-disabled', modal.okBtn.disabled ? 'true' : 'false');
              }
              updateVehicleModalAction();
            }

            function setYearValue(nextValue, skipLoad){
              var val = trimPropValue(nextValue);
              var prev = trimPropValue(yearValueEl.value);
              if (!val || !isAllowedYear(val)) {
                yearValueEl.value = '';
                if (yearCombobox) yearCombobox.syncFromSelection();
                else yearEl.value = '';
                if (prev && !skipLoad) loadModelsForYear('');
                updateSubmitState();
                return;
              }
              yearValueEl.value = val;
              if (yearCombobox) yearCombobox.syncFromSelection();
              else yearEl.value = val;
              if (prev !== val && !skipLoad) loadModelsForYear(val);
              else updateSubmitState();
            }

            function setModelValue(nextValue){
              modelEl.value = String(nextValue || '');
              if (modelCombobox) modelCombobox.syncFromSelection();
              updateSubmitState();
            }

            function loadModelsForYear(yearValue, preserveModel){
              var chosenYear = trimPropValue(yearValue);
              var savedModel = trimPropValue(modelEl.value);
              if (!isCurrentModalSession()) return;
              requestId++;
              modelOptions = [];
              vehicleModalState.modelOptions = [];
              vehicleModalState.modelLoading = false;
              vehicleModalState.modelLookupFailed = false;
              if (!preserveModel && chosenYear !== lastLoadedYear) setModelValue('');
              modal.renderError('');
              if (slowTimer) window.clearTimeout(slowTimer);
              if (!chosenYear) {
                isLoading = false;
                isModelLoading = false;
                setModelEnabled(false, 'Select model');
                setModelStatus('', '');
                updateSubmitState();
                return;
              }
              if (!vehicleLookup.make && !vehicleLookup.make_slug) {
                isLoading = false;
                isModelLoading = false;
                setModelEnabled(true, 'Select model');
                setModelStatus('Model is optional for this vehicle selection.', 'empty');
                updateSubmitState();
                return;
              }
              isLoading = false;
              isModelLoading = true;
              vehicleModalState.modelLoading = true;
              setModelEnabled(false, 'Loading models...');
              setModelStatus('Loading vehicle models...', 'loading');
              updateSubmitState();
              (function(localRequestId){
                slowTimer = window.setTimeout(function(){
                  if (!shouldApplyVehicleModelResponse(self, vehicleModalSession, modal.root, requestId, localRequestId) || !isModelLoading) return;
                  setModelStatus('Still loading vehicle models. You may continue without a model if it is optional.', 'slow');
                }, 1500);
                trackVehicleModalFunnel(self, 'vehicle_model_load_requested', { product_type: self._currentProductBase || '', outcome: 'requested', modal_required_fields: 'year' });
                fetchVehicleModelsForController(self, vehicleLookup, chosenYear, function(_err, models){
                  if (!shouldApplyVehicleModelResponse(self, vehicleModalSession, modal.root, requestId, localRequestId)) return;
                  if (slowTimer) window.clearTimeout(slowTimer);
                  modelOptions = models || [];
                  vehicleModalState.modelOptions = modelOptions.slice(0);
                  vehicleModalState.modelLoading = false;
                  vehicleModalState.modelLookupFailed = !!_err;
                  trackCustomColorFunnel('vehicle_models_loaded', { product_type: self._currentProductBase || '', outcome: _err ? 'failure' : 'success' });
                  if (_err) trackVehicleModalFunnel(self, 'vehicle_model_load_failed', { product_type: self._currentProductBase || '', outcome: 'failure', modal_required_fields: 'year', modal_block_reason: 'models_load_failed' });
                  else trackVehicleModalFunnel(self, 'vehicle_model_load_succeeded', { product_type: self._currentProductBase || '', outcome: 'success', modal_required_fields: 'year' });
                  if (!_err && !modelOptions.length) trackVehicleModalFunnel(self, 'vehicle_model_empty', { product_type: self._currentProductBase || '', outcome: 'empty', modal_required_fields: 'year' });
                  isLoading = false;
                  isModelLoading = false;
                  if (_err) {
                    setModelEnabled(true, 'Select model');
                    setModelStatus('', 'error');
                  } else if (!modelOptions.length) {
                    setModelEnabled(true, 'Model is optional');
                    setModelStatus('No applicable models were found for this year. You may continue without a model.', 'empty');
                  } else {
                    setModelEnabled(true, 'Select model (required)');
                    setModelStatus('Select a vehicle model to continue.', 'ready');
                  }
                  if (savedModel && resolveAllowedVehicleModel(savedModel)) setModelValue(resolveAllowedVehicleModel(savedModel));
                  lastLoadedYear = chosenYear;
                  updateSubmitState();
                });
              })(requestId);
            }

            if (modelStatusEl) {
              modelStatusEl.onclick = function(evt){
                var target = evt.target || evt.srcElement;
                if (!target || !target.getAttribute || target.getAttribute('data-psm-retry-models') !== 'true') return;
                if (!isCurrentModalSession()) return;
                if (evt && evt.preventDefault) evt.preventDefault();
                loadModelsForYear(trimPropValue(yearValueEl.value), true);
              };
            }

            yearCombobox = createVehicleCombobox({
              comboEl: yearComboEl,
              inputEl: yearEl,
              listEl: yearListEl,
              toggleEl: yearToggleEl,
              clearEl: yearClearEl,
              optionIdPrefix: 'psm-vehicle-year-option-',
              emptyText: 'No matching years found.',
              onOpen: function(){
                trackVehicleModalFunnel(self, 'vehicle_year_select_open', { product_type: self._currentProductBase || '', outcome: 'opened', modal_required_fields: 'year' });
              },
              getOptions: function(){ return yearOptions.slice(0); },
              getSelectedValue: function(){ return yearValueEl.value; },
              normalizeInput: function(rawValue){
                return String(rawValue || '').replace(/\D/g, '');
              },
              filterOption: function(optionValue, query){
                return String(optionValue).indexOf(query) === 0;
              },
              onSelect: function(value){
                trackVehicleModalFunnel(self, 'vehicle_year_selected', { product_type: self._currentProductBase || '', outcome: 'selected', modal_required_fields: 'year' });
                setYearValue(value, false);
              },
              onInput: function(nextQuery){
                if (!nextQuery) {
                  setYearValue('', false);
                  return { syncDisplay: true };
                }
                if (isAllowedYear(nextQuery)) {
                  setYearValue(nextQuery, false);
                  return { syncDisplay: true, close: true };
                }
                if (trimPropValue(yearValueEl.value)) loadModelsForYear('');
                yearValueEl.value = '';
                updateSubmitState();
                return {};
              },
              onClear: function(){
                setYearValue('', false);
              },
              onBlur: function(){
                if (!isAllowedYear(yearEl.value)) setYearValue('', false);
                return { syncDisplay: true };
              }
            });

            modelCombobox = createVehicleCombobox({
              comboEl: comboEl,
              inputEl: modelEl,
              listEl: listEl,
              toggleEl: toggleEl,
              clearEl: clearEl,
              optionIdPrefix: 'psm-vehicle-model-option-',
              emptyText: 'No matching models found.',
              getOptions: function(){ return modelOptions.slice(0); },
              getSelectedValue: function(){ return modelEl.value; },
              filterOption: function(optionValue, query){
                return String(optionValue).toLowerCase().indexOf(String(query || '').toLowerCase()) > -1;
              },
              onInput: function(nextQuery){
                var resolved = resolveAllowedVehicleModel(nextQuery);
                if (resolved && String(resolved).toLowerCase() === String(trimPropValue(nextQuery)).toLowerCase()) {
                  setModelValue(resolved);
                  return { syncDisplay: true, close: true };
                }
                updateSubmitState();
                return {};
              },
              onSelect: function(value){
                trackVehicleModalFunnel(self, 'vehicle_model_selected', { product_type: self._currentProductBase || '', outcome: 'selected', modal_required_fields: 'year' });
                setModelValue(value);
              },
              onClear: function(){
                setModelValue('');
              },
              onBlur: function(){
                updateSubmitState();
                return { syncDisplay: true };
              },
              onEnterAfterSelect: function(){
                if (modal.formEl.requestSubmit) modal.formEl.requestSubmit();
                else modal.okBtn.click();
              }
            });

            hasInitialYear = isAllowedYear(initialYear);
            if (!hasInitialYear && yearOptions.length === 1) {
              initialYear = String(yearOptions[0]);
              hasInitialYear = true;
            }
            if (!hasInitialYear) {
              yearValueEl.value = '';
              yearEl.value = '';
            } else {
              yearValueEl.value = initialYear;
              yearEl.value = initialYear;
            }
            setModelEnabled(false, 'Select model');
            syncClearButton(yearEl, yearClearEl);
            updateSubmitState();
            if (trimPropValue(yearValueEl.value)) loadModelsForYear(yearValueEl.value);
          }
        }).then(function(res){
          var chosenYear = '';
          var chosenModel = '';
          invalidateVehicleModalSession(self, vehicleModalSession);
          if (!res || !res.ok) {
            trackVehicleModalFunnel(self, 'vehicle_modal_closed', { product_type: self._currentProductBase || '', outcome: 'closed', modal_required_fields: 'year', modal_block_reason: 'modal_dismissed' });
            endVehicleModalFunnel(self);
            self._clearModalProductContext();
            if (options && typeof options.onCancel === 'function') options.onCancel();
            return;
          }
          chosenYear = res.data && res.data.year ? String(res.data.year) : '';
          chosenModel = res.data && res.data.model ? trimPropValue(res.data.model) : '';
          if (!chosenYear) {
            endVehicleModalFunnel(self);
            self._clearModalProductContext();
            if (options && typeof options.onCancel === 'function') options.onCancel();
            return;
          }
          chosenModel = resolveAllowedVehicleModel(chosenModel);
          if (vehicleModalState.modelLoading || vehicleModalState.modelLookupFailed || (vehicleModalState.modelOptions.length && !chosenModel)) {
            trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'year,model', modal_block_reason: vehicleModalState.modelLoading ? 'models_loading' : (vehicleModalState.modelLookupFailed ? 'models_load_failed' : 'missing_model') });
            setFormErrorMessage(self.atcForm, vehicleModalState.modelLookupFailed ? 'Vehicle models could not load. Please try again.' : (vehicleModalState.modelLoading ? 'Vehicle models are still loading. Please try again.' : 'Please select your vehicle model.'));
            endVehicleModalFunnel(self);
            self._clearModalProductContext();
            if (options && typeof options.onCancel === 'function') options.onCancel();
            return;
          }
          doneCb({
            year: chosenYear,
            model: chosenModel
          });
        });
      }
    },


    _openFactoryModal: function(doneCb, nextAction, onCancel, factoryOptionsOverride){
      var self = this;
      var opts = factoryOptionsOverride && factoryOptionsOverride.slice ? factoryOptionsOverride.slice(0) : ((this._factoryCodes && this._factoryCodes.length) ? this._factoryCodes.slice(0) : []);
      var action = nextAction || { label: 'Add to Cart', ariaLabel: 'Add selected paint product to cart' };
      var factoryModalAttempt = { opened: false };
      if (!opts.length) { doneCb(''); return; }

      var mkInput = document.querySelector('input[name="properties[Make]"]');
      var cc = readPsCc();
      var mk = (mkInput && mkInput.value) || cc.make || 'your car';
      var title = 'Select your ' + mk + '\'s factory code';

      // Prefer hydrated make slug, then ps_cc, then a simple make-name fallback.
      var ssr = (typeof window !== 'undefined' && window.PS_SSR && typeof window.PS_SSR === 'object') ? window.PS_SSR : null;
      var makeSlug = '';
      if (ssr && ssr.make_slug) {
        makeSlug = String(ssr.make_slug);
      } else if (cc && cc.make_slug) {
        makeSlug = String(cc.make_slug);
      } else {
        makeSlug = String(mk || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }
      var helpHref = '/touch-up-paint-codes/' + encodeURIComponent(makeSlug) + '.htm';
      var productContextHtml = this._getModalProductContextHtml();
      var factoryModalClass = 'ps-modal--vehicle-details ps-modal--factory-code' + (productContextHtml ? ' ps-modal--with-product-context' : '');

      var helpHtml =
        '<div class="psm-factory-copy">' +
          '<p>On many vehicles, the factory code is a letter or number next to or after the paint code.</p>' +
          '<p>Example: If the paint code looks like B-89P-3, the "-3" is the factory code and must be entered separately.</p>' +
          '<p>If no factory code is shown, use the 11th digit of your VIN as the factory code.</p>' +
          '<p><strong><a href="' + helpHref + '" target="_blank" title="How to find your ' + mk + ' factory code (opens in a new tab)">More about ' + mk + ' Factory Codes &gt;</a></strong></p>' +
        '</div>';
      var i = 0;
      var opt = null;
      var optValue = '';
      var factoryOptions = [];

      for (i = 0; i < opts.length; i++) {
        opt = opts[i];
        if (typeof opt === 'string') {
          optValue = String(opt);
        } else {
          optValue = opt && opt.value != null ? String(opt.value) : '';
        }
        if (optValue) factoryOptions.push(optValue);
      }

      if (PS.Modal && PS.Modal.open) {
        PS.Modal.open({
          title: title,
          okLabel: action.label,
          okAriaLabel: action.ariaLabel,
          hideCancel: true,
          modalClass: factoryModalClass,
          contentClass: 'psm-content psm-factory-code',
          contentHtml:
            helpHtml +
            '<div class="psm-factory-field">' +
              '<div class="psm-vehicle-combobox psm-vehicle-combobox--factory psm-vehicle-combobox--required" data-psm-combobox="factory_code">' +
                '<input type="hidden" name="factory_code" value="">' +
                '<input type="text" name="factory_code_display" value="" class="psm-input psm-vehicle-combobox-input psm-vehicle-combobox-input--required psm-factory-code-input" placeholder="Select Factory Code (Required)" autocomplete="off" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="psm-factory-code-list">' +
                '<button type="button" class="psm-vehicle-combobox-toggle" aria-label="Toggle factory code suggestions"></button>' +
                '<div id="psm-factory-code-list" class="psm-vehicle-model-list psm-factory-code-list" role="listbox" hidden></div>' +
              '</div>' +
            '</div>' +
            productContextHtml,
          focusSelector: 'input[name="factory_code_display"]',
          onPrimaryBlocked: function(){
            trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'factory_code', modal_block_reason: 'missing_factory_code' });
          },
          onValidate: function(data){
            var chosenValue = data.factory_code ? String(data.factory_code) : '';
            var resolvedValue = '';
            var blockReason = '';
            if (!chosenValue) {
              blockReason = 'missing_factory_code';
            } else {
              resolvedValue = resolveAllowedFactoryCode(chosenValue, factoryOptions);
              if (!resolvedValue) blockReason = 'invalid_selection';
            }
            if (blockReason) {
              trackVehicleModalFunnel(self, 'vehicle_continue_blocked', { product_type: self._currentProductBase || '', outcome: 'blocked', modal_required_fields: 'factory_code', modal_block_reason: blockReason });
              return { ok:false, message: blockReason === 'missing_factory_code' ? 'Please select a factory code or choose "No Factory Code"' : 'Please select a valid factory code' };
            }
            data.factory_code = resolvedValue;
            trackVehicleModalFunnel(self, 'vehicle_continue_clicked', { product_type: self._currentProductBase || '', outcome: 'clicked', modal_required_fields: 'factory_code' });
            return { ok:true };
          },
          onOpen: function(modal){
            if (!self._vehicleModalFunnelState) {
              beginVehicleModalFunnel(self, factoryModalAttempt, { product_type: self._currentProductBase || '', outcome: 'opened', modal_required_fields: 'factory_code' });
            }
            trackVehicleModalFunnel(self, 'vehicle_factory_code_shown', { product_type: self._currentProductBase || '', outcome: 'shown', modal_required_fields: 'factory_code' });
            var factoryValueEl = modal.formEl.querySelector('input[name="factory_code"]');
            var factoryEl = modal.formEl.querySelector('input[name="factory_code_display"]');
            var factoryComboEl = modal.formEl.querySelector('[data-psm-combobox="factory_code"]');
            var factoryClearEl = factoryComboEl ? factoryComboEl.querySelector('.psm-vehicle-combobox-clear') : null;
            var factoryToggleEl = factoryComboEl ? factoryComboEl.querySelector('.psm-vehicle-combobox-toggle') : null;
            var factoryListEl = modal.formEl.querySelector('#psm-factory-code-list');
            var factoryCombobox = null;

            function updateSubmitState(){
              var hasSelection = !!trimPropValue(factoryValueEl && factoryValueEl.value);
              if (factoryEl && factoryEl.classList) {
                if (hasSelection) factoryEl.classList.remove('psm-vehicle-combobox-input--required');
                else factoryEl.classList.add('psm-vehicle-combobox-input--required');
              }
              if (factoryComboEl && factoryComboEl.classList) {
                if (hasSelection) factoryComboEl.classList.remove('psm-vehicle-combobox--required');
                else factoryComboEl.classList.add('psm-vehicle-combobox--required');
              }
              if (modal.setPrimaryDisabled) {
                modal.setPrimaryDisabled(!hasSelection, 'Select factory code to continue');
              } else {
                modal.okBtn.disabled = false;
                modal.okBtn.setAttribute('aria-disabled', hasSelection ? 'false' : 'true');
              }
            }

            function setFactoryValue(nextValue){
              var val = trimPropValue(nextValue);
              var resolved = '';
              var idx = 0;
              if (val) {
                for (idx = 0; idx < factoryOptions.length; idx++) {
                  if (String(factoryOptions[idx]).toLowerCase() === val.toLowerCase()) {
                    resolved = String(factoryOptions[idx]);
                    break;
                  }
                }
              }
              factoryValueEl.value = resolved;
              if (factoryCombobox) factoryCombobox.syncFromSelection();
              else factoryEl.value = resolved;
              updateSubmitState();
            }

            factoryCombobox = createModalCombobox({
              comboEl: factoryComboEl,
              inputEl: factoryEl,
              listEl: factoryListEl,
              toggleEl: factoryToggleEl,
              clearEl: factoryClearEl,
              optionIdPrefix: 'psm-factory-code-option-',
              emptyText: 'No matching factory codes found.',
              getOptions: function(){ return factoryOptions.slice(0); },
              getSelectedValue: function(){ return factoryValueEl.value; },
              filterOption: function(optionValue, query){
                return String(optionValue).toLowerCase().indexOf(String(query || '').toLowerCase()) > -1;
              },
              onSelect: function(value){
                trackVehicleModalFunnel(self, 'vehicle_factory_code_selected', { product_type: self._currentProductBase || '', outcome: 'selected', modal_required_fields: 'factory_code' });
                setFactoryValue(value);
              },
              onClear: function(){
                setFactoryValue('');
              },
              onBlur: function(){
                return { syncDisplay: true };
              },
              onEnterAfterSelect: function(){
                if (modal.formEl.requestSubmit) modal.formEl.requestSubmit();
                else modal.okBtn.click();
              }
            });

            updateSubmitState();
          }
        }).then(function(res){
          if (!res || !res.ok) {
            trackVehicleModalFunnel(self, 'vehicle_modal_closed', { product_type: self._currentProductBase || '', outcome: 'closed', modal_required_fields: 'factory_code', modal_block_reason: 'modal_dismissed' });
            endVehicleModalFunnel(self);
            self._clearModalProductContext();
            if (typeof onCancel === 'function') onCancel();
            return;
          }
          var chosen = resolveAllowedFactoryCode(res.data && res.data.factory_code, factoryOptions);
          if (!chosen) {
            endVehicleModalFunnel(self);
            self._clearModalProductContext();
            if (typeof onCancel === 'function') onCancel();
            return;
          }
          doneCb(chosen);
        });
      } else {
        var v = window.prompt(title, '');
        var fallbackValue = resolveAllowedFactoryCode(v, factoryOptions);
        if (fallbackValue) doneCb(fallbackValue);
        else {
          endVehicleModalFunnel(self);
          self._clearModalProductContext();
          if (typeof onCancel === 'function') onCancel();
        }
      }
    },

    _openSingleStageModal: function(doneCb, onCancel){
      var self = this;
      var kitHasCc = this._kitHasClearcoat ? this._kitHasClearcoat() : false;
      var productContextHtml = this._getModalProductContextHtml();
      var singleStageModalClass = 'ps-modal--vehicle-details ps-modal--single-stage' + (productContextHtml ? ' ps-modal--with-product-context' : '');
      var noticeHtml = kitHasCc
        ? '<div id="ps-ss-cc-notice" class="psm-single-stage-notice" style="display:none;">' +
          'Note: Clearcoat is not needed for Single Stage paint and will be removed from your bundle.' +
          '</div>'
        : '';

      var bodyHtml =
        '<div class="psm-vehicle-copy psm-single-stage-copy">' +
          'Many vintage vehicles originally had pigment mixed directly into the clearcoat. ' +
          'Single Stage paint combines color and protection in one product &mdash; ' +
          'no separate clearcoat needed.' +
        '</div>' +
        '<div class="psm-single-stage-options">' +
          '<label class="psm-single-stage-option">' +
            '<input type="radio" name="paint_formula" value="single_stage" class="psm-single-stage-radio">' +
            ' Single Stage formula' +
          '</label>' +
          '<label class="psm-single-stage-option">' +
            '<input type="radio" name="paint_formula" value="basecoat_clearcoat" checked class="psm-single-stage-radio">' +
            ' Basecoat + Clearcoat' +
          '</label>' +
        '</div>' +
        noticeHtml +
        productContextHtml;

      if (PS.Modal && PS.Modal.open) {
        PS.Modal.open({
          title: 'This color may be available as a "Single Stage" paint formula',
          modalClass: singleStageModalClass,
          contentClass: 'psm-content psm-single-stage',
          contentHtml: bodyHtml,
          okLabel: 'Add to Cart',
          hideCancel: true
        }).then(function(res){
          if (!res || !res.ok) {
            self._clearModalProductContext();
            if (typeof onCancel === 'function') onCancel();
            return;
          }
          var choice = (res.data && res.data.paint_formula) ? res.data.paint_formula : 'basecoat_clearcoat';
          doneCb(choice);
        });

        // PS - Toggle clearcoat notice when radio selection changes
        if (kitHasCc) {
          var radios = document.querySelectorAll('#psm-form input[name="paint_formula"]');
          var notice = document.getElementById('ps-ss-cc-notice');
          if (notice && radios.length) {
            for (var i = 0; i < radios.length; i++) {
              radios[i].addEventListener('change', function() {
                notice.style.display = this.value === 'single_stage' ? 'block' : 'none';
              });
            }
          }
        }
      } else {
        self._clearModalProductContext();
        doneCb('basecoat_clearcoat');
      }
    },

    _bindYearGate: function(opts){
      var self=this;
      var skipAttach = !!(opts && opts.skipAttach);
      var yearRequiredMessage = '';
      if(!self.atcForm) return;

      var factoryOptions = self._factoryCodes && self._factoryCodes.length ? self._factoryCodes.slice(0) : [];

      function isAllowedYear(y){
        if (!y) return false;
        if (self._years && self._years.length) return self._years.indexOf(String(y)) !== -1;
        var yn = parseInt(String(y).replace(/\D/g,''),10);
        return yn && yn >= CONFIG.minYear;
      }

      function clearValidationMessage(){
        setFormErrorMessage(self.atcForm, '');
      }

      function showYearValidationMessage(){
        setFormErrorMessage(self.atcForm, '');
      }

      function hasValidCustomColorYear(formData){
        var props = serializeProperties(self.atcForm);
        var yearVal = trimPropValue(props['Year']);
        if (!isCustomColorLineItem(self.atcForm, formData, props)) {
          clearValidationMessage();
          return true;
        }
        if (!hasVehicleLineItemContext(props)) {
          showYearValidationMessage();
          return false;
        }
        if (yearVal && isAllowedYear(yearVal)) {
          clearValidationMessage();
          return true;
        }
        showYearValidationMessage();
        return false;
      }

      function isFactoryRequired(){
        return factoryOptions && factoryOptions.length > 0;
      }

      function requiresSingleStageFormula(yearValue){
        var cutoff = (window.paintscratchTheme && window.paintscratchTheme.psSingleStageYear) || 0;
        var selectedYear = parseInt(String(yearValue || ''), 10) || 0;
        return !!(cutoff && selectedYear && selectedYear < cutoff);
      }

      function finishAtcFlow(){
        releaseAtcFlow(self);
        if (self._repairPlanRequest && !self._repairPlanRequest.transportStarted) {
          cancelRepairPlanRequest(self, self.atcForm, 'Repair plan cancelled.');
        }
      }

      function isAllowedFactory(code){
        if (!isFactoryRequired()) return true;
        return !!resolveAllowedFactoryCode(code, factoryOptions);
      }

      function setYearHidden(y){
        var yEl = self.atcForm.querySelector('input[name="properties[Year]"]');
        if (!yEl) upsertHiddenProp(self.atcForm, 'Year', '');
        yEl = self.atcForm.querySelector('input[name="properties[Year]"]');
        if (yEl) yEl.value = String(y || '');
        try{
          var cc = readPsCc();
          cc.year = String(y || '');
          cc.vehicle_scope = true;
          writePsCc(cc);
          if (PS.cc && typeof PS.cc.setYear === 'function') {
            PS.cc.setYear(String(y || ''));
          }
        }catch(_e){}
      }

      function setModelHidden(model){
        var modelValue = trimPropValue(model);
        if (modelValue) {
          upsertHiddenProp(self.atcForm, 'Model', modelValue);
        } else {
          removeHiddenProp(self.atcForm, 'Model');
        }
        try{
          var cc = readPsCc();
          cc.model = modelValue;
          cc.vehicle_scope = true;
          writePsCc(cc);
        }catch(_e){}
      }

      function setFactoryHidden(code, consumeSearchTransition){
        var fEl = self.atcForm.querySelector('input[name="properties[' + FACTORY_PROP_KEY + ']"]');
        if (!fEl) upsertHiddenProp(self.atcForm, FACTORY_PROP_KEY, '');
        fEl = self.atcForm.querySelector('input[name="properties[' + FACTORY_PROP_KEY + ']"]');
        if (fEl) fEl.value = String(code || '');
        try{
          var cc = readPsCc();
          cc.factory_code = String(code || '');
          if (cc.year || cc.model) cc.vehicle_scope = true;
          if (consumeSearchTransition === true) cc.ps_from_search = false;
          writePsCc(cc);
        }catch(_e){}
      }

      function requireYearAndFactoryThenContinue(originalCb){
        var cc = readPsCc();
        var freshVehicleSearch = isFreshVehicleSearchContext(cc);
        var ssCutoff = (window.paintscratchTheme && window.paintscratchTheme.psSingleStageYear) || 0;

        // Wrap callback: conditionally show Single Stage modal before proceeding
        function cb(result) {
          var resolvedYear = (result && result.year) ? parseInt(String(result.year), 10) : 0;
          if (ssCutoff && resolvedYear && resolvedYear < ssCutoff) {
            trackCustomColorFunnel('formula_modal_open', { product_type: self._currentProductBase || '' });
            self._openSingleStageModal(function(choice) {
              trackCustomColorFunnel('formula_selected', { product_type: self._currentProductBase || '', formula_choice: choice || 'none' });
              if (choice === 'single_stage') {
                upsertHiddenProp(self.atcForm, 'Paint Formula', 'Single Stage');
              } else {
                var pfEl = self.atcForm.querySelector('input[name="properties[Paint Formula]"]');
                if (pfEl) pfEl.parentNode.removeChild(pfEl);
              }
              originalCb(result);
            }, finishAtcFlow);
          } else {
            var pfEl = self.atcForm.querySelector('input[name="properties[Paint Formula]"]');
            if (pfEl) pfEl.parentNode.removeChild(pfEl);
            originalCb(result);
          }
        }

        var yInput = self.atcForm && self.atcForm.querySelector('input[name="properties[Year]"]');
        var mInput = self.atcForm && self.atcForm.querySelector('input[name="properties[Model]"]');
        var fInput = self.atcForm && self.atcForm.querySelector('input[name="properties[' + FACTORY_PROP_KEY + ']"]');

        var yearVal = '';
        if (yInput && typeof yInput.value !== 'undefined') {
          yearVal = String(yInput.value || '');
        } else if (cc.year) {
          yearVal = String(cc.year || '');
        }

        var modelVal = '';
        var payloadModels = sanitizeModels((self._lastPayload && self._lastPayload.models) || []);
        var resolvedPayloadModel = '';
        var modelOutcome = null;
        if (mInput && typeof mInput.value !== 'undefined') {
          modelVal = String(mInput.value || '');
        } else if (cc.model) {
          modelVal = String(cc.model || '');
        }
        if (!modelVal) {
          modelVal = onlyAllModelsValue((self._lastPayload && self._lastPayload.models) || []);
        }

        var factoryVal = '';

        if (!freshVehicleSearch && fInput && typeof fInput.value !== 'undefined') {
          factoryVal = trimPropValue(fInput.value || '');
        }
        if (!freshVehicleSearch && !factoryVal) {
          factoryVal = resolveScopedCookieFactoryCode(cc, self._lastPayload || {}, factoryOptions);
        }

        function afterVehicleDetails(selection){
          var yResolved = selection && selection.year ? String(selection.year) : '';
          var chosenModel = selection && selection.model ? trimPropValue(selection.model) : '';
          var vehicleContext = null;
          var resolvedModels = null;
          vehicleContext = resolveVehicleLookupContext(self.atcForm, self._lastPayload || {});
          resolvedModels = readVehicleModelsForController(self, vehicleContext, yResolved);
          if (!chosenModel && resolvedModels !== null && !resolvedModels.length && self._lastPayload) {
            self._lastPayload.models = [];
          }
          setYearHidden(yResolved);
          setModelHidden(chosenModel);
          clearValidationMessage();

          if (!isFactoryRequired()){
            setFactoryHidden('', true);
            endVehicleModalFunnel(self);
            cb({ year: yResolved, model: chosenModel, factory_code: '' });
            return;
          }

          if (factoryVal && isAllowedFactory(factoryVal)) {
            factoryVal = resolveAllowedFactoryCode(factoryVal, factoryOptions);
            setFactoryHidden(factoryVal, true);
            endVehicleModalFunnel(self);
            cb({ year: yResolved, model: chosenModel, factory_code: factoryVal });
            return;
          }

          function openFactorySelection(){
            self._openFactoryModal(function(chosenFc){
              if (!chosenFc) return;
              if (!isAllowedFactory(chosenFc)){
                alert('Sorry, that factory code is not compatible for this color. Please select a valid factory code.');
                return;
              }
              factoryVal = resolveAllowedFactoryCode(chosenFc, factoryOptions);
              setFactoryHidden(factoryVal, true);
              endVehicleModalFunnel(self);
              cb({ year: yResolved, model: chosenModel, factory_code: factoryVal });
            }, requiresSingleStageFormula(yResolved) ? {
              label: 'Continue',
              ariaLabel: 'Continue to the paint formula selection'
            } : {
              label: 'Add to Cart',
              ariaLabel: 'Add selected paint product to cart'
            }, finishAtcFlow, factoryOptions);
          }

          vehicleContext.year = yResolved;
          vehicleContext.model = chosenModel;
          self.disable('Loading...');
          requestCartSnapshot(function(_err, cart){
            var reusableFactory = findReusableFactoryCodeFromCart(cart, vehicleContext, factoryOptions);
            self.enable();
            if (reusableFactory) {
              factoryVal = reusableFactory;
              setFactoryHidden(factoryVal, true);
              endVehicleModalFunnel(self);
              cb({ year: yResolved, model: chosenModel, factory_code: factoryVal });
              return;
            }
            openFactorySelection();
          });
        }

        function openVehicleDetailsPrompt(initialModalModel, shouldShowYearMessage){
          if (shouldShowYearMessage) showYearValidationMessage();
          setFactoryHidden('');
          self._openVehicleDetailsModal(function(selection){
            if (!selection || !selection.year) {
              endVehicleModalFunnel(self);
              return;
            }
            if (!isAllowedYear(selection.year)){
              showYearValidationMessage();
              alert('Sorry, that year is not compatible for this color. Please select a valid year.');
              endVehicleModalFunnel(self);
              return;
            }
            yearVal = String(selection.year || '');
            modelVal = trimPropValue(selection.model || '');
            trackVehicleModalFunnel(self, 'vehicle_modal_continue', { product_type: self._currentProductBase || '', outcome: 'continued' });
            afterVehicleDetails({
              year: yearVal,
              model: modelVal
            });
          }, {
            requiredMsg: yearRequiredMessage,
            initialYear: yearVal,
            initialModel: initialModalModel || '',
            factoryOptions: factoryOptions,
            onCancel: finishAtcFlow
          });
        }

        if (yearVal && isAllowedYear(yearVal)) {
          if (modelVal && payloadModels.length) {
            modelOutcome = resolveSavedVehicleModelOutcome(modelVal, payloadModels, null);
            resolvedPayloadModel = modelOutcome.model;
            if (resolveVehicleCheckoutStep({
              isCustom: true,
              yearValid: true,
              modelRequired: payloadModels.length > 0,
              modelValid: modelOutcome.step === 'valid'
            }) === 'vehicle') {
              openVehicleDetailsPrompt('', false);
              return;
            }
            afterVehicleDetails({
              year: yearVal,
              model: resolvedPayloadModel
            });
            return;
          }
          if (modelVal) {
            fetchVehicleModelsForController(self, resolveVehicleLookupContext(self.atcForm, self._lastPayload || {}), yearVal, function(_err, models){
              var savedModelOutcome = resolveSavedVehicleModelOutcome(modelVal, models || [], _err);
              if (savedModelOutcome.step === 'valid') {
                afterVehicleDetails({ year: yearVal, model: savedModelOutcome.model });
                return;
              }
              if (savedModelOutcome.step === 'optional') {
                afterVehicleDetails({ year: yearVal, model: '' });
                return;
              }
              openVehicleDetailsPrompt('', false);
            });
            return;
          }
          modelVal = onlyAllModelsValue(payloadModels);
          if (modelVal) {
            afterVehicleDetails({ year: yearVal, model: modelVal });
            return;
          }
          if (payloadModels.length) {
            if (canUseVehicleScope(cc, self._lastPayload || {}) && trimPropValue(cc && cc.year) === trimPropValue(yearVal)) {
              fetchVehicleModelsForController(self, resolveVehicleLookupContext(self.atcForm, self._lastPayload || {}), yearVal, function(_err, models){
                var scopedModelOutcome = resolveTrustedScopedVehicleModelOutcome(cc, self._lastPayload || {}, yearVal, models || [], _err);
                if (scopedModelOutcome.step === 'optional') {
                  afterVehicleDetails({ year: yearVal, model: '' });
                  return;
                }
                openVehicleDetailsPrompt('', false);
              });
              return;
            }
            openVehicleDetailsPrompt('', false);
            return;
          }
          fetchVehicleModelsForController(self, resolveVehicleLookupContext(self.atcForm, self._lastPayload || {}), yearVal, function(_err, models){
            var availableModels = sanitizeModels(models || []);
            if (!_err && !availableModels.length) {
              afterVehicleDetails({ year: yearVal, model: '' });
              return;
            }
            openVehicleDetailsPrompt('', false);
          });
          return;
        }

        openVehicleDetailsPrompt(modelVal, true);

      }

      function onAtc(evt){
        function continueAtc(){
          requireYearAndFactoryThenContinue(function(){
            var integrityResult;
            ensureSlugProps(self.atcForm, self._lastPayload || {});
            ensureBaseProps(self.atcForm, self._lastPayload || {});
            integrityResult = validateCustomColorIntegrity(self.atcForm, self._lastPayload || {});
            if (!integrityResult.ok) {
              stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, integrityResult);
              return;
            }
            if (!hasValidCustomColorYear(self._lastPayload || {})) {
              stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: 'invalid_year', properties: integrityResult.properties });
              return;
            }

            var mainItem=mainLineItemFromForm(self.atcForm, self._lastPayload || {});
            if(!mainItem){
              stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: 'missing_line_item', properties: integrityResult.properties });
              return;
            }

            var items=[ mainItem ];
            var quickAddModal = null;
            var repairPlan = self._repairPlanRequest && self._repairPlanRequest.form === self.atcForm ? self._repairPlanRequest : null;
            if (repairPlan && repairPlan.multiForm) {
              items = [];
              for (var repairFormIndex = 0; repairFormIndex < repairPlan.forms.length; repairFormIndex += 1) {
                var repairForm = repairPlan.forms[repairFormIndex];
                copyRepairPlanFormula(repairForm, self.atcForm);
                var repairProps = prepareRepairPlanColorForm(repairForm, self._lastPayload || {});
                var repairIntegrity = validateCustomColorIntegrity(repairForm, self._lastPayload || {}, repairProps);
                var repairLine = null;
                if (!repairIntegrity.ok || !hasValidRepairPlanColorYear(self._lastPayload || {}, repairIntegrity.properties)) {
                  stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: repairIntegrity.reason || 'invalid_year', properties: repairIntegrity.properties });
                  return;
                }
                if (isCatalyzedSprayOnly(repairProps['Color Name'] || '') && !isCatalyzedAllowedBase(getCurrentProductBase(self._lastPayload || {}, repairForm))) {
                  stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: 'catalyzed_spray_only', properties: repairProps });
                  return;
                }
                repairLine = mainLineItemFromForm(repairForm, self._lastPayload || {});
                if (!repairLine) {
                  stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: 'missing_line_item', properties: repairProps });
                  return;
                }
                items.push(repairLine);
              }
            }

            // PS - Inject Kit Extras
            var kitExtras = repairPlan ? repairPlanKitExtrasFromForm(self.atcForm) : (self._getKitExtras ? self._getKitExtras() : []);
            // PS - If Single Stage, remove clearcoat from bundle
            var pfEl = self.atcForm.querySelector('input[name="properties[Paint Formula]"]');
            if (pfEl && pfEl.value === 'Single Stage' && kitExtras.length > 0) {
              var ccVid = self._getClearcoatVariantId ? self._getClearcoatVariantId() : 0;
              if (ccVid) {
                var filtered = [];
                for (var k = 0; k < kitExtras.length; k++) {
                  if (kitExtras[k].id !== ccVid) filtered.push(kitExtras[k]);
                }
                kitExtras = filtered;
              }
            }
            if (kitExtras.length > 0) {
               items = items.concat(kitExtras);
            }
            if (repairPlan) {
              items = appendRepairPlanOrdinaryItems(items, repairPlan.ordinaryItems);
            }

            try {
              quickAddModal = self.atcForm && self.atcForm.closest ? self.atcForm.closest('quick-add-modal') : null;
            } catch (_e) {
              quickAddModal = null;
            }

            if (!claimCartRequest(self)) {
              if (repairPlan) {
                completeRepairPlanRequest(self, self.atcForm, new Error('A cart request is already in progress. Please wait for it to finish.'), null);
              }
              finishAtcFlow();
              return;
            }
            if (repairPlan) {
              repairPlan.transportStarted = true;
              setRepairPlanButtonBusy(repairPlan.button, true);
            } else {
              self.disable('Adding...');
            }
            var secId = currentSectionId(self.atcForm);
            addItemsAndRender(items, secId, function(err){
              releaseCartRequest(self);
              if (!repairPlan) self.enable();
              finishAtcFlow();
              if (repairPlan) {
                repairPlan.transportStarted = false;
                if (err) {
                  self._clearModalProductContext();
                  if (err.psIntegrityFailure) {
                    stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: err.psIntegrityReason || 'identity_unavailable' });
                    return;
                  }
                  markRepairPlanTransportError(err);
                  setFormErrorMessage(self.atcForm, err.message || 'Unable to add this item to your cart. Please try again.');
                  completeRepairPlanRequest(self, self.atcForm, err, null);
                  return;
                }
                self._clearModalProductContext();
                completeRepairPlanRequest(self, self.atcForm, null, { items: items });
                return;
              }
              if (err){
                self._clearModalProductContext();
                if (err.psIntegrityFailure) {
                  stopCustomColorIntegrityFailure(self, self.atcForm, self._lastPayload || {}, { reason: err.psIntegrityReason || 'identity_unavailable' });
                  return;
                }
                if (!attemptNativeCartFallback(self.atcForm, self._lastPayload || {}, err)) {
                  setFormErrorMessage(self.atcForm, err.message || 'Unable to add this item to your cart. Please try again.');
                  return;
                }
              } else {
                self._clearModalProductContext();
              }
            }, {
              quickAddModal: quickAddModal,
              requireCompleteItems: !!repairPlan,
              integrityForm: self.atcForm,
              integrityData: self._lastPayload || {},
              beforeSend: repairPlan && repairPlan.beforeSend
            });
          });
        }

        if (!isCustomColorLineItem(self.atcForm, self._lastPayload || {}, serializeProperties(self.atcForm))) {
          if (self._repairPlanRequest && self._repairPlanRequest.form === self.atcForm) {
            completeRepairPlanRequest(self, self.atcForm, new Error('Please choose a color-specific paint kit before adding this repair plan.'), null);
          }
          return true;
        }
        if (self.isCatalyzedSprayOnlyBlocked()) {
          self.applyCatalyzedSprayOnlyGuard(self._lastPayload || {});
          if (self._repairPlanRequest && self._repairPlanRequest.form === self.atcForm) {
            completeRepairPlanRequest(self, self.atcForm, new Error('This color is available only as a catalyzed spray can.'), null);
          }
          return false;
        }
        if(evt && evt.preventDefault) evt.preventDefault();
        if(evt && evt.stopImmediatePropagation) evt.stopImmediatePropagation();
        if(evt && evt.stopPropagation) evt.stopPropagation();
        if (!claimAtcFlow(self)) {
          if (self._repairPlanRequest && self._repairPlanRequest.form === self.atcForm) {
            completeRepairPlanRequest(self, self.atcForm, new Error('A cart request is already in progress. Please wait for it to finish.'), null);
          }
          return false;
        }
        trackCustomColorFunnel('atc_click', { product_type: self._currentProductBase || '' });
        self._captureModalProductContext(self.atcForm, self.atcBtn);

        if (shouldRefreshColorContext(self.atcForm, self._lastPayload || {})) {
          self.disable('Loading...');
          fetchColorContextFromCookie(function(_err, fetchedPayload){
            var nextPayload = self._lastPayload || {};
            if (_err) {
              stopCustomColorIntegrityFailure(self, self.atcForm, nextPayload || {}, { reason: _err.psColorContextReason || 'color_context_unavailable', properties: serializeProperties(self.atcForm) });
              return;
            }
            if (fetchedPayload) nextPayload = mergePayload(nextPayload, fetchedPayload);
            syncControllerPayload(self, nextPayload || {});
            self.enable();
            continueAtc();
          });
          return false;
        }

        continueAtc();
      }

      self._onAtcHandler = onAtc;
      if (skipAttach) return;
      self.atcForm.addEventListener('submit', onAtc, true);
      if(self.atcBtn && self.atcBtn.addEventListener){
        self.atcBtn.addEventListener('click', onAtc, true);
      }
    },

    invokeAddToCart: function(form, btn, evt){
      var self = this;
      var payload = null;
      if (!form) return false;

      this.atcForm = form;
      if (btn) this.atcBtn = btn;

      payload = mergePayload(
        mergePayload(
          ((typeof window !== 'undefined' && window.PS_SSR && typeof window.PS_SSR === 'object') ? window.PS_SSR : {}) || {},
          ((PS.ssr && PS.ssr()) || {}) || {}
        ),
        this._lastPayload || {}
      );

      function bindFromPayload(nextPayload){
        syncControllerPayload(self, nextPayload || {});
        self._bindYearGate({ skipAttach: true });
      }

      if (shouldRefreshColorContext(form, payload || {})) {
        this.disable('Loading...');
        fetchColorContextFromCookie(function(_err, fetchedPayload){
          var nextPayload = payload;
          if (_err) {
            stopCustomColorIntegrityFailure(self, form, nextPayload || {}, { reason: _err.psColorContextReason || 'color_context_unavailable', properties: serializeProperties(form) });
            return;
          }
          if (fetchedPayload) nextPayload = mergePayload(payload || {}, fetchedPayload);
          bindFromPayload(nextPayload || {});
          self.enable();
          if (typeof self._onAtcHandler !== 'function') {
            if (isCustomColorLineItem(form, nextPayload || {}, serializeProperties(form))) {
              stopCustomColorIntegrityFailure(self, form, nextPayload || {}, { reason: 'handler_unavailable', properties: serializeProperties(form) });
              setFormErrorMessage(form, 'Custom-color Add to Cart is still loading. Please try again.');
              return;
            }
            if (self._repairPlanRequest && self._repairPlanRequest.form === form) {
              completeRepairPlanRequest(self, form, new Error('The repair plan could not start. Please try again.'), null);
              return;
            }
            form.submit();
            return;
          }
          self._onAtcHandler(evt || null);
        });
        return true;
      }

      bindFromPayload(payload || {});

      if (typeof this._onAtcHandler !== 'function') {
        if (isCustomColorLineItem(form, payload || {}, serializeProperties(form))) {
          stopCustomColorIntegrityFailure(this, form, payload || {}, { reason: 'handler_unavailable', properties: serializeProperties(form) });
          setFormErrorMessage(form, 'Custom-color Add to Cart is still loading. Please try again.');
        }
        return false;
      }
      this._onAtcHandler(evt || null);
      return true;
    },

    /*
     * Add the selected color-specific repair kit and ordinary accessory variants
     * in one managed cart request. The form must be the selected kit's own custom
     * color form; pass null for accessories-only. Ordinary items intentionally
     * contain only Shopify variant ids and quantities, never paint properties.
     */
    addRepairPlanItems: function(customColorForms, ordinaryItems, button, done, beforeSend){
      var self = this;
      var forms = customColorForms && typeof customColorForms.length === 'number' ? Array.prototype.slice.call(customColorForms) : [];
      var ordinary = normalizeRepairPlanOrdinaryItems(ordinaryItems);
      var request = null;
      var i = 0;
      var form = null;
      var formButton = null;
      var props = null;

      function failImmediately(message){
        var error = new Error(message);
        try { if (typeof done === 'function') done(error, null); } catch (_eDone) {}
        return false;
      }

      if (!Array.isArray(customColorForms) || !Array.isArray(ordinaryItems)) {
        return failImmediately('Some selected products are invalid. Please reload the plan before adding.');
      }
      if (ordinaryItems.length !== ordinary.length) {
        return failImmediately('Some selected products or quantities are invalid. Please reload the plan before adding.');
      }
      if (!forms.length) return this._addRepairPlanSingle(null, ordinary, button, done, beforeSend);
      if (forms.length === 1) return this._addRepairPlanSingle(forms[0], ordinary, button, done, beforeSend);
      if (this._repairPlanInFlight || this._repairPlanRequest) {
        return failImmediately('A repair plan is already being added. Please wait for it to finish.');
      }
      if (this._atcFlowInFlight || this._cartRequestInFlight) {
        return failImmediately('Another cart action is in progress. Finish it before adding this plan.');
      }

      for (i = 0; i < forms.length; i += 1) {
        form = forms[i];
        if (!form || !form.querySelector || !form.querySelector('input[name="id"]')) {
          return failImmediately('A selected color-specific paint product is unavailable. Please choose it again.');
        }
        props = prepareRepairPlanColorForm(form, this._lastPayload || {});
        if (!isCustomColorLineItem(form, this._lastPayload || {}, props)) {
          return failImmediately('A selected color-specific paint product could not be confirmed. Please choose it again.');
        }
        if (isCatalyzedSprayOnly((props['Color Name'] || (this._lastPayload || {}).color || '')) && !isCatalyzedAllowedBase(getCurrentProductBase(this._lastPayload || {}, form))) {
          return failImmediately('This color is available only as a catalyzed spray can.');
        }
      }
      if (!button && forms[0].querySelector) {
        formButton = forms[0].querySelector('[type="submit"], .product-form__submit');
      }
      request = {
        form: forms[0],
        forms: forms,
        multiForm: true,
        ordinaryItems: ordinary,
        button: button || formButton || null,
        done: done,
        beforeSend: typeof beforeSend === 'function' ? beforeSend : null,
        originalForm: this.atcForm || null,
        originalBtn: this.atcBtn || null,
        originalPayload: this._lastPayload || null,
        originalProductBase: this._currentProductBase,
        originalCatalyzedOnly: this._isCatalyzedOnly,
        originalSprayProduct: this._isSprayProduct,
        transportStarted: false,
        completed: false
      };
      this._repairPlanRequest = request;
      this._repairPlanInFlight = true;
      setRepairPlanButtonBusy(request.button, true);
      if (!this.invokeAddToCart(forms[0], request.button, null)) {
        completeRepairPlanRequest(this, forms[0], new Error('The repair plan could not start. Please try again.'), null);
        return false;
      }
      return true;
    },

    _addRepairPlanSingle: function(form, ordinaryItems, button, done, beforeSend){
      var self = this;
      var ordinary = normalizeRepairPlanOrdinaryItems(ordinaryItems);
      var request = null;
      var started = false;
      var payload = null;
      var error = null;
      var formButton = null;

      function failImmediately(message){
        error = new Error(message);
        try { if (typeof done === 'function') done(error, null); } catch (_eDone) {}
        return false;
      }

      if (this._repairPlanInFlight || this._repairPlanRequest) {
        return failImmediately('A repair plan is already being added. Please wait for it to finish.');
      }
      if (this._atcFlowInFlight || this._cartRequestInFlight) {
        return failImmediately('Another cart action is in progress. Finish it before adding this plan.');
      }
      if (!Array.isArray(ordinaryItems) || ordinaryItems.length !== ordinary.length) {
        return failImmediately('Some selected products or quantities are invalid. Please reload the plan before adding.');
      }
      if (!form && !ordinary.length) {
        return failImmediately('Choose at least one product to add to your cart.');
      }
      if (form && !button && form.querySelector) {
        formButton = form.querySelector('[type="submit"], .product-form__submit');
      }

      request = {
        form: form || null,
        ordinaryItems: ordinary,
        button: button || formButton || null,
        done: done,
        beforeSend: typeof beforeSend === 'function' ? beforeSend : null,
        originalForm: this.atcForm || null,
        originalBtn: this.atcBtn || null,
        originalPayload: this._lastPayload || null,
        originalProductBase: this._currentProductBase,
        originalCatalyzedOnly: this._isCatalyzedOnly,
        originalSprayProduct: this._isSprayProduct,
        transportStarted: false,
        completed: false
      };
      this._repairPlanRequest = request;
      this._repairPlanInFlight = true;
      setRepairPlanButtonBusy(request.button, true);

      if (!form) {
        if (!claimCartRequest(this)) {
          completeRepairPlanRequest(this, null, new Error('A cart request is already in progress. Please wait for it to finish.'), null);
          return false;
        }
        request.transportStarted = true;
        addItemsAndRender(ordinary, '', function(err, result){
          releaseCartRequest(self);
          request.transportStarted = false;
          if (err) markRepairPlanTransportError(err);
          completeRepairPlanRequest(self, null, err || null, result || { items: ordinary });
        }, { requireCompleteItems: true, beforeSend: request.beforeSend });
        return true;
      }

      if (!form.querySelector || !form.querySelector('input[name="id"]')) {
        completeRepairPlanRequest(this, form, new Error('The selected paint kit is unavailable. Please choose it again.'), null);
        return false;
      }

      payload = mergePayload(
        mergePayload(
          ((typeof window !== 'undefined' && window.PS_SSR && typeof window.PS_SSR === 'object') ? window.PS_SSR : {}) || {},
          ((PS.ssr && PS.ssr()) || {}) || {}
        ),
        this._lastPayload || {}
      );
      if (!isCustomColorLineItem(form, payload, serializeProperties(form))) {
        completeRepairPlanRequest(this, form, new Error('Please choose a color-specific paint kit before adding this repair plan.'), null);
        return false;
      }

      started = this.invokeAddToCart(form, request.button, null);
      if (!started && this._repairPlanRequest === request) {
        completeRepairPlanRequest(this, form, new Error('The repair plan could not start. Please try again.'), null);
      }
      return !!started;
    },

    /* Backward-compatible single-form entry point for existing callers. */
    addRepairPlan: function(form, ordinaryItems, button, done){
      return this.addRepairPlanItems(form ? [form] : [], ordinaryItems, button, done);
    },

    // Clearcoat UI helpers
    hideAllCollections: function(){
      if (!this._collectionPairs.length) this._collectionPairs = findCollectionPairs();
      for (var i = 0; i < this._collectionPairs.length; i++){
        setHidden(this._collectionPairs[i].el, true);
      }
    },

toggleCollectionsByFlag: function(isTricoat){
      if (!this._collectionPairs.length) this._collectionPairs = findCollectionPairs();
      var want = isTricoat ? 'tricoat' : 'basecoat';
      for (var i = 0; i < this._collectionPairs.length; i++){
        var p = this._collectionPairs[i];
        setHidden(p.el, p.type !== want);
      }
    },

    disable: function(label){
      var showLoading = false;
      if (this.isCatalyzedSprayOnlyBlocked()) {
        label = label || 'Spray Can Only';
      }
      var b = this.atcBtn; if (!b) return;
      showLoading = String(label || '').toLowerCase() === 'adding...';
      b.disabled = true;
      if (showLoading) b.classList.add('loading');
      var span = b.querySelector('span');
      var spinner = b.querySelector('.loading__spinner');
      if (!b.dataset.originalText) {
        b.dataset.originalText = span ? (span.textContent || 'Add to cart') : (b.textContent || 'Add to cart');
      }
      if (label) { if (span) span.textContent = label; else b.textContent = label; }
      if (spinner) {
        if (showLoading) spinner.classList.remove('hidden');
        else spinner.classList.add('hidden');
      }
      b.setAttribute('aria-disabled','true');
    },

    enable: function(){
      if (this.isCatalyzedSprayOnlyBlocked()) return;
      var b = this.atcBtn; if (!b) return;
      var orig = b.dataset.originalText || 'Add to cart';
      var span = b.querySelector('span');
      var spinner = b.querySelector('.loading__spinner');
      if (span) span.textContent = orig; else b.textContent = orig;
      b.classList.remove('loading');
      b.disabled = false;
      if (spinner) spinner.classList.add('hidden');
      b.setAttribute('aria-disabled','false');
    },

    isCatalyzedSprayOnlyBlocked: function(){
      if (!this._isCatalyzedOnly) return false;
      if (this._currentProductBase) return !isCatalyzedAllowedBase(this._currentProductBase);
      return isColorProductRoute();
    },

    applyCatalyzedSprayOnlyGuard: function(payload){
      var p = payload || this._lastPayload || {};
      var colorName = p.color || '';
      var form = this.atcForm;
      var btn = this.atcBtn;
      var base = getCurrentProductBase(p, form);
      this._isCatalyzedOnly = isCatalyzedSprayOnly(colorName);
      this._currentProductBase = base;
      this._isSprayProduct = base === 'spray';

      if (!form || !btn) return;

      var note = form.querySelector('[data-ps-catalyzed-note="1"]');
      var blocked = this.isCatalyzedSprayOnlyBlocked();
      var dpb = findDynamicCheckoutNearForm(form);

      if (!blocked) {
        if (note && note.parentNode) note.parentNode.removeChild(note);
        btn.removeAttribute('data-ps-catalyzed-blocked');
        if (dpb) dpb.style.display = '';
        return;
      }

      this.disable('Spray Can Only');
      btn.setAttribute('data-ps-catalyzed-blocked', '1');
      if (dpb) dpb.style.display = 'none';

      if (!note) {
        note = document.createElement('div');
        note.setAttribute('data-ps-catalyzed-note', '1');
        note.setAttribute('style', 'margin-top:12px;padding:10px;border:1px solid #d9c27a;background:#fff8e5;color:#2a2a2a;font-size:14px;line-height:1.4;');
      }

      var sprayHref = buildSprayOnlyUrl(p);
      note.innerHTML = 'This selected color is available only as a Spray Can. <a href="' + sprayHref + '">Go to Spray Can product</a>.';
      if (btn.parentNode && note.parentNode !== btn.parentNode) {
        btn.parentNode.appendChild(note);
      }
    }
  };

  function bindPdpColorContextListener(){
    if (!document || !document.addEventListener) return;
    if (!PS || !PS.PDP || PS.PDP._colorContextListenerBound) return;
    document.addEventListener('ps:color:validated', function(ev){
      var d = ev && ev.detail ? ev.detail : {};
      if (PS && PS.PDP && typeof PS.PDP.rememberColorContext === 'function') {
        PS.PDP.rememberColorContext(d);
      }
    });
    PS.PDP._colorContextListenerBound = true;
  }

  function shouldAutoInitPdp(){
    try {
      var path = (window.location && window.location.pathname) ? String(window.location.pathname) : '';
      if (/^\/products\//.test(path)) return true;
    } catch (_e) {}
    return false;
  }

  // Auto init the PDP controller once the DOM is ready so the year gate and cart wiring are active.
  if (document && document.addEventListener) {
    try {
      bindPdpColorContextListener();
    } catch (_e) {}
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){
        try {
          normalizeLegacyColorFocusHeadings();
        } catch (_eNormalize) {}
        try {
          if (PS && PS.PDP && !PS.PDP._bound && shouldAutoInitPdp()) {
            PS.PDP.init();
          }
        } catch (_e) {}
      });
    } else {
      try {
        normalizeLegacyColorFocusHeadings();
      } catch (_eNormalizeReady) {}
      try {
        if (PS && PS.PDP && !PS.PDP._bound && shouldAutoInitPdp()) {
          PS.PDP.init();
        }
      } catch (_e) {}
    }
  }

})(window, document);
